webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	__webpack_require__(1);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _routes = __webpack_require__(174);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _api = __webpack_require__(826);
	
	var _reactRedux = __webpack_require__(268);
	
	var _reduxActions = __webpack_require__(299);
	
	var _configureStore = __webpack_require__(955);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _reactRouter = __webpack_require__(180);
	
	var _localStorage = __webpack_require__(954);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = (0, _configureStore2.default)();
	
	var token = (0, _localStorage.getItem)('wideeyes-token');
	if (token) {
	  (0, _api.getUser)(token).then(function (res) {
	    store.dispatch((0, _reduxActions.createAction)('GET_USER_COMPLETED')(_extends({}, res, { token: token })));
	    main();
	  }).catch(function () {
	    (0, _localStorage.deleteItem)('wideeyes-token');
	    main();
	  });
	} else {
	  main();
	}
	
	function main() {
	  _reactDom2.default.render(_react2.default.createElement(
	    _reactRedux.Provider,
	    { store: store },
	    _react2.default.createElement(_reactRouter.Router, { history: _reactRouter.browserHistory, routes: _routes2.default })
	  ), document.getElementById('root'));
	}

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _App = __webpack_require__(175);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _auth = __webpack_require__(306);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  childRoutes: [{
	    path: '/',
	    component: (0, _auth.isUserAuthenticated)(_App2.default),
	    indexRoute: {
	      getComponent: function getComponent(partialNextState, cb) {
	        __webpack_require__.e/* nsure */(1, function (require) {
	          cb(null, __webpack_require__(313));
	        });
	      }
	    }
	  }, {
	    path: '/login',
	    getComponent: function getComponent(partialNextState, cb) {
	      __webpack_require__.e/* nsure */(2, function (require) {
	        cb(null, __webpack_require__(319));
	      });
	    }
	  }, {
	    path: '/results/:jobId/:env/:apikey/:toJobId/:fromJobId',
	    getComponent: function getComponent(partialNextState, cb) {
	      __webpack_require__.e/* nsure */(3, function (require) {
	        cb(null, __webpack_require__(324));
	      });
	    }
	  }]
	};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _App = __webpack_require__(176);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _reactRedux = __webpack_require__(268);
	
	var _app = __webpack_require__(298);
	
	var appActions = _interopRequireWildcard(_app);
	
	var _user = __webpack_require__(305);
	
	var userActions = _interopRequireWildcard(_user);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.user,
	    loading: state.app.loading
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    logout: function logout() {
	      return dispatch(userActions.logout());
	    },
	    toggleLoading: function toggleLoading() {
	      return dispatch(appActions.toggleLoading());
	    }
	  };
	};
	
	var AppContainer = function (_Component) {
	  _inherits(AppContainer, _Component);
	
	  function AppContainer() {
	    _classCallCheck(this, AppContainer);
	
	    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
	  }
	
	  _createClass(AppContainer, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        user: this.props.user,
	        logout: this.props.logout,
	        loading: this.props.loading,
	        location: this.props.location,
	        toggleLoading: this.props.toggleLoading
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_App2.default, { children: this.props.children });
	    }
	  }]);
	
	  return AppContainer;
	}(_react.Component);
	
	AppContainer.childContextTypes = {
	  logout: _react.PropTypes.func.isRequired,
	  user: _react.PropTypes.object.isRequired,
	  loading: _react.PropTypes.bool.isRequired,
	  location: _react.PropTypes.object.isRequired,
	  toggleLoading: _react.PropTypes.func.isRequired
	};
	AppContainer.contextTypes = {
	  router: _react.PropTypes.object.isRequired
	};
	AppContainer.propTypes = {
	  logout: _react.PropTypes.func.isRequired,
	  user: _react.PropTypes.object.isRequired,
	  loading: _react.PropTypes.bool.isRequired,
	  location: _react.PropTypes.object.isRequired,
	  toggleLoading: _react.PropTypes.func.isRequired
	};
	
	
	module.exports = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AppContainer);

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Header = __webpack_require__(177);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LoadingIndicator = __webpack_require__(243);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _constants = __webpack_require__(267);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var App = function App(_ref, _ref2) {
	  var children = _ref.children;
	  var logout = _ref2.logout,
	      loading = _ref2.loading,
	      user = _ref2.user;
	
	  if (user.authenticating) return null;
	
	  return _react2.default.createElement(
	    'section',
	    { className: 'container' },
	    _react2.default.createElement(
	      'section',
	      { className: 'row' },
	      _react2.default.createElement(_Header2.default, { logout: logout })
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'row' },
	      _react2.default.createElement(
	        'section',
	        { className: 'col-xs-1-1' },
	        loading ? _react2.default.createElement(_LoadingIndicator2.default, null) : '',
	        children
	      )
	    ),
	    _react2.default.createElement(
	      'footer',
	      { className: 'row', style: { margin: '2rem 0 1rem' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-xs-1-1' },
	        _react2.default.createElement(
	          'small',
	          null,
	          'Made with ',
	          _react2.default.createElement('i', { className: 'fa fa-heart' }),
	          ' by ',
	          _react2.default.createElement(
	            'a',
	            { href: 'http://wide-eyes.it' },
	            'Wide Eyes'
	          ),
	          ' ',
	          _constants.version,
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: '/changelog' },
	            ' changelog'
	          )
	        )
	      )
	    )
	  );
	};
	
	App.propTypes = {
	  children: _react.PropTypes.element
	};
	
	App.contextTypes = {
	  user: _react.PropTypes.object.isRequired,
	  logout: _react.PropTypes.func.isRequired,
	  loading: _react.PropTypes.bool.isRequired
	};
	
	module.exports = App;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _styles = __webpack_require__(178);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(180);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var s = {
	  list: { listStyle: 'none' },
	  root: { paddingTop: '1rem', paddingBottom: '1rem', marginBottom: '1rem' }
	}; // import {Link} from 'react-router'
	// import { Button } from 'wideeyes-ui'
	
	
	var Header = function Header(_ref, _ref2) {
	  var logout = _ref.logout;
	  var router = _ref2.router,
	      location = _ref2.location;
	  return _react2.default.createElement(
	    'header',
	    { className: 'col-xs-1-1', style: s.root },
	    _react2.default.createElement(
	      'div',
	      { className: 'row space-between v-center', style: s.root },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-xs' },
	        _react2.default.createElement('img', {
	          style: {
	            maxWidth: 200,
	            verticalAlign: 'middle',
	            display: 'inline-block'
	          },
	          src: 'https://s3-eu-west-1.amazonaws.com/wideeyes-assets/images/we_logo.png'
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-xs' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row v-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs' },
	            _react2.default.createElement(
	              _reactRouter.IndexLink,
	              {
	                to: '/',
	                className: _styles2.default.link,
	                activeClassName: _styles2.default.active
	              },
	              'Home'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('div', { className: 'separator' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: '/login',
	                className: _styles2.default.logout,
	                activeClassName: _styles2.default.active,
	                onClick: function onClick(e) {
	                  e.preventDefault();
	                  logout();
	                }
	              },
	              _react2.default.createElement(
	                'span',
	                { style: { fontSize: '1rem' } },
	                'Logout ',
	                _react2.default.createElement('i', { className: 'fa fa-sign-out' })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	Header.propTypes = {
	  logout: _react.PropTypes.func.isRequired
	};
	
	Header.contextTypes = {
	  router: _react.PropTypes.object.isRequired,
	  location: _react.PropTypes.object.isRequired
	};
	
	module.exports = Header;

/***/ }),
/* 178 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"link":"_3Qqthw9YkYjoyfxWN69hT8","active":"_1HhDGC4C_GyXisDEGJhKiw","logout":"kG51w3BNGKNtJmM5pKTXS"};

/***/ }),
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _halogen = __webpack_require__(244);
	
	var _halogen2 = _interopRequireDefault(_halogen);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoadingIndicator = function (_React$Component) {
	  _inherits(LoadingIndicator, _React$Component);
	
	  function LoadingIndicator() {
	    _classCallCheck(this, LoadingIndicator);
	
	    return _possibleConstructorReturn(this, (LoadingIndicator.__proto__ || Object.getPrototypeOf(LoadingIndicator)).call(this));
	  }
	
	  _createClass(LoadingIndicator, [{
	    key: 'render',
	    value: function render() {
	      var _style, _containerStyles;
	
	      var _props = this.props,
	          loader = _props.loader,
	          size = _props.size;
	
	
	      var color = '#206281';
	
	      var style = (_style = {
	        display: '-webkit-flex'
	      }, _defineProperty(_style, 'display', 'flex'), _defineProperty(_style, 'WebkitFlex', '0 1 auto'), _defineProperty(_style, 'flex', '0 1 auto'), _defineProperty(_style, 'WebkitFlexDirection', 'column'), _defineProperty(_style, 'flexDirection', 'column'), _defineProperty(_style, 'WebkitFlexGrow', 1), _defineProperty(_style, 'flexGrow', 1), _defineProperty(_style, 'WebkitFlexShrink', 0), _defineProperty(_style, 'flexShrink', 0), _defineProperty(_style, 'WebkitFlexBasis', '100%'), _defineProperty(_style, 'flexBasis', '100%'), _defineProperty(_style, 'maxWidth', '100%'), _defineProperty(_style, 'height', size || '200px'), _defineProperty(_style, 'WebkitAlignItems', 'center'), _defineProperty(_style, 'alignItems', 'center'), _defineProperty(_style, 'WebkitJustifyContent', 'center'), _defineProperty(_style, 'justifyContent', 'center'), _style);
	
	      var containerStyles = (_containerStyles = {
	        boxSizing: 'border-box',
	        display: '-webkit-flex'
	      }, _defineProperty(_containerStyles, 'display', 'flex'), _defineProperty(_containerStyles, 'WebkitFlex', '0 1 auto'), _defineProperty(_containerStyles, 'flex', '0 1 auto'), _defineProperty(_containerStyles, 'WebkitFlexDirection', 'row'), _defineProperty(_containerStyles, 'flexDirection', 'row'), _defineProperty(_containerStyles, 'WebkitFlexWrap', 'wrap'), _defineProperty(_containerStyles, 'flexWrap', 'wrap'), _containerStyles);
	
	      var Hloader = _halogen2.default[loader || 'ClipLoader'];
	
	      return _react2.default.createElement(
	        'div',
	        { style: containerStyles },
	        _react2.default.createElement(
	          'div',
	          { style: style },
	          _react2.default.createElement(Hloader, _defineProperty({ color: this.props.color, size: size }, 'color', color))
	        )
	      );
	    }
	  }]);
	
	  return LoadingIndicator;
	}(_react2.default.Component);
	
	LoadingIndicator.propTypes = {
	  //loader: React.PropTypes.string.isRequired,
	};
	exports.default = LoadingIndicator;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	    PulseLoader: __webpack_require__(245),
	    RotateLoader: __webpack_require__(252),
	    BeatLoader: __webpack_require__(253),
	    RiseLoader: __webpack_require__(254),
	    SyncLoader: __webpack_require__(255),
	    GridLoader: __webpack_require__(256),
	    ClipLoader: __webpack_require__(257),
	    SquareLoader: __webpack_require__(258),
	    DotLoader: __webpack_require__(259),
	    PacmanLoader: __webpack_require__(260),
	    MoonLoader: __webpack_require__(261),
	    RingLoader: __webpack_require__(262),
	    BounceLoader: __webpack_require__(263),
	    SkewLoader: __webpack_require__(264),
	    FadeLoader: __webpack_require__(265),
	    ScaleLoader: __webpack_require__(266)
	};

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(5);
	var assign = __webpack_require__(246);
	var insertKeyframesRule = __webpack_require__(249);
	
	/**
	 * @type {Object}
	 */
	var keyframes = {
	    '0%': {
	        transform: 'scale(1)',
	        opacity: 1
	    },
	    '45%': {
	        transform: 'scale(0.1)',
	        opacity: 0.7
	    },
	    '80%': {
	        transform: 'scale(1)',
	        opacity: 1
	    }
	};
	
	/**
	 * @type {String}
	 */
	var animationName = insertKeyframesRule(keyframes);
	
	var Loader = React.createClass({
	    displayName: 'Loader',
	
	    /**
	     * @type {Object}
	     */
	    propTypes: {
	        loading: React.PropTypes.bool,
	        color: React.PropTypes.string,
	        size: React.PropTypes.string,
	        margin: React.PropTypes.string
	    },
	
	    /**
	     * @return {Object}
	     */
	    getDefaultProps: function getDefaultProps() {
	        return {
	            loading: true,
	            color: '#ffffff',
	            size: '15px',
	            margin: '2px'
	        };
	    },
	
	    /**
	     * @return {Object}
	     */
	    getBallStyle: function getBallStyle() {
	        return {
	            backgroundColor: this.props.color,
	            width: this.props.size,
	            height: this.props.size,
	            margin: this.props.margin,
	            borderRadius: '100%',
	            verticalAlign: this.props.verticalAlign
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getAnimationStyle: function getAnimationStyle(i) {
	        var animation = [animationName, '0.75s', i * 0.12 + 's', 'infinite', 'cubic-bezier(.2,.68,.18,1.08)'].join(' ');
	        var animationFillMode = 'both';
	
	        return {
	            animation: animation,
	            animationFillMode: animationFillMode
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getStyle: function getStyle(i) {
	        return assign(this.getBallStyle(i), this.getAnimationStyle(i), {
	            display: 'inline-block'
	        });
	    },
	
	    /**
	     * @param  {Boolean} loading
	     * @return {ReactComponent || null}
	     */
	    renderLoader: function renderLoader(loading) {
	        if (loading) {
	            return React.createElement(
	                'div',
	                { id: this.props.id, className: this.props.className },
	                React.createElement('div', { style: this.getStyle(1) }),
	                React.createElement('div', { style: this.getStyle(2) }),
	                React.createElement('div', { style: this.getStyle(3) })
	            );
	        }
	
	        return null;
	    },
	
	    render: function render() {
	        return this.renderLoader(this.props.loading);
	    }
	});
	
	module.exports = Loader;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var getVendorPropertyName = __webpack_require__(247);
	
	module.exports = function(target, sources) {
	  var to = Object(target);
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	  for (var nextIndex = 1; nextIndex < arguments.length; nextIndex++) {
	    var nextSource = arguments[nextIndex];
	    if (nextSource == null) {
	      continue;
	    }
	
	    var from = Object(nextSource);
	
	    for (var key in from) {
	      if (hasOwnProperty.call(from, key)) {
	        to[key] = from[key];
	      }
	    }
	  }
	
	  var prefixed = {};
	  for (var key in to) {
	    prefixed[getVendorPropertyName(key)] = to[key]
	  }
	
	  return prefixed
	}


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var builtinStyle = __webpack_require__(248);
	var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
	var domVendorPrefix;
	
	// Helper function to get the proper vendor property name. (transition => WebkitTransition)
	module.exports = function(prop, isSupportTest) {
	
	  var vendorProp;
	  if (prop in builtinStyle) return prop;
	
	  var UpperProp = prop.charAt(0).toUpperCase() + prop.substr(1);
	
	  if (domVendorPrefix) {
	
	    vendorProp = domVendorPrefix + UpperProp;
	    if (vendorProp in builtinStyle) {
	      return vendorProp;
	    }
	  } else {
	
	    for (var i = 0; i < prefixes.length; ++i) {
	      vendorProp = prefixes[i] + UpperProp;
	      if (vendorProp in builtinStyle) {
	        domVendorPrefix = prefixes[i];
	        return vendorProp;
	      }
	    }
	  }
	
	  // if support test, not fallback to origin prop name
	  if (!isSupportTest) {
	    return prop;
	  }
	
	}


/***/ }),
/* 248 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = document.createElement('div').style;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var insertRule = __webpack_require__(250);
	var vendorPrefix = __webpack_require__(251)();
	var index = 0;
	
	module.exports = function(keyframes) {
	  // random name
	  var name = 'anim_' + (++index) + (+new Date);
	  var css = "@" + vendorPrefix + "keyframes " + name + " {";
	
	  for (var key in keyframes) {
	    css += key + " {";
	
	    for (var property in keyframes[key]) {
	      var part = ":" + keyframes[key][property] + ";";
	      // We do vendor prefix for every property
	      css += vendorPrefix + property + part;
	      css += property + part;
	    }
	
	    css += "}";
	  }
	
	  css += "}";
	
	  insertRule(css);
	
	  return name
	}


/***/ }),
/* 250 */
/***/ (function(module, exports) {

	'use strict';
	
	var extraSheet;
	
	module.exports = function(css) {
	
	  if (!extraSheet) {
	    // First time, create an extra stylesheet for adding rules
	    extraSheet = document.createElement('style');
	    document.getElementsByTagName('head')[0].appendChild(extraSheet);
	    // Keep reference to actual StyleSheet object (`styleSheet` for IE < 9)
	    extraSheet = extraSheet.sheet || extraSheet.styleSheet;
	  }
	
	  var index = (extraSheet.cssRules || extraSheet.rules).length;
	  extraSheet.insertRule(css, index);
	
	  return extraSheet;
	}


/***/ }),
/* 251 */
/***/ (function(module, exports) {

	'use strict';
	
	var cssVendorPrefix;
	
	module.exports = function() {
	
	  if (cssVendorPrefix) return cssVendorPrefix;
	
	  var styles = window.getComputedStyle(document.documentElement, '');
	  var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || (styles.OLink === '' && ['', 'o']))[1];
	
	  return cssVendorPrefix = '-' + pre + '-';
	}


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(5);
	var assign = __webpack_require__(246);
	var insertKeyframesRule = __webpack_require__(249);
	
	/**
	 * @type {Object}
	 */
	var keyframes = {
	    '0%': {
	        transform: 'rotate(0deg)'
	    },
	    '50%': {
	        transform: 'rotate(180deg)'
	    },
	    '100%': {
	        transform: 'rotate(360deg)'
	    }
	};
	
	/**
	 * @type {String}
	 */
	var animationName = insertKeyframesRule(keyframes);
	
	var Loader = React.createClass({
	    displayName: 'Loader',
	
	    /**
	     * @type {Object}
	     */
	    propTypes: {
	        loading: React.PropTypes.bool,
	        color: React.PropTypes.string,
	        size: React.PropTypes.string,
	        margin: React.PropTypes.string
	    },
	
	    /**
	     * @return {Object}
	     */
	    getDefaultProps: function getDefaultProps() {
	        return {
	            loading: true,
	            color: '#ffffff',
	            size: '15px',
	            margin: '2px'
	        };
	    },
	
	    /**
	     * @return {Object}
	     */
	    getBallStyle: function getBallStyle() {
	        return {
	            backgroundColor: this.props.color,
	            width: this.props.size,
	            height: this.props.size,
	            margin: this.props.margin,
	            borderRadius: '100%',
	            verticalAlign: this.props.verticalAlign
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getAnimationStyle: function getAnimationStyle(i) {
	        var animation = [animationName, '1s', '0s', 'infinite', 'cubic-bezier(.7,-.13,.22,.86)'].join(' ');
	        var animationFillMode = 'both';
	
	        return {
	            animation: animation,
	            animationFillMode: animationFillMode
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getStyle: function getStyle(i) {
	        if (i) {
	            return assign(this.getBallStyle(i), {
	                opacity: '0.8',
	                position: 'absolute',
	                top: 0,
	                left: i % 2 ? -28 : 25
	            });
	        }
	
	        return assign(this.getBallStyle(i), this.getAnimationStyle(i), {
	            display: 'inline-block',
	            position: 'relative'
	        });
	    },
	
	    /**
	     * @param  {Boolean} loading
	     * @return {ReactComponent || null}
	     */
	    renderLoader: function renderLoader(loading) {
	        if (loading) {
	            return React.createElement(
	                'div',
	                { id: this.props.id, className: this.props.className },
	                React.createElement(
	                    'div',
	                    { style: this.getStyle() },
	                    React.createElement('div', { style: this.getStyle(1) }),
	                    React.createElement('div', { style: this.getStyle(2) })
	                )
	            );
	        }
	
	        return null;
	    },
	
	    render: function render() {
	        return this.renderLoader(this.props.loading);
	    }
	});
	
	module.exports = Loader;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(5);
	var assign = __webpack_require__(246);
	var insertKeyframesRule = __webpack_require__(249);
	
	/**
	 * @type {Object}
	 */
	var keyframes = {
	    '50%': {
	        transform: 'scale(0.75)',
	        opacity: 0.2
	    },
	    '100%': {
	        transform: 'scale(1)',
	        opacity: 1
	    }
	};
	
	var animationName = insertKeyframesRule(keyframes);
	
	var Loader = React.createClass({
	    displayName: 'Loader',
	
	    /**
	     * @type {Object}
	     */
	    propTypes: {
	        loading: React.PropTypes.bool,
	        color: React.PropTypes.string,
	        size: React.PropTypes.string,
	        margin: React.PropTypes.string
	    },
	
	    /**
	     * @return {Object}
	     */
	    getDefaultProps: function getDefaultProps() {
	        return {
	            loading: true,
	            color: '#ffffff',
	            size: '15px',
	            margin: '2px'
	        };
	    },
	
	    /**
	     * @return {Object}
	     */
	    getBallStyle: function getBallStyle() {
	        return {
	            backgroundColor: this.props.color,
	            width: this.props.size,
	            height: this.props.size,
	            margin: this.props.margin,
	            borderRadius: '100%',
	            verticalAlign: this.props.verticalAlign
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getAnimationStyle: function getAnimationStyle(i) {
	        var animation = [animationName, '0.7s', i % 2 ? '0s' : '0.35s', 'infinite', 'linear'].join(' ');
	        var animationFillMode = 'both';
	
	        return {
	            animation: animation,
	            animationFillMode: animationFillMode
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getStyle: function getStyle(i) {
	        return assign(this.getBallStyle(i), this.getAnimationStyle(i), {
	            display: 'inline-block'
	        });
	    },
	
	    /**
	     * @param  {Boolean} loading
	     * @return {ReactComponent || null}
	     */
	    renderLoader: function renderLoader(loading) {
	        if (loading) {
	            return React.createElement(
	                'div',
	                { id: this.props.id, className: this.props.className },
	                React.createElement('div', { style: this.getStyle(1) }),
	                React.createElement('div', { style: this.getStyle(2) }),
	                React.createElement('div', { style: this.getStyle(3) })
	            );
	        }
	
	        return null;
	    },
	
	    render: function render() {
	        return this.renderLoader(this.props.loading);
	    }
	});
	
	module.exports = Loader;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(5);
	var assign = __webpack_require__(246);
	var insertKeyframesRule = __webpack_require__(249);
	
	/**
	 * @type {Number}
	 */
	var riseAmount = 30;
	
	/**
	 * @type {Object}
	 */
	var keyframesEven = {
	    '0%': {
	        transform: 'scale(1.1)'
	    },
	    '25': {
	        transform: 'translateY(-' + riseAmount + 'px)'
	    },
	    '50%': {
	        transform: 'scale(0.4)'
	    },
	    '75%': {
	        transform: 'translateY(' + riseAmount + 'px)'
	    },
	    '100%': {
	        transform: 'translateY(0) scale(1.0)'
	    }
	};
	
	/**
	 * @type {Object}
	 */
	var keyframesOdd = {
	    '0%': {
	        transform: 'scale(0.4)'
	    },
	    '25': {
	        transform: 'translateY(' + riseAmount + 'px)'
	    },
	    '50%': {
	        transform: 'scale(1.1)'
	    },
	    '75%': {
	        transform: 'translateY(-' + riseAmount + 'px)'
	    },
	    '100%': {
	        transform: 'translateY(0) scale(0.75)'
	    }
	};
	
	/**
	 * @type {String}
	 */
	var animationNameEven = insertKeyframesRule(keyframesEven);
	
	/**
	 * @type {String}
	 */
	var animationNameOdd = insertKeyframesRule(keyframesOdd);
	
	var Loader = React.createClass({
	    displayName: 'Loader',
	
	    /**
	     * @type {Object}
	     */
	    propTypes: {
	        loading: React.PropTypes.bool,
	        color: React.PropTypes.string,
	        size: React.PropTypes.string,
	        margin: React.PropTypes.string
	    },
	
	    /**
	     * @return {Object}
	     */
	    getDefaultProps: function getDefaultProps() {
	        return {
	            loading: true,
	            color: '#ffffff',
	            size: '15px',
	            margin: '2px'
	        };
	    },
	
	    /**
	     * @return {Object}
	     */
	    getBallStyle: function getBallStyle() {
	        return {
	            backgroundColor: this.props.color,
	            width: this.props.size,
	            height: this.props.size,
	            margin: this.props.margin,
	            borderRadius: '100%',
	            verticalAlign: this.props.verticalAlign
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getAnimationStyle: function getAnimationStyle(i) {
	        var animation = [i % 2 == 0 ? animationNameEven : animationNameOdd, '1s', '0s', 'infinite', 'cubic-bezier(.15,.46,.9,.6)'].join(' ');
	        var animationFillMode = 'both';
	
	        return {
	            animation: animation,
	            animationFillMode: animationFillMode
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getStyle: function getStyle(i) {
	        return assign(this.getBallStyle(i), this.getAnimationStyle(i), {
	            display: 'inline-block'
	        });
	    },
	
	    /**
	     * @param  {Boolean} loading
	     * @return {ReactComponent || null}
	     */
	    renderLoader: function renderLoader(loading) {
	        if (loading) {
	            return React.createElement(
	                'div',
	                { id: this.props.id, className: this.props.className },
	                React.createElement('div', { style: this.getStyle(1) }),
	                React.createElement('div', { style: this.getStyle(2) }),
	                React.createElement('div', { style: this.getStyle(3) }),
	                React.createElement('div', { style: this.getStyle(4) }),
	                React.createElement('div', { style: this.getStyle(5) })
	            );
	        }
	
	        return null;
	    },
	
	    render: function render() {
	        return this.renderLoader(this.props.loading);
	    }
	});
	
	module.exports = Loader;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(5);
	var assign = __webpack_require__(246);
	var insertKeyframesRule = __webpack_require__(249);
	
	/**
	 * @type {Object}
	 */
	var keyframes = {
	    '33%': {
	        transform: 'translateY(10px)'
	    },
	    '66%': {
	        transform: 'translateY(-10px)'
	    },
	    '100%': {
	        transform: 'translateY(0)'
	    }
	};
	
	/**
	 * @type {String}
	 */
	var animationName = insertKeyframesRule(keyframes);
	
	var Loader = React.createClass({
	    displayName: 'Loader',
	
	    /**
	     * @type {Object}
	     */
	    propTypes: {
	        loading: React.PropTypes.bool,
	        color: React.PropTypes.string,
	        size: React.PropTypes.string,
	        margin: React.PropTypes.string
	    },
	
	    /**
	     * @return {Object}
	     */
	    getDefaultProps: function getDefaultProps() {
	        return {
	            loading: true,
	            color: '#ffffff',
	            size: '15px',
	            margin: '2px'
	        };
	    },
	
	    /**
	     * @return {Object}
	     */
	    getBallStyle: function getBallStyle() {
	        return {
	            backgroundColor: this.props.color,
	            width: this.props.size,
	            height: this.props.size,
	            margin: this.props.margin,
	            borderRadius: '100%',
	            verticalAlign: this.props.verticalAlign
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getAnimationStyle: function getAnimationStyle(i) {
	        var animation = [animationName, '0.6s', i * 0.07 + 's', 'infinite', 'ease-in-out'].join(' ');
	        var animationFillMode = 'both';
	
	        return {
	            animation: animation,
	            animationFillMode: animationFillMode
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getStyle: function getStyle(i) {
	        return assign(this.getBallStyle(i), this.getAnimationStyle(i), {
	            display: 'inline-block'
	        });
	    },
	
	    /**
	     * @param  {Boolean} loading
	     * @return {ReactComponent || null}
	     */
	    renderLoader: function renderLoader(loading) {
	        if (loading) {
	            return React.createElement(
	                'div',
	                { id: this.props.id, className: this.props.className },
	                React.createElement('div', { style: this.getStyle(1) }),
	                React.createElement('div', { style: this.getStyle(2) }),
	                React.createElement('div', { style: this.getStyle(3) })
	            );
	        };
	
	        return null;
	    },
	
	    render: function render() {
	        return this.renderLoader(this.props.loading);
	    }
	});
	
	module.exports = Loader;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(5);
	var assign = __webpack_require__(246);
	var insertKeyframesRule = __webpack_require__(249);
	
	/**
	 * @type {Object}
	 */
	var keyframes = {
	    '0%': {
	        transform: 'scale(1)'
	    },
	    '50%': {
	        transform: 'scale(0.5)',
	        opacity: 0.7
	    },
	    '100%': {
	        transform: 'scale(1)',
	        opacity: 1
	    }
	};
	
	/**
	 * @type {String}
	 */
	var animationName = insertKeyframesRule(keyframes);
	
	/**
	 * @param  {Number} top
	 * @return {Number}
	 */
	function random(top) {
	    return Math.random() * top;
	}
	
	var Loader = React.createClass({
	    displayName: 'Loader',
	
	    /**
	     * @type {Object}
	     */
	    propTypes: {
	        loading: React.PropTypes.bool,
	        color: React.PropTypes.string,
	        size: React.PropTypes.string,
	        margin: React.PropTypes.string
	    },
	
	    /**
	     * @return {Object}
	     */
	    getDefaultProps: function getDefaultProps() {
	        return {
	            loading: true,
	            color: '#ffffff',
	            size: '15px',
	            margin: '2px'
	        };
	    },
	
	    /**
	     * @return {Object}
	     */
	    getBallStyle: function getBallStyle() {
	        return {
	            backgroundColor: this.props.color,
	            width: this.props.size,
	            height: this.props.size,
	            margin: this.props.margin,
	            borderRadius: '100%',
	            verticalAlign: this.props.verticalAlign
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getAnimationStyle: function getAnimationStyle(i) {
	        var animationDuration = random(100) / 100 + 0.6 + 's';
	        var animationDelay = random(100) / 100 - 0.2 + 's';
	
	        var animation = [animationName, animationDuration, animationDelay, 'infinite', 'ease'].join(' ');
	        var animationFillMode = 'both';
	
	        return {
	            animation: animation,
	            animationFillMode: animationFillMode
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getStyle: function getStyle(i) {
	        return assign(this.getBallStyle(i), this.getAnimationStyle(i), {
	            display: 'inline-block'
	        });
	    },
	
	    /**
	     * @param  {Boolean} loading
	     * @return {ReactComponent || null}
	     */
	    renderLoader: function renderLoader(loading) {
	        if (loading) {
	            var style = {
	                width: parseFloat(this.props.size) * 3 + parseFloat(this.props.margin) * 6,
	                fontSize: 0
	            };
	
	            return React.createElement(
	                'div',
	                { id: this.props.id, className: this.props.className },
	                React.createElement(
	                    'div',
	                    { style: style },
	                    React.createElement('div', { style: this.getStyle(1) }),
	                    React.createElement('div', { style: this.getStyle(2) }),
	                    React.createElement('div', { style: this.getStyle(3) }),
	                    React.createElement('div', { style: this.getStyle(4) }),
	                    React.createElement('div', { style: this.getStyle(5) }),
	                    React.createElement('div', { style: this.getStyle(6) }),
	                    React.createElement('div', { style: this.getStyle(7) }),
	                    React.createElement('div', { style: this.getStyle(8) }),
	                    React.createElement('div', { style: this.getStyle(9) })
	                )
	            );
	        }
	
	        return null;
	    },
	
	    render: function render() {
	        return this.renderLoader(this.props.loading);
	    }
	});
	
	module.exports = Loader;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(5);
	var assign = __webpack_require__(246);
	var insertKeyframesRule = __webpack_require__(249);
	
	/**
	 * @type {Object}
	 */
	var keyframes = {
	    '0%': {
	        transform: 'rotate(0deg) scale(1)'
	    },
	    '50%': {
	        transform: 'rotate(180deg) scale(0.8)'
	    },
	    '100%': {
	        transform: 'rotate(360deg) scale(1)'
	    }
	};
	
	/**
	 * @type {String}
	 */
	var animationName = insertKeyframesRule(keyframes);
	
	var Loader = React.createClass({
	    displayName: 'Loader',
	
	    /**
	     * @type {Object}
	     */
	    propTypes: {
	        loading: React.PropTypes.bool,
	        color: React.PropTypes.string,
	        size: React.PropTypes.string
	    },
	
	    /**
	     * @return {Object}
	     */
	    getDefaultProps: function getDefaultProps() {
	        return {
	            loading: true,
	            color: '#ffffff',
	            size: '35px'
	        };
	    },
	
	    /**
	     * @return {Object}
	     */
	    getBallStyle: function getBallStyle() {
	        return {
	            width: this.props.size,
	            height: this.props.size,
	            border: '2px solid',
	            borderColor: this.props.color,
	            borderBottomColor: 'transparent',
	            borderRadius: '100%',
	            background: 'transparent !important',
	            verticalAlign: this.props.verticalAlign
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getAnimationStyle: function getAnimationStyle(i) {
	        var animation = [animationName, '0.75s', '0s', 'infinite', 'linear'].join(' ');
	        var animationFillMode = 'both';
	
	        return {
	            animation: animation,
	            animationFillMode: animationFillMode
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getStyle: function getStyle(i) {
	        return assign(this.getBallStyle(i), this.getAnimationStyle(i), {
	            display: 'inline-block'
	        });
	    },
	
	    /**
	     * @param  {Boolean} loading
	     * @return {ReactComponent || null}
	     */
	    renderLoader: function renderLoader(loading) {
	        if (loading) {
	            return React.createElement(
	                'div',
	                { id: this.props.id, className: this.props.className },
	                React.createElement('div', { style: this.getStyle() })
	            );
	        }
	
	        return null;
	    },
	
	    render: function render() {
	        return this.renderLoader(this.props.loading);
	    }
	});
	
	module.exports = Loader;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(5);
	var assign = __webpack_require__(246);
	var insertKeyframesRule = __webpack_require__(249);
	
	/**
	 * @type {Object}
	 */
	var keyframes = {
	    '25%': {
	        transform: 'rotateX(180deg) rotateY(0)'
	    },
	    '50%': {
	        transform: 'rotateX(180deg) rotateY(180deg)'
	    },
	    '75%': {
	        transform: 'rotateX(0) rotateY(180deg)'
	    },
	    '100%': {
	        transform: 'rotateX(0) rotateY(0)'
	    }
	};
	
	/**
	 * @type {String}
	 */
	var animationName = insertKeyframesRule(keyframes);
	
	var Loader = React.createClass({
	    displayName: 'Loader',
	
	    /**
	     * @type {Object}
	     */
	    propTypes: {
	        loading: React.PropTypes.bool,
	        color: React.PropTypes.string,
	        size: React.PropTypes.string,
	        margin: React.PropTypes.string
	    },
	
	    /**
	     * @return {Object}
	     */
	    getDefaultProps: function getDefaultProps() {
	        return {
	            loading: true,
	            color: '#ffffff',
	            size: '50px'
	        };
	    },
	
	    /**
	     * @return {Object}
	     */
	    getSquareStyle: function getSquareStyle() {
	        return {
	            backgroundColor: this.props.color,
	            width: this.props.size,
	            height: this.props.size,
	            verticalAlign: this.props.verticalAlign
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getAnimationStyle: function getAnimationStyle(i) {
	        var animation = [animationName, '3s', '0s', 'infinite', 'cubic-bezier(.09,.57,.49,.9)'].join(' ');
	        var animationFillMode = 'both';
	        var perspective = '100px';
	
	        return {
	            perspective: perspective,
	            animation: animation,
	            animationFillMode: animationFillMode
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getStyle: function getStyle(i) {
	        return assign(this.getSquareStyle(i), this.getAnimationStyle(i), {
	            display: 'inline-block'
	        });
	    },
	
	    /**
	     * @param  {Boolean} loading
	     * @return {ReactComponent || null}
	     */
	    renderLoader: function renderLoader(loading) {
	        if (loading) {
	            return React.createElement(
	                'div',
	                { id: this.props.id, className: this.props.className },
	                React.createElement('div', { style: this.getStyle() })
	            );
	        }
	
	        return null;
	    },
	
	    render: function render() {
	        return this.renderLoader(this.props.loading);
	    }
	});
	
	module.exports = Loader;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(5);
	var assign = __webpack_require__(246);
	var insertKeyframesRule = __webpack_require__(249);
	
	/**
	 * @type {Object}
	 */
	var rotateKeyframes = {
	    '100%': {
	        transform: 'rotate(360deg)'
	    }
	};
	
	/**
	 * @type {Object}
	 */
	var bounceKeyframes = {
	    '0%, 100%': {
	        transform: 'scale(0)'
	    },
	    '50%': {
	        transform: 'scale(1.0)'
	    }
	};
	
	/**
	 * @type {String}
	 */
	var rotateAnimationName = insertKeyframesRule(rotateKeyframes);
	
	/**
	 * @type {String}
	 */
	var bounceAnimationName = insertKeyframesRule(bounceKeyframes);
	
	var Loader = React.createClass({
	    displayName: 'Loader',
	
	    /**
	     * @type {Object}
	     */
	    propTypes: {
	        loading: React.PropTypes.bool,
	        color: React.PropTypes.string,
	        size: React.PropTypes.string,
	        margin: React.PropTypes.string
	    },
	
	    /**
	     * @return {Object}
	     */
	    getDefaultProps: function getDefaultProps() {
	        return {
	            loading: true,
	            color: '#ffffff',
	            size: '60px'
	        };
	    },
	
	    /**
	     * @param  {String} size
	     * @return {Object}
	     */
	    getBallStyle: function getBallStyle(size) {
	        return {
	            backgroundColor: this.props.color,
	            width: size,
	            height: size,
	            borderRadius: '100%',
	            verticalAlign: this.props.verticalAlign
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getAnimationStyle: function getAnimationStyle(i) {
	        var animation = [i == 0 ? rotateAnimationName : bounceAnimationName, '2s', i == 2 ? '-1s' : '0s', 'infinite', 'linear'].join(' ');
	        var animationFillMode = 'forwards';
	
	        return {
	            animation: animation,
	            animationFillMode: animationFillMode
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getStyle: function getStyle(i) {
	        var size = parseInt(this.props.size);
	        var ballSize = size / 2;
	
	        if (i) {
	            return assign(this.getBallStyle(ballSize), this.getAnimationStyle(i), {
	                position: 'absolute',
	                top: i % 2 ? 0 : 'auto',
	                bottom: i % 2 ? 'auto' : 0
	            });
	        }
	
	        return assign(this.getAnimationStyle(i), {
	            width: size,
	            height: size,
	            position: 'relative'
	        });
	    },
	
	    /**
	     * @param  {Boolean} loading
	     * @return {ReactComponent || null}
	     */
	    renderLoader: function renderLoader(loading) {
	        if (loading) {
	            return React.createElement(
	                'div',
	                { id: this.props.id, className: this.props.className },
	                React.createElement(
	                    'div',
	                    { style: this.getStyle(0) },
	                    React.createElement('div', { style: this.getStyle(1) }),
	                    React.createElement('div', { style: this.getStyle(2) })
	                )
	            );
	        }
	
	        return null;
	    },
	
	    render: function render() {
	        return this.renderLoader(this.props.loading);
	    }
	});
	
	module.exports = Loader;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(5);
	var assign = __webpack_require__(246);
	var insertKeyframesRule = __webpack_require__(249);
	
	/**
	 * @type {Object}
	 */
	var animations = {};
	
	var Loader = React.createClass({
	    displayName: 'Loader',
	
	    /**
	     * @type {Object}
	     */
	    propTypes: {
	        loading: React.PropTypes.bool,
	        color: React.PropTypes.string,
	        size: React.PropTypes.number,
	        margin: React.PropTypes.number
	    },
	
	    /**
	     * @return {Object}
	     */
	    getDefaultProps: function getDefaultProps() {
	        return {
	            loading: true,
	            color: '#ffffff',
	            size: 25,
	            margin: 2
	        };
	    },
	
	    /**
	     * @return {Object}
	     */
	    getBallStyle: function getBallStyle() {
	        return {
	            backgroundColor: this.props.color,
	            width: this.props.size,
	            height: this.props.size,
	            margin: this.props.margin,
	            borderRadius: '100%',
	            verticalAlign: this.props.verticalAlign
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getAnimationStyle: function getAnimationStyle(i) {
	        var size = this.props.size;
	        var animationName = animations[size];
	
	        if (!animationName) {
	            var keyframes = {
	                '75%': {
	                    opacity: 0.7
	                },
	                '100%': {
	                    transform: 'translate(' + -4 * size + 'px,' + -size / 4 + 'px)'
	                }
	            };
	            animationName = animations[size] = insertKeyframesRule(keyframes);
	        }
	
	        var animation = [animationName, '1s', i * 0.25 + 's', 'infinite', 'linear'].join(' ');
	        var animationFillMode = 'both';
	
	        return {
	            animation: animation,
	            animationFillMode: animationFillMode
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getStyle: function getStyle(i) {
	        if (i == 1) {
	            var s1 = this.props.size + 'px solid transparent';
	            var s2 = this.props.size + 'px solid ' + this.props.color;
	
	            return {
	                width: 0,
	                height: 0,
	                borderRight: s1,
	                borderTop: s2,
	                borderLeft: s2,
	                borderBottom: s2,
	                borderRadius: this.props.size
	            };
	        }
	
	        return assign(this.getBallStyle(i), this.getAnimationStyle(i), {
	            width: 10,
	            height: 10,
	            transform: 'translate(0, ' + -this.props.size / 4 + 'px)',
	            position: 'absolute',
	            top: 25,
	            left: 100
	        });
	    },
	
	    /**
	     * @param  {Boolean} loading
	     * @return {ReactComponent || null}
	     */
	    renderLoader: function renderLoader(loading) {
	        if (loading) {
	            var style = {
	                position: 'relative',
	                fontSize: 0
	            };
	
	            return React.createElement(
	                'div',
	                { id: this.props.id, className: this.props.className },
	                React.createElement(
	                    'div',
	                    { style: style },
	                    React.createElement('div', { style: this.getStyle(1) }),
	                    React.createElement('div', { style: this.getStyle(2) }),
	                    React.createElement('div', { style: this.getStyle(3) }),
	                    React.createElement('div', { style: this.getStyle(4) }),
	                    React.createElement('div', { style: this.getStyle(5) })
	                )
	            );
	        }
	
	        return null;
	    },
	
	    render: function render() {
	        return this.renderLoader(this.props.loading);
	    }
	});
	
	module.exports = Loader;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(5);
	var assign = __webpack_require__(246);
	var insertKeyframesRule = __webpack_require__(249);
	
	/**
	 * @type {Object}
	 */
	var keyframes = {
	    '100%': {
	        transform: 'rotate(360deg)'
	    }
	};
	
	/**
	 * @type {String}
	 */
	var animationName = insertKeyframesRule(keyframes);
	
	var Loader = React.createClass({
	    displayName: 'Loader',
	
	    /**
	     * @type {Object}
	     */
	    propTypes: {
	        loading: React.PropTypes.bool,
	        color: React.PropTypes.string,
	        size: React.PropTypes.string,
	        margin: React.PropTypes.string
	    },
	
	    /**
	     * @return {Object}
	     */
	    getDefaultProps: function getDefaultProps() {
	        return {
	            loading: true,
	            color: '#ffffff',
	            size: '60px'
	        };
	    },
	
	    /**
	     * @param  {String} size
	     * @return {Object}
	     */
	    getBallStyle: function getBallStyle(size) {
	        return {
	            width: size,
	            height: size,
	            borderRadius: '100%',
	            verticalAlign: this.props.verticalAlign
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getAnimationStyle: function getAnimationStyle(i) {
	        var animation = [animationName, '0.6s', '0s', 'infinite', 'linear'].join(' ');
	        var animationFillMode = 'forwards';
	
	        return {
	            animation: animation,
	            animationFillMode: animationFillMode
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getStyle: function getStyle(i) {
	        var size = parseInt(this.props.size);
	        var moonSize = size / 7;
	
	        if (i == 1) {
	            return assign(this.getBallStyle(moonSize), this.getAnimationStyle(i), {
	                backgroundColor: this.props.color,
	                opacity: '0.8',
	                position: 'absolute',
	                top: size / 2 - moonSize / 2
	            });
	        } else if (i == 2) {
	            return assign(this.getBallStyle(size), {
	                border: moonSize + 'px solid ' + this.props.color,
	                opacity: 0.1
	            });
	        } else {
	            return assign(this.getAnimationStyle(i), {
	                position: 'relative'
	            });
	        }
	    },
	
	    /**
	     * @param  {Boolean} loading
	     * @return {ReactComponent || null}
	     */
	    renderLoader: function renderLoader(loading) {
	        if (loading) {
	            return React.createElement(
	                'div',
	                { id: this.props.id, className: this.props.className },
	                React.createElement(
	                    'div',
	                    { style: this.getStyle(0) },
	                    React.createElement('div', { style: this.getStyle(1) }),
	                    React.createElement('div', { style: this.getStyle(2) })
	                )
	            );
	        }
	
	        return null;
	    },
	
	    render: function render() {
	        return this.renderLoader(this.props.loading);
	    }
	});
	
	module.exports = Loader;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(5);
	var assign = __webpack_require__(246);
	var insertKeyframesRule = __webpack_require__(249);
	
	/**
	 * @type {Object}
	 */
	var rightRotateKeyframes = {
	    '0%': {
	        transform: 'rotateX(0deg) rotateY(0deg) rotateZ(0deg)'
	
	    },
	    '100%': {
	        transform: 'rotateX(180deg) rotateY(360deg) rotateZ(360deg)'
	    }
	};
	
	/**
	 * @type {Object}
	 */
	var leftRotateKeyframes = {
	    '0%': {
	        transform: 'rotateX(0deg) rotateY(0deg) rotateZ(0deg)'
	    },
	    '100%': {
	        transform: 'rotateX(360deg) rotateY(180deg) rotateZ(360deg)'
	    }
	};
	
	/**
	 * @type {String}
	 */
	var rightRotateAnimationName = insertKeyframesRule(rightRotateKeyframes);
	
	/**
	 * @type {String}
	 */
	var leftRotateAnimationName = insertKeyframesRule(leftRotateKeyframes);
	
	var Loader = React.createClass({
	    displayName: 'Loader',
	
	    /**
	     * @type {Object}
	     */
	    propTypes: {
	        loading: React.PropTypes.bool,
	        color: React.PropTypes.string,
	        size: React.PropTypes.string,
	        margin: React.PropTypes.string
	    },
	
	    /**
	     * @return {Object}
	     */
	    getDefaultProps: function getDefaultProps() {
	        return {
	            loading: true,
	            color: '#ffffff',
	            size: '60px'
	        };
	    },
	
	    /**
	     * @param {String} size
	     * @return {Object}
	     */
	    getCircleStyle: function getCircleStyle(size) {
	        return {
	            width: size,
	            height: size,
	            border: size / 10 + 'px solid ' + this.props.color,
	            opacity: 0.4,
	            borderRadius: '100%',
	            verticalAlign: this.props.verticalAlign
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getAnimationStyle: function getAnimationStyle(i) {
	        var animation = [i == 1 ? rightRotateAnimationName : leftRotateAnimationName, '2s', '0s', 'infinite', 'linear'].join(' ');
	        var animationFillMode = 'forwards';
	        var perspective = '800px';
	
	        return {
	            perspective: perspective,
	            animation: animation,
	            animationFillMode: animationFillMode
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getStyle: function getStyle(i) {
	        var size = parseInt(this.props.size);
	
	        if (i) {
	            return assign(this.getCircleStyle(size), this.getAnimationStyle(i), {
	                position: 'absolute',
	                top: 0,
	                left: 0
	            });
	        }
	
	        return {
	            width: size,
	            height: size,
	            position: 'relative'
	        };
	    },
	
	    /**
	     * @param  {Boolean} loading
	     * @return {ReactComponent || null}
	     */
	    renderLoader: function renderLoader(loading) {
	        if (loading) {
	            return React.createElement(
	                'div',
	                { id: this.props.id, className: this.props.className },
	                React.createElement(
	                    'div',
	                    { style: this.getStyle(0) },
	                    React.createElement('div', { style: this.getStyle(1) }),
	                    React.createElement('div', { style: this.getStyle(2) })
	                )
	            );
	        }
	
	        return null;
	    },
	
	    render: function render() {
	        return this.renderLoader(this.props.loading);
	    }
	});
	
	module.exports = Loader;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(5);
	var assign = __webpack_require__(246);
	var insertKeyframesRule = __webpack_require__(249);
	
	/**
	 * @type {Object}
	 */
	var keyframes = {
	    '0%, 100%': {
	        transform: 'scale(0)'
	    },
	    '50%': {
	        transform: 'scale(1.0)'
	    }
	};
	
	/**
	 * @type {String}
	 */
	var animationName = insertKeyframesRule(keyframes);
	
	var Loader = React.createClass({
	    displayName: 'Loader',
	
	    /**
	     * @type {Object}
	     */
	    propTypes: {
	        loading: React.PropTypes.bool,
	        color: React.PropTypes.string,
	        size: React.PropTypes.string
	    },
	
	    /**
	     * @return {Object}
	     */
	    getDefaultProps: function getDefaultProps() {
	        return {
	            loading: true,
	            color: '#ffffff',
	            size: '60px'
	        };
	    },
	
	    /**
	     * @return {Object}
	     */
	    getBallStyle: function getBallStyle() {
	        return {
	            backgroundColor: this.props.color,
	            width: this.props.size,
	            height: this.props.size,
	            borderRadius: '100%',
	            opacity: 0.6,
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            verticalAlign: this.props.verticalAlign
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getAnimationStyle: function getAnimationStyle(i) {
	        var animation = [animationName, '2s', i == 1 ? '1s' : '0s', 'infinite', 'ease-in-out'].join(' ');
	        var animationFillMode = 'both';
	
	        return {
	            animation: animation,
	            animationFillMode: animationFillMode
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getStyle: function getStyle(i) {
	        if (i) {
	            return assign(this.getBallStyle(i), this.getAnimationStyle(i));
	        }
	
	        return assign({
	            width: this.props.size,
	            height: this.props.size,
	            position: 'relative'
	        });
	    },
	
	    /**
	     * @param  {Boolean} loading
	     * @return {ReactComponent || null}
	     */
	    renderLoader: function renderLoader(loading) {
	        if (loading) {
	            return React.createElement(
	                'div',
	                { id: this.props.id, className: this.props.className },
	                React.createElement(
	                    'div',
	                    { style: this.getStyle() },
	                    React.createElement('div', { style: this.getStyle(1) }),
	                    React.createElement('div', { style: this.getStyle(2) })
	                )
	            );
	        }
	
	        return null;
	    },
	
	    render: function render() {
	        return this.renderLoader(this.props.loading);
	    }
	});
	
	module.exports = Loader;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(5);
	var assign = __webpack_require__(246);
	var insertKeyframesRule = __webpack_require__(249);
	
	/**
	 * @type {Object}
	 */
	var keyframes = {
	    '25%': {
	        transform: 'perspective(100px) rotateX(180deg) rotateY(0)'
	    },
	    '50%': {
	        transform: 'perspective(100px) rotateX(180deg) rotateY(180deg)'
	    },
	    '75%': {
	        transform: 'perspective(100px) rotateX(0) rotateY(180deg)'
	    },
	    '100%': {
	        transform: 'perspective(100px) rotateX(0) rotateY(0)'
	    }
	};
	
	/**
	 * @type {String}
	 */
	var animationName = insertKeyframesRule(keyframes);
	
	var Loader = React.createClass({
	    displayName: 'Loader',
	
	    /**
	     * @type {Object}
	     */
	    propTypes: {
	        loading: React.PropTypes.bool,
	        color: React.PropTypes.string,
	        size: React.PropTypes.string
	    },
	
	    /**
	     * @return {Object}
	     */
	    getDefaultProps: function getDefaultProps() {
	        return {
	            loading: true,
	            color: '#ffffff',
	            size: '20px'
	        };
	    },
	
	    /**
	     * @return {Object}
	     */
	    getSharpStyle: function getSharpStyle() {
	        return {
	            width: 0,
	            height: 0,
	            borderLeft: this.props.size + ' solid transparent',
	            borderRight: this.props.size + ' solid transparent',
	            borderBottom: this.props.size + ' solid ' + this.props.color,
	            verticalAlign: this.props.verticalAlign
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getAnimationStyle: function getAnimationStyle(i) {
	        var animation = [animationName, '3s', '0s', 'infinite', 'cubic-bezier(.09,.57,.49,.9)'].join(' ');
	        var animationFillMode = 'both';
	
	        return {
	            animation: animation,
	            animationFillMode: animationFillMode
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getStyle: function getStyle(i) {
	        return assign(this.getSharpStyle(i), this.getAnimationStyle(i), {
	            display: 'inline-block'
	        });
	    },
	
	    /**
	     * @param  {Boolean} loading
	     * @return {ReactComponent || null}
	     */
	    renderLoader: function renderLoader(loading) {
	        if (loading) {
	            return React.createElement(
	                'div',
	                { id: this.props.id, className: this.props.className },
	                React.createElement('div', { style: this.getStyle() })
	            );
	        };
	
	        return null;
	    },
	
	    render: function render() {
	        return this.renderLoader(this.props.loading);
	    }
	});
	
	module.exports = Loader;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(5);
	var assign = __webpack_require__(246);
	var insertKeyframesRule = __webpack_require__(249);
	
	/**
	 * @type {Object}
	 */
	var keyframes = {
	    '50%': {
	        opacity: 0.3
	    },
	    '100%': {
	        opacity: 1
	    }
	};
	
	/**
	 * @type {String}
	 */
	var animationName = insertKeyframesRule(keyframes);
	
	var Loader = React.createClass({
	    displayName: 'Loader',
	
	    /**
	     * @type {Object}
	     */
	    propTypes: {
	        loading: React.PropTypes.bool,
	        color: React.PropTypes.string,
	        height: React.PropTypes.string,
	        width: React.PropTypes.string,
	        margin: React.PropTypes.string,
	        radius: React.PropTypes.string
	    },
	
	    /**
	     * @return {Object}
	     */
	    getDefaultProps: function getDefaultProps() {
	        return {
	            loading: true,
	            color: '#ffffff',
	            height: '15px',
	            width: '5px',
	            margin: '2px',
	            radius: '2px'
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getLineStyle: function getLineStyle(i) {
	        return {
	            backgroundColor: this.props.color,
	            height: this.props.height,
	            width: this.props.width,
	            margin: this.props.margin,
	            borderRadius: this.props.radius,
	            verticalAlign: this.props.verticalAlign
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getAnimationStyle: function getAnimationStyle(i) {
	        var animation = [animationName, '1.2s', i * 0.12 + 's', 'infinite', 'ease-in-out'].join(' ');
	        var animationFillMode = 'both';
	
	        return {
	            animation: animation,
	            animationFillMode: animationFillMode
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getPosStyle: function getPosStyle(i) {
	        var radius = '20';
	        var quarter = radius / 2 + radius / 5.5;
	
	        var lines = {
	            l1: {
	                top: radius,
	                left: 0
	            },
	            l2: {
	                top: quarter,
	                left: quarter,
	                transform: 'rotate(-45deg)'
	            },
	            l3: {
	                top: 0,
	                left: radius,
	                transform: 'rotate(90deg)'
	            },
	            l4: {
	                top: -quarter,
	                left: quarter,
	                transform: 'rotate(45deg)'
	            },
	            l5: {
	                top: -radius,
	                left: 0
	            },
	            l6: {
	                top: -quarter,
	                left: -quarter,
	                transform: 'rotate(-45deg)'
	            },
	            l7: {
	                top: 0,
	                left: -radius,
	                transform: 'rotate(90deg)'
	            },
	            l8: {
	                top: quarter,
	                left: -quarter,
	                transform: 'rotate(45deg)'
	            }
	        };
	
	        return lines['l' + i];
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getStyle: function getStyle(i) {
	        return assign(this.getLineStyle(i), this.getPosStyle(i), this.getAnimationStyle(i), {
	            position: 'absolute'
	        });
	    },
	
	    /**
	     * @param  {Boolean} loading
	     * @return {ReactComponent || null}
	     */
	    renderLoader: function renderLoader(loading) {
	        if (loading) {
	            var style = {
	                position: 'relative',
	                fontSize: 0
	            };
	
	            return React.createElement(
	                'div',
	                { id: this.props.id, className: this.props.className },
	                React.createElement(
	                    'div',
	                    { style: style },
	                    React.createElement('div', { style: this.getStyle(1) }),
	                    React.createElement('div', { style: this.getStyle(2) }),
	                    React.createElement('div', { style: this.getStyle(3) }),
	                    React.createElement('div', { style: this.getStyle(4) }),
	                    React.createElement('div', { style: this.getStyle(5) }),
	                    React.createElement('div', { style: this.getStyle(6) }),
	                    React.createElement('div', { style: this.getStyle(7) }),
	                    React.createElement('div', { style: this.getStyle(8) })
	                )
	            );
	        }
	
	        return null;
	    },
	
	    render: function render() {
	        return this.renderLoader(this.props.loading);
	    }
	});
	
	module.exports = Loader;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(5);
	var assign = __webpack_require__(246);
	var insertKeyframesRule = __webpack_require__(249);
	
	/**
	 * @type {Object}
	 */
	var keyframes = {
	    '0%': {
	        transform: 'scaley(1.0)'
	    },
	    '50%': {
	        transform: 'scaley(0.4)'
	    },
	    '100%': {
	        transform: 'scaley(1.0)'
	    }
	};
	
	/**
	 * @type {String}
	 */
	var animationName = insertKeyframesRule(keyframes);
	
	var Loader = React.createClass({
	    displayName: 'Loader',
	
	    /**
	     * @type {Object}
	     */
	    propTypes: {
	        loading: React.PropTypes.bool,
	        color: React.PropTypes.string,
	        height: React.PropTypes.string,
	        width: React.PropTypes.string,
	        margin: React.PropTypes.string,
	        radius: React.PropTypes.string
	    },
	
	    /**
	     * @return {Object}
	     */
	    getDefaultProps: function getDefaultProps() {
	        return {
	            loading: true,
	            color: '#ffffff',
	            height: '35px',
	            width: '4px',
	            margin: '2px',
	            radius: '2px'
	        };
	    },
	
	    /**
	     * @return {Object}
	     */
	    getLineStyle: function getLineStyle() {
	        return {
	            backgroundColor: this.props.color,
	            height: this.props.height,
	            width: this.props.width,
	            margin: this.props.margin,
	            borderRadius: this.props.radius,
	            verticalAlign: this.props.verticalAlign
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getAnimationStyle: function getAnimationStyle(i) {
	        var animation = [animationName, '1s', i * 0.1 + 's', 'infinite', 'cubic-bezier(.2,.68,.18,1.08)'].join(' ');
	        var animationFillMode = 'both';
	
	        return {
	            animation: animation,
	            animationFillMode: animationFillMode
	        };
	    },
	
	    /**
	     * @param  {Number} i
	     * @return {Object}
	     */
	    getStyle: function getStyle(i) {
	        return assign(this.getLineStyle(i), this.getAnimationStyle(i), {
	            display: 'inline-block'
	        });
	    },
	
	    /**
	     * @param  {Boolean} loading
	     * @return {ReactComponent || null}
	     */
	    renderLoader: function renderLoader(loading) {
	        if (loading) {
	            return React.createElement(
	                'div',
	                { id: this.props.id, className: this.props.className },
	                React.createElement('div', { style: this.getStyle(1) }),
	                React.createElement('div', { style: this.getStyle(2) }),
	                React.createElement('div', { style: this.getStyle(3) }),
	                React.createElement('div', { style: this.getStyle(4) }),
	                React.createElement('div', { style: this.getStyle(5) })
	            );
	        }
	
	        return null;
	    },
	
	    render: function render() {
	        return this.renderLoader(this.props.loading);
	    }
	});
	
	module.exports = Loader;

/***/ }),
/* 267 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CONFIDENCE_THRESHOLD = exports.CONFIDENCE_THRESHOLD = 0.1;
	var NOTICE_MESSAGE = exports.NOTICE_MESSAGE = "We are updating our servers to offer you a better experience. You may experience a momentary disruption in the performance because of the updating process. Don't worry, any disruption due to updating will not last more than two hours. Thank you for your understanding.";
	
	var host = exports.host = 'http://api.wide-eyes.it';
	var hostApiMirror = exports.hostApiMirror = 'http://v5.api-mirror.wide-eyes.it';
	var eventsHost = exports.eventsHost = 'http://events-engine.wide-eyes.it';
	var version = exports.version = "v3.2";
	var headers = exports.headers = {
	  'Accept': 'application/json',
	  'Content-Type': 'application/json'
	};
	
	var attributesMap = exports.attributesMap = {
	  tshirt: ['style', 'sleeve length', 'pattern type', 'color', 'neckline'],
	  skirt: ['style', 'silhouette', 'pattern type', 'color', 'clothes length', 'dress/skirt silhouette', 'dress/skirt length', 'embellishments'],
	  jeans: ['silhouette', 'color', 'pants silhouette', 'pattern type', 'pants length', 'embellishments', 'waist skirts/pants'],
	  'short pants': ['pants silhouette', 'pattern type', 'color', 'pants length', 'embellishments', 'waist skirts/pants'],
	  shorts: ['style', 'pattern type', 'color', 'clothes length', 'pants silhouette', 'pants length', 'embellishments', 'waist skirts/pants'],
	  cardigan: ['style', 'pattern type', 'color', 'neckline', 'sleeve length', 'tops silhouette', 'neckline shape', 'neckline depth', 'embellishments'],
	  basic: ['style', 'pattern type', 'color', 'toe shape'],
	  gladiator: ['style', 'pattern type', 'color', 'toe shape', 'heel height', 'heel type'],
	  'mary janes': ['style', 'pattern type', 'color', 'toe shape', 'heel height', 'heel type'],
	  slingbacks: ['style', 'pattern type', 'color', 'toe shape', 'heel height', 'heel type'],
	  top: ['style', 'sleeve length', 'pattern type', 'color', 'silhouette', 'neckline'],
	  tops: ['tops silhouette', 'sleeve length', 'pattern type', 'color', 'neckline depth', 'neckline shape'],
	  jacket: ['style', 'pattern type', 'color', 'neckline', 'sleeve length', 'embellishments'],
	  sweater: ['style', 'pattern type', 'color', 'neckline', 'sleeve length', 'tops silhouette', 'neckline shape', 'neckline depth', 'embellishments'],
	  dress: ['style', 'pattern type', 'color', 'neckline', 'sleeve length', 'silhouette', 'clothes length', 'neckline depth', 'embellishments', 'dress/skirt silhouette', 'dress/skirt length', 'neckline shape'],
	  shirt: ['style', 'pattern type', 'color', 'neckline', 'sleeve length', 'tops silhouette', 'neckline depth', 'neckline shape'],
	  'shoulder bag': ['style', 'pattern type', 'color'],
	  clutch: ['style', 'pattern type', 'color'],
	  bag: ['style', 'pattern type', 'color'],
	  'glasses/sunglasses': ['pattern type', 'color', 'embellishments'],
	  hats: ['pattern type', 'color', 'embellishments'],
	  jewelery: ['pattern type', 'color', 'embellishments'],
	  belts: ['pattern type', 'color', 'embellishments'],
	  'other accessories': ['pattern type', 'color', 'embellishments'],
	  backpack: ['style', 'pattern type', 'color', 'embellishments'],
	  duffle: ['style', 'pattern type', 'color'],
	  coat: ['style', 'pattern type', 'color', 'neckline', 'sleeve length'],
	  'coat/cape': ['sleeve length', 'pattern type', 'color', 'embellishments'],
	  'pump/wedge': ['pattern type', 'color', 'heel height', 'toe shape', 'heel style', 'embellishments'],
	  flat: ['pattern type', 'color', 'toe shape', 'embellishments'],
	  sandals: ['pattern type', 'color', 'heel height', 'toe shape', 'heel style', 'embellishments'],
	  boots: ['style', 'pattern type', 'color', 'toe shape', 'boot height', 'heel height', 'boot height', 'heel style'],
	  'riding boots': ['style', 'pattern type', 'color', 'toe shape', 'boot height', 'heel height'],
	  'snow boots': ['style', 'pattern type', 'color', 'toe shape', 'boot height', 'heel height'],
	  leggings: ['style', 'pattern type', 'color'],
	  cape: ['style', 'pattern type', 'color'],
	  pants: ['style', 'pattern type', 'color', 'pants silhouette', 'pants length', 'embellishments', 'waist skirts/pants'],
	  joggers: ['pants silhouette', 'pattern type', 'color', 'pants length', 'embellishments', 'waist skirts/pants'],
	  vest: ['sleeve length', 'pattern type', 'color', 'embellishments'],
	  blouse: ['style', 'sleeve length', 'pattern type', 'color', 'neckline'],
	  sweatshirt: ['style', 'sleeve length', 'pattern type', 'color'],
	  'baseball caps': ['style', 'pattern type', 'color'],
	  beanie: ['style', 'pattern type', 'color'],
	  beret: ['style', 'pattern type', 'color'],
	  'brimmed hat': ['style', 'color'],
	  'bucket hats': ['style', 'color'],
	  'trapper hat': ['style', 'color'],
	  visors: ['style', 'color'],
	  polo: ['tops silhouette', 'sleeve length', 'pattern type', 'color', 'neckline depth', 'neckline shape'],
	  suits: ['sleeve length', 'neckline depth', 'pattern type', 'color', 'embellishments', 'pants silhouette', 'pants length', 'neckline shape'],
	  jumpsuits: ['sleeve length', 'neckline depth', 'pattern type', 'color', 'embellishments', 'pants silhouette', 'pants length', 'neckline shape'],
	  blazer: ['style', 'sleeve length', 'pattern type', 'color', 'sleeve length', 'embellishments'],
	  'clutch/wallet': ['pattern type', 'color', 'embellishments'],
	  'crossbody/bagmessenges': ['pattern type', 'color', 'embellishments'],
	  'crossbody/bag': ['pattern type', 'color', 'embellishments'],
	  'crossbody/messenger': ['pattern type', 'color', 'embellishments'],
	  'briefcase': ['pattern type', 'color', 'embellishments'],
	  'top handles': ['pattern type', 'color', 'embellishments'],
	  'travel bags': ['pattern type', 'color', 'embellishments'],
	  'pants/leggings': ['pants silhouette', 'pattern type', 'color', 'pants length', 'embellishments', 'waist skirts/pants']
	};

/***/ }),
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _reduxActions = __webpack_require__(299);
	
	exports.toggleLoading = (0, _reduxActions.createAction)('TOGGLE_LOADING');
	exports.toggleCreateDetection = (0, _reduxActions.createAction)('TOGGLE_CREATE_DETECTION');

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleActions = exports.handleAction = exports.createAction = undefined;
	
	var _createAction = __webpack_require__(300);
	
	var _createAction2 = _interopRequireDefault(_createAction);
	
	var _handleAction = __webpack_require__(301);
	
	var _handleAction2 = _interopRequireDefault(_handleAction);
	
	var _handleActions = __webpack_require__(302);
	
	var _handleActions2 = _interopRequireDefault(_handleActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createAction = _createAction2.default;
	exports.handleAction = _handleAction2.default;
	exports.handleActions = _handleActions2.default;

/***/ }),
/* 300 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createAction;
	function identity(t) {
	  return t;
	}
	
	function createAction(type, actionCreator, metaCreator) {
	  var finalActionCreator = typeof actionCreator === 'function' ? actionCreator : identity;
	
	  var actionHandler = function actionHandler() {
	    var hasError = (arguments.length <= 0 ? undefined : arguments[0]) instanceof Error;
	
	    var action = {
	      type: type
	    };
	
	    var payload = hasError ? arguments.length <= 0 ? undefined : arguments[0] : finalActionCreator.apply(undefined, arguments);
	    if (!(payload === null || payload === undefined)) {
	      action.payload = payload;
	    }
	
	    if (hasError) {
	      // Handle FSA errors where the payload is an Error object. Set error.
	      action.error = true;
	    }
	
	    if (typeof metaCreator === 'function') {
	      action.meta = metaCreator.apply(undefined, arguments);
	    }
	
	    return action;
	  };
	
	  actionHandler.toString = function () {
	    return type;
	  };
	
	  return actionHandler;
	}

/***/ }),
/* 301 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = handleAction;
	function isFunction(val) {
	  return typeof val === 'function';
	}
	
	function handleAction(type, reducers, defaultState) {
	  var typeValue = isFunction(type) ? type.toString() : type;
	
	  return function () {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
	    var action = arguments[1];
	
	    // If action type does not match, return previous state
	    if (action.type !== typeValue) return state;
	
	    var handlerKey = action.error === true ? 'throw' : 'next';
	
	    // If function is passed instead of map, use as reducer
	    if (isFunction(reducers)) {
	      reducers.next = reducers.throw = reducers;
	    }
	
	    // Otherwise, assume an action map was passed
	    var reducer = reducers[handlerKey];
	
	    return isFunction(reducer) ? reducer(state, action) : state;
	  };
	}

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = handleActions;
	
	var _handleAction = __webpack_require__(301);
	
	var _handleAction2 = _interopRequireDefault(_handleAction);
	
	var _ownKeys = __webpack_require__(303);
	
	var _ownKeys2 = _interopRequireDefault(_ownKeys);
	
	var _reduceReducers = __webpack_require__(304);
	
	var _reduceReducers2 = _interopRequireDefault(_reduceReducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function handleActions(handlers, defaultState) {
	  var reducers = (0, _ownKeys2.default)(handlers).map(function (type) {
	    return (0, _handleAction2.default)(type, handlers[type]);
	  });
	  var reducer = _reduceReducers2.default.apply(undefined, _toConsumableArray(reducers));
	
	  return typeof defaultState !== 'undefined' ? function () {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
	    var action = arguments[1];
	    return reducer(state, action);
	  } : reducer;
	}

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownKeys;
	function ownKeys(object) {
	  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
	    return Reflect.ownKeys(object);
	  }
	
	  var keys = Object.getOwnPropertyNames(object);
	
	  if (typeof Object.getOwnPropertySymbols === 'function') {
	    keys = keys.concat(Object.getOwnPropertySymbols(object));
	  }
	
	  return keys;
	}

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = reduceReducers;
	
	function reduceReducers() {
	  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
	    reducers[_key] = arguments[_key];
	  }
	
	  return function (previous, current) {
	    return reducers.reduce(function (p, r) {
	      return r(p, current);
	    }, previous);
	  };
	}
	
	module.exports = exports["default"];

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getUser = exports.login = exports.logout = undefined;
	
	var _reduxActions = __webpack_require__(299);
	
	var logout = exports.logout = (0, _reduxActions.createAction)('USER_LOGGED_OUT');
	var login = exports.login = (0, _reduxActions.createAction)('USER_LOGIN_REQUESTED');
	var getUser = exports.getUser = (0, _reduxActions.createAction)('GET_USER_REQUESTED');

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isUserAuthenticated = undefined;
	
	var _reduxAuthWrapper = __webpack_require__(307);
	
	var isUserAuthenticated = exports.isUserAuthenticated = (0, _reduxAuthWrapper.UserAuthWrapper)({
	  authSelector: function authSelector(state) {
	    return state.user;
	  }, // how to get the user state
	  wrapperDisplayName: 'UserIsAuthenticated' // a nice name for this auth check
	});

/***/ }),
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _LOOK_TYPE_DESCRIPTIO;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var LOOK_ANNOTATED_TYPE = exports.LOOK_ANNOTATED_TYPE = 'lookProducts';
	var TWINNED_LOOK_TYPE = exports.TWINNED_LOOK_TYPE = 'twinnedLooksResults';
	var STYLE_ADVISOR_TYPE = exports.STYLE_ADVISOR_TYPE = 'styleAdvisorLook';
	
	var LOOK_TYPE_DESCRIPTION = exports.LOOK_TYPE_DESCRIPTION = (_LOOK_TYPE_DESCRIPTIO = {}, _defineProperty(_LOOK_TYPE_DESCRIPTIO, LOOK_ANNOTATED_TYPE, 'Look annotated'), _defineProperty(_LOOK_TYPE_DESCRIPTIO, TWINNED_LOOK_TYPE, 'Twinned look'), _defineProperty(_LOOK_TYPE_DESCRIPTIO, STYLE_ADVISOR_TYPE, 'Style advisor look'), _LOOK_TYPE_DESCRIPTIO);
	
	var LOOK_TYPE_ORDER = exports.LOOK_TYPE_ORDER = {
	  lookProducts: 1,
	  twinnedLooksResults: 2,
	  styleAdvisorLook: 3
	
	  // RT - Recommendation Types
	};var RECOMMENDATION_TYPES = exports.RECOMMENDATION_TYPES = {
	  PERFECT_MATCH: {
	    value: 'perfect_match',
	    description: 'Perfect Match'
	  },
	  SIMILAR: {
	    value: 'similar',
	    description: 'Similar'
	  },
	  MAYBE: {
	    value: 'maybe',
	    description: 'Maybe'
	  },
	  FITB: {
	    value: 'fitb',
	    description: 'Fitb'
	  },
	  NO: {
	    value: 'no',
	    description: 'No'
	  }
	};
	
	var RT_NO_CATREGORIES = exports.RT_NO_CATREGORIES = {
	  OUTWEAR: 'outwear',
	  TOP: 'top',
	  BOTTOM: 'bottom',
	  ONE_PIECE: 'one_piece',
	  SHOES: 'shoes',
	  BAG: 'bag',
	  ACCESSORIES: 'accessories'
	};
	
	var NEW_DETECTION_STR = exports.NEW_DETECTION_STR = 'New detection';
	var INTERNAL_REF = exports.INTERNAL_REF = 'internal_ref';

/***/ }),
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  'chunk': __webpack_require__(590),
	  'compact': __webpack_require__(603),
	  'concat': __webpack_require__(604),
	  'difference': __webpack_require__(612),
	  'differenceBy': __webpack_require__(665),
	  'differenceWith': __webpack_require__(726),
	  'drop': __webpack_require__(727),
	  'dropRight': __webpack_require__(728),
	  'dropRightWhile': __webpack_require__(729),
	  'dropWhile': __webpack_require__(731),
	  'fill': __webpack_require__(732),
	  'findIndex': __webpack_require__(736),
	  'findLastIndex': __webpack_require__(737),
	  'first': __webpack_require__(738),
	  'flatten': __webpack_require__(740),
	  'flattenDeep': __webpack_require__(741),
	  'flattenDepth': __webpack_require__(742),
	  'fromPairs': __webpack_require__(743),
	  'head': __webpack_require__(739),
	  'indexOf': __webpack_require__(744),
	  'initial': __webpack_require__(745),
	  'intersection': __webpack_require__(746),
	  'intersectionBy': __webpack_require__(749),
	  'intersectionWith': __webpack_require__(750),
	  'join': __webpack_require__(751),
	  'last': __webpack_require__(725),
	  'lastIndexOf': __webpack_require__(752),
	  'nth': __webpack_require__(754),
	  'pull': __webpack_require__(756),
	  'pullAll': __webpack_require__(757),
	  'pullAllBy': __webpack_require__(760),
	  'pullAllWith': __webpack_require__(761),
	  'pullAt': __webpack_require__(762),
	  'remove': __webpack_require__(769),
	  'reverse': __webpack_require__(770),
	  'slice': __webpack_require__(771),
	  'sortedIndex': __webpack_require__(772),
	  'sortedIndexBy': __webpack_require__(775),
	  'sortedIndexOf': __webpack_require__(776),
	  'sortedLastIndex': __webpack_require__(777),
	  'sortedLastIndexBy': __webpack_require__(778),
	  'sortedLastIndexOf': __webpack_require__(779),
	  'sortedUniq': __webpack_require__(780),
	  'sortedUniqBy': __webpack_require__(782),
	  'tail': __webpack_require__(783),
	  'take': __webpack_require__(784),
	  'takeRight': __webpack_require__(785),
	  'takeRightWhile': __webpack_require__(786),
	  'takeWhile': __webpack_require__(787),
	  'union': __webpack_require__(788),
	  'unionBy': __webpack_require__(792),
	  'unionWith': __webpack_require__(793),
	  'uniq': __webpack_require__(794),
	  'uniqBy': __webpack_require__(795),
	  'uniqWith': __webpack_require__(796),
	  'unzip': __webpack_require__(797),
	  'unzipWith': __webpack_require__(798),
	  'without': __webpack_require__(799),
	  'xor': __webpack_require__(800),
	  'xorBy': __webpack_require__(802),
	  'xorWith': __webpack_require__(803),
	  'zip': __webpack_require__(804),
	  'zipObject': __webpack_require__(805),
	  'zipObjectDeep': __webpack_require__(809),
	  'zipWith': __webpack_require__(811)
	};


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(591),
	    isIterateeCall = __webpack_require__(592),
	    toInteger = __webpack_require__(599);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * Creates an array of elements split into groups the length of `size`.
	 * If `array` can't be split evenly, the final chunk will be the remaining
	 * elements.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to process.
	 * @param {number} [size=1] The length of each chunk
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the new array of chunks.
	 * @example
	 *
	 * _.chunk(['a', 'b', 'c', 'd'], 2);
	 * // => [['a', 'b'], ['c', 'd']]
	 *
	 * _.chunk(['a', 'b', 'c', 'd'], 3);
	 * // => [['a', 'b', 'c'], ['d']]
	 */
	function chunk(array, size, guard) {
	  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	    size = 1;
	  } else {
	    size = nativeMax(toInteger(size), 0);
	  }
	  var length = array == null ? 0 : array.length;
	  if (!length || size < 1) {
	    return [];
	  }
	  var index = 0,
	      resIndex = 0,
	      result = Array(nativeCeil(length / size));
	
	  while (index < length) {
	    result[resIndex++] = baseSlice(array, index, (index += size));
	  }
	  return result;
	}
	
	module.exports = chunk;


/***/ }),
/* 591 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(593),
	    isArrayLike = __webpack_require__(594),
	    isIndex = __webpack_require__(598),
	    isObject = __webpack_require__(596);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 593 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(595),
	    isLength = __webpack_require__(597);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(280),
	    isObject = __webpack_require__(596);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 596 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 597 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 598 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(600);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(601);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(596),
	    isSymbol = __webpack_require__(602);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(280),
	    isObjectLike = __webpack_require__(288);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 603 */
/***/ (function(module, exports) {

	/**
	 * Creates an array with all falsey values removed. The values `false`, `null`,
	 * `0`, `""`, `undefined`, and `NaN` are falsey.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to compact.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.compact([0, 1, false, 2, '', 3]);
	 * // => [1, 2, 3]
	 */
	function compact(array) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = compact;


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(605),
	    baseFlatten = __webpack_require__(606),
	    copyArray = __webpack_require__(611),
	    isArray = __webpack_require__(610);
	
	/**
	 * Creates a new array concatenating `array` with any additional arrays
	 * and/or values.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to concatenate.
	 * @param {...*} [values] The values to concatenate.
	 * @returns {Array} Returns the new concatenated array.
	 * @example
	 *
	 * var array = [1];
	 * var other = _.concat(array, 2, [3], [[4]]);
	 *
	 * console.log(other);
	 * // => [1, 2, 3, [4]]
	 *
	 * console.log(array);
	 * // => [1]
	 */
	function concat() {
	  var length = arguments.length;
	  if (!length) {
	    return [];
	  }
	  var args = Array(length - 1),
	      array = arguments[0],
	      index = length;
	
	  while (index--) {
	    args[index - 1] = arguments[index];
	  }
	  return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	}
	
	module.exports = concat;


/***/ }),
/* 605 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(605),
	    isFlattenable = __webpack_require__(607);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(281),
	    isArguments = __webpack_require__(608),
	    isArray = __webpack_require__(610);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(609),
	    isObjectLike = __webpack_require__(288);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(280),
	    isObjectLike = __webpack_require__(288);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 610 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 611 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(613),
	    baseFlatten = __webpack_require__(606),
	    baseRest = __webpack_require__(655),
	    isArrayLikeObject = __webpack_require__(664);
	
	/**
	 * Creates an array of `array` values not included in the other given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * **Note:** Unlike `_.pullAll`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.without, _.xor
	 * @example
	 *
	 * _.difference([2, 1], [2, 3]);
	 * // => [1]
	 */
	var difference = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	    : [];
	});
	
	module.exports = difference;


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(614),
	    arrayIncludes = __webpack_require__(646),
	    arrayIncludesWith = __webpack_require__(651),
	    arrayMap = __webpack_require__(652),
	    baseUnary = __webpack_require__(653),
	    cacheHas = __webpack_require__(654);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(615),
	    setCacheAdd = __webpack_require__(644),
	    setCacheHas = __webpack_require__(645);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(616),
	    mapCacheDelete = __webpack_require__(638),
	    mapCacheGet = __webpack_require__(641),
	    mapCacheHas = __webpack_require__(642),
	    mapCacheSet = __webpack_require__(643);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(617),
	    ListCache = __webpack_require__(630),
	    Map = __webpack_require__(637);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(618),
	    hashDelete = __webpack_require__(626),
	    hashGet = __webpack_require__(627),
	    hashHas = __webpack_require__(628),
	    hashSet = __webpack_require__(629);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(619);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(620);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(621),
	    getValue = __webpack_require__(625);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(595),
	    isMasked = __webpack_require__(622),
	    isObject = __webpack_require__(596),
	    toSource = __webpack_require__(624);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(623);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(282);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 624 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 625 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 626 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(619);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(619);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(619);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(631),
	    listCacheDelete = __webpack_require__(632),
	    listCacheGet = __webpack_require__(634),
	    listCacheHas = __webpack_require__(635),
	    listCacheSet = __webpack_require__(636);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 631 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(633);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(593);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(633);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(633);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(633);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(620),
	    root = __webpack_require__(282);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(639);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(640);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 640 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(639);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(639);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(639);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 644 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 645 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(647);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(648),
	    baseIsNaN = __webpack_require__(649),
	    strictIndexOf = __webpack_require__(650);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 648 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 649 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),
/* 650 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ }),
/* 651 */
/***/ (function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ }),
/* 652 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 653 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 654 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(656),
	    overRest = __webpack_require__(657),
	    setToString = __webpack_require__(659);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 656 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(658);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 658 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(660),
	    shortOut = __webpack_require__(663);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(661),
	    defineProperty = __webpack_require__(662),
	    identity = __webpack_require__(656);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 661 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(620);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 663 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(594),
	    isObjectLike = __webpack_require__(288);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(613),
	    baseFlatten = __webpack_require__(606),
	    baseIteratee = __webpack_require__(666),
	    baseRest = __webpack_require__(655),
	    isArrayLikeObject = __webpack_require__(664),
	    last = __webpack_require__(725);
	
	/**
	 * This method is like `_.difference` except that it accepts `iteratee` which
	 * is invoked for each element of `array` and `values` to generate the criterion
	 * by which they're compared. The order and references of result values are
	 * determined by the first array. The iteratee is invoked with one argument:
	 * (value).
	 *
	 * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	 * // => [1.2]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	 * // => [{ 'x': 2 }]
	 */
	var differenceBy = baseRest(function(array, values) {
	  var iteratee = last(values);
	  if (isArrayLikeObject(iteratee)) {
	    iteratee = undefined;
	  }
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), baseIteratee(iteratee, 2))
	    : [];
	});
	
	module.exports = differenceBy;


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(667),
	    baseMatchesProperty = __webpack_require__(708),
	    identity = __webpack_require__(656),
	    isArray = __webpack_require__(610),
	    property = __webpack_require__(722);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(668),
	    getMatchData = __webpack_require__(705),
	    matchesStrictComparable = __webpack_require__(707);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(669),
	    baseIsEqual = __webpack_require__(675);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(630),
	    stackClear = __webpack_require__(670),
	    stackDelete = __webpack_require__(671),
	    stackGet = __webpack_require__(672),
	    stackHas = __webpack_require__(673),
	    stackSet = __webpack_require__(674);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(630);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 671 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 672 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 673 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(630),
	    Map = __webpack_require__(637),
	    MapCache = __webpack_require__(615);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(676),
	    isObjectLike = __webpack_require__(288);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(669),
	    equalArrays = __webpack_require__(677),
	    equalByTag = __webpack_require__(679),
	    equalObjects = __webpack_require__(683),
	    getTag = __webpack_require__(700),
	    isArray = __webpack_require__(610),
	    isBuffer = __webpack_require__(692),
	    isTypedArray = __webpack_require__(694);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(614),
	    arraySome = __webpack_require__(678),
	    cacheHas = __webpack_require__(654);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 678 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(281),
	    Uint8Array = __webpack_require__(680),
	    eq = __webpack_require__(593),
	    equalArrays = __webpack_require__(677),
	    mapToArray = __webpack_require__(681),
	    setToArray = __webpack_require__(682);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(282);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 681 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 682 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(684);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(685),
	    getSymbols = __webpack_require__(686),
	    keys = __webpack_require__(689);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(605),
	    isArray = __webpack_require__(610);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(687),
	    stubArray = __webpack_require__(688);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 687 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 688 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(690),
	    baseKeys = __webpack_require__(697),
	    isArrayLike = __webpack_require__(594);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(691),
	    isArguments = __webpack_require__(608),
	    isArray = __webpack_require__(610),
	    isBuffer = __webpack_require__(692),
	    isIndex = __webpack_require__(598),
	    isTypedArray = __webpack_require__(694);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 691 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(282),
	    stubFalse = __webpack_require__(693);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(291)(module)))

/***/ }),
/* 693 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(695),
	    baseUnary = __webpack_require__(653),
	    nodeUtil = __webpack_require__(696);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(280),
	    isLength = __webpack_require__(597),
	    isObjectLike = __webpack_require__(288);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(283);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(291)(module)))

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(698),
	    nativeKeys = __webpack_require__(699);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 698 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(287);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(701),
	    Map = __webpack_require__(637),
	    Promise = __webpack_require__(702),
	    Set = __webpack_require__(703),
	    WeakMap = __webpack_require__(704),
	    baseGetTag = __webpack_require__(280),
	    toSource = __webpack_require__(624);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(620),
	    root = __webpack_require__(282);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(620),
	    root = __webpack_require__(282);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(620),
	    root = __webpack_require__(282);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(620),
	    root = __webpack_require__(282);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(706),
	    keys = __webpack_require__(689);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(596);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 707 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(675),
	    get = __webpack_require__(709),
	    hasIn = __webpack_require__(719),
	    isKey = __webpack_require__(712),
	    isStrictComparable = __webpack_require__(706),
	    matchesStrictComparable = __webpack_require__(707),
	    toKey = __webpack_require__(718);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(710);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(711),
	    toKey = __webpack_require__(718);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(610),
	    isKey = __webpack_require__(712),
	    stringToPath = __webpack_require__(713),
	    toString = __webpack_require__(716);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(610),
	    isSymbol = __webpack_require__(602);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(714);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(715);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(615);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(717);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(281),
	    arrayMap = __webpack_require__(652),
	    isArray = __webpack_require__(610),
	    isSymbol = __webpack_require__(602);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(602);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(720),
	    hasPath = __webpack_require__(721);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 720 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(711),
	    isArguments = __webpack_require__(608),
	    isArray = __webpack_require__(610),
	    isIndex = __webpack_require__(598),
	    isLength = __webpack_require__(597),
	    toKey = __webpack_require__(718);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(723),
	    basePropertyDeep = __webpack_require__(724),
	    isKey = __webpack_require__(712),
	    toKey = __webpack_require__(718);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 723 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(710);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 725 */
/***/ (function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(613),
	    baseFlatten = __webpack_require__(606),
	    baseRest = __webpack_require__(655),
	    isArrayLikeObject = __webpack_require__(664),
	    last = __webpack_require__(725);
	
	/**
	 * This method is like `_.difference` except that it accepts `comparator`
	 * which is invoked to compare elements of `array` to `values`. The order and
	 * references of result values are determined by the first array. The comparator
	 * is invoked with two arguments: (arrVal, othVal).
	 *
	 * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	 *
	 * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	 * // => [{ 'x': 2, 'y': 1 }]
	 */
	var differenceWith = baseRest(function(array, values) {
	  var comparator = last(values);
	  if (isArrayLikeObject(comparator)) {
	    comparator = undefined;
	  }
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	    : [];
	});
	
	module.exports = differenceWith;


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(591),
	    toInteger = __webpack_require__(599);
	
	/**
	 * Creates a slice of `array` with `n` elements dropped from the beginning.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {number} [n=1] The number of elements to drop.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.drop([1, 2, 3]);
	 * // => [2, 3]
	 *
	 * _.drop([1, 2, 3], 2);
	 * // => [3]
	 *
	 * _.drop([1, 2, 3], 5);
	 * // => []
	 *
	 * _.drop([1, 2, 3], 0);
	 * // => [1, 2, 3]
	 */
	function drop(array, n, guard) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return [];
	  }
	  n = (guard || n === undefined) ? 1 : toInteger(n);
	  return baseSlice(array, n < 0 ? 0 : n, length);
	}
	
	module.exports = drop;


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(591),
	    toInteger = __webpack_require__(599);
	
	/**
	 * Creates a slice of `array` with `n` elements dropped from the end.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {number} [n=1] The number of elements to drop.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.dropRight([1, 2, 3]);
	 * // => [1, 2]
	 *
	 * _.dropRight([1, 2, 3], 2);
	 * // => [1]
	 *
	 * _.dropRight([1, 2, 3], 5);
	 * // => []
	 *
	 * _.dropRight([1, 2, 3], 0);
	 * // => [1, 2, 3]
	 */
	function dropRight(array, n, guard) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return [];
	  }
	  n = (guard || n === undefined) ? 1 : toInteger(n);
	  n = length - n;
	  return baseSlice(array, 0, n < 0 ? 0 : n);
	}
	
	module.exports = dropRight;


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(666),
	    baseWhile = __webpack_require__(730);
	
	/**
	 * Creates a slice of `array` excluding elements dropped from the end.
	 * Elements are dropped until `predicate` returns falsey. The predicate is
	 * invoked with three arguments: (value, index, array).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': true },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': false }
	 * ];
	 *
	 * _.dropRightWhile(users, function(o) { return !o.active; });
	 * // => objects for ['barney']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	 * // => objects for ['barney', 'fred']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.dropRightWhile(users, ['active', false]);
	 * // => objects for ['barney']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.dropRightWhile(users, 'active');
	 * // => objects for ['barney', 'fred', 'pebbles']
	 */
	function dropRightWhile(array, predicate) {
	  return (array && array.length)
	    ? baseWhile(array, baseIteratee(predicate, 3), true, true)
	    : [];
	}
	
	module.exports = dropRightWhile;


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(591);
	
	/**
	 * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	 * without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to query.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseWhile(array, predicate, isDrop, fromRight) {
	  var length = array.length,
	      index = fromRight ? length : -1;
	
	  while ((fromRight ? index-- : ++index < length) &&
	    predicate(array[index], index, array)) {}
	
	  return isDrop
	    ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	    : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	}
	
	module.exports = baseWhile;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(666),
	    baseWhile = __webpack_require__(730);
	
	/**
	 * Creates a slice of `array` excluding elements dropped from the beginning.
	 * Elements are dropped until `predicate` returns falsey. The predicate is
	 * invoked with three arguments: (value, index, array).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.dropWhile(users, function(o) { return !o.active; });
	 * // => objects for ['pebbles']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.dropWhile(users, { 'user': 'barney', 'active': false });
	 * // => objects for ['fred', 'pebbles']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.dropWhile(users, ['active', false]);
	 * // => objects for ['pebbles']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.dropWhile(users, 'active');
	 * // => objects for ['barney', 'fred', 'pebbles']
	 */
	function dropWhile(array, predicate) {
	  return (array && array.length)
	    ? baseWhile(array, baseIteratee(predicate, 3), true)
	    : [];
	}
	
	module.exports = dropWhile;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFill = __webpack_require__(733),
	    isIterateeCall = __webpack_require__(592);
	
	/**
	 * Fills elements of `array` with `value` from `start` up to, but not
	 * including, `end`.
	 *
	 * **Note:** This method mutates `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.2.0
	 * @category Array
	 * @param {Array} array The array to fill.
	 * @param {*} value The value to fill `array` with.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns `array`.
	 * @example
	 *
	 * var array = [1, 2, 3];
	 *
	 * _.fill(array, 'a');
	 * console.log(array);
	 * // => ['a', 'a', 'a']
	 *
	 * _.fill(Array(3), 2);
	 * // => [2, 2, 2]
	 *
	 * _.fill([4, 6, 8, 10], '*', 1, 3);
	 * // => [4, '*', '*', 10]
	 */
	function fill(array, value, start, end) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return [];
	  }
	  if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	    start = 0;
	    end = length;
	  }
	  return baseFill(array, value, start, end);
	}
	
	module.exports = fill;


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(599),
	    toLength = __webpack_require__(734);
	
	/**
	 * The base implementation of `_.fill` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to fill.
	 * @param {*} value The value to fill `array` with.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns `array`.
	 */
	function baseFill(array, value, start, end) {
	  var length = array.length;
	
	  start = toInteger(start);
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = (end === undefined || end > length) ? length : toInteger(end);
	  if (end < 0) {
	    end += length;
	  }
	  end = start > end ? 0 : toLength(end);
	  while (start < end) {
	    array[start++] = value;
	  }
	  return array;
	}
	
	module.exports = baseFill;


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(735),
	    toInteger = __webpack_require__(599);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Converts `value` to an integer suitable for use as the length of an
	 * array-like object.
	 *
	 * **Note:** This method is based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toLength(3.2);
	 * // => 3
	 *
	 * _.toLength(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toLength(Infinity);
	 * // => 4294967295
	 *
	 * _.toLength('3.2');
	 * // => 3
	 */
	function toLength(value) {
	  return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	}
	
	module.exports = toLength;


/***/ }),
/* 735 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.clamp` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {number} number The number to clamp.
	 * @param {number} [lower] The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the clamped number.
	 */
	function baseClamp(number, lower, upper) {
	  if (number === number) {
	    if (upper !== undefined) {
	      number = number <= upper ? number : upper;
	    }
	    if (lower !== undefined) {
	      number = number >= lower ? number : lower;
	    }
	  }
	  return number;
	}
	
	module.exports = baseClamp;


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(648),
	    baseIteratee = __webpack_require__(666),
	    toInteger = __webpack_require__(599);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(648),
	    baseIteratee = __webpack_require__(666),
	    toInteger = __webpack_require__(599);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * This method is like `_.findIndex` except that it iterates over elements
	 * of `collection` from right to left.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=array.length-1] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': true },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': false }
	 * ];
	 *
	 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	 * // => 2
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	 * // => 0
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findLastIndex(users, ['active', false]);
	 * // => 2
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findLastIndex(users, 'active');
	 * // => 0
	 */
	function findLastIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = length - 1;
	  if (fromIndex !== undefined) {
	    index = toInteger(fromIndex);
	    index = fromIndex < 0
	      ? nativeMax(length + index, 0)
	      : nativeMin(index, length - 1);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index, true);
	}
	
	module.exports = findLastIndex;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(739);


/***/ }),
/* 739 */
/***/ (function(module, exports) {

	/**
	 * Gets the first element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias first
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the first element of `array`.
	 * @example
	 *
	 * _.head([1, 2, 3]);
	 * // => 1
	 *
	 * _.head([]);
	 * // => undefined
	 */
	function head(array) {
	  return (array && array.length) ? array[0] : undefined;
	}
	
	module.exports = head;


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(606);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(606);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Recursively flattens `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flattenDeep([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, 3, 4, 5]
	 */
	function flattenDeep(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, INFINITY) : [];
	}
	
	module.exports = flattenDeep;


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(606),
	    toInteger = __webpack_require__(599);
	
	/**
	 * Recursively flatten `array` up to `depth` times.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.4.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @param {number} [depth=1] The maximum recursion depth.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * var array = [1, [2, [3, [4]], 5]];
	 *
	 * _.flattenDepth(array, 1);
	 * // => [1, 2, [3, [4]], 5]
	 *
	 * _.flattenDepth(array, 2);
	 * // => [1, 2, 3, [4], 5]
	 */
	function flattenDepth(array, depth) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return [];
	  }
	  depth = depth === undefined ? 1 : toInteger(depth);
	  return baseFlatten(array, depth);
	}
	
	module.exports = flattenDepth;


/***/ }),
/* 743 */
/***/ (function(module, exports) {

	/**
	 * The inverse of `_.toPairs`; this method returns an object composed
	 * from key-value `pairs`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} pairs The key-value pairs.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * _.fromPairs([['a', 1], ['b', 2]]);
	 * // => { 'a': 1, 'b': 2 }
	 */
	function fromPairs(pairs) {
	  var index = -1,
	      length = pairs == null ? 0 : pairs.length,
	      result = {};
	
	  while (++index < length) {
	    var pair = pairs[index];
	    result[pair[0]] = pair[1];
	  }
	  return result;
	}
	
	module.exports = fromPairs;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(647),
	    toInteger = __webpack_require__(599);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Gets the index at which the first occurrence of `value` is found in `array`
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. If `fromIndex` is negative, it's used as the
	 * offset from the end of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 * @example
	 *
	 * _.indexOf([1, 2, 1, 2], 2);
	 * // => 1
	 *
	 * // Search from the `fromIndex`.
	 * _.indexOf([1, 2, 1, 2], 2, 2);
	 * // => 3
	 */
	function indexOf(array, value, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseIndexOf(array, value, index);
	}
	
	module.exports = indexOf;


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(591);
	
	/**
	 * Gets all but the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.initial([1, 2, 3]);
	 * // => [1, 2]
	 */
	function initial(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseSlice(array, 0, -1) : [];
	}
	
	module.exports = initial;


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(652),
	    baseIntersection = __webpack_require__(747),
	    baseRest = __webpack_require__(655),
	    castArrayLikeObject = __webpack_require__(748);
	
	/**
	 * Creates an array of unique values that are included in all given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of intersecting values.
	 * @example
	 *
	 * _.intersection([2, 1], [2, 3]);
	 * // => [2]
	 */
	var intersection = baseRest(function(arrays) {
	  var mapped = arrayMap(arrays, castArrayLikeObject);
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped)
	    : [];
	});
	
	module.exports = intersection;


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(614),
	    arrayIncludes = __webpack_require__(646),
	    arrayIncludesWith = __webpack_require__(651),
	    arrayMap = __webpack_require__(652),
	    baseUnary = __webpack_require__(653),
	    cacheHas = __webpack_require__(654);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * The base implementation of methods like `_.intersection`, without support
	 * for iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 */
	function baseIntersection(arrays, iteratee, comparator) {
	  var includes = comparator ? arrayIncludesWith : arrayIncludes,
	      length = arrays[0].length,
	      othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(othLength),
	      maxLength = Infinity,
	      result = [];
	
	  while (othIndex--) {
	    var array = arrays[othIndex];
	    if (othIndex && iteratee) {
	      array = arrayMap(array, baseUnary(iteratee));
	    }
	    maxLength = nativeMin(array.length, maxLength);
	    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	      ? new SetCache(othIndex && array)
	      : undefined;
	  }
	  array = arrays[0];
	
	  var index = -1,
	      seen = caches[0];
	
	  outer:
	  while (++index < length && result.length < maxLength) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (!(seen
	          ? cacheHas(seen, computed)
	          : includes(result, computed, comparator)
	        )) {
	      othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if (!(cache
	              ? cacheHas(cache, computed)
	              : includes(arrays[othIndex], computed, comparator))
	            ) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseIntersection;


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(664);
	
	/**
	 * Casts `value` to an empty array if it's not an array like object.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array|Object} Returns the cast array-like object.
	 */
	function castArrayLikeObject(value) {
	  return isArrayLikeObject(value) ? value : [];
	}
	
	module.exports = castArrayLikeObject;


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(652),
	    baseIntersection = __webpack_require__(747),
	    baseIteratee = __webpack_require__(666),
	    baseRest = __webpack_require__(655),
	    castArrayLikeObject = __webpack_require__(748),
	    last = __webpack_require__(725);
	
	/**
	 * This method is like `_.intersection` except that it accepts `iteratee`
	 * which is invoked for each element of each `arrays` to generate the criterion
	 * by which they're compared. The order and references of result values are
	 * determined by the first array. The iteratee is invoked with one argument:
	 * (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Array} Returns the new array of intersecting values.
	 * @example
	 *
	 * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	 * // => [2.1]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }]
	 */
	var intersectionBy = baseRest(function(arrays) {
	  var iteratee = last(arrays),
	      mapped = arrayMap(arrays, castArrayLikeObject);
	
	  if (iteratee === last(mapped)) {
	    iteratee = undefined;
	  } else {
	    mapped.pop();
	  }
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped, baseIteratee(iteratee, 2))
	    : [];
	});
	
	module.exports = intersectionBy;


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(652),
	    baseIntersection = __webpack_require__(747),
	    baseRest = __webpack_require__(655),
	    castArrayLikeObject = __webpack_require__(748),
	    last = __webpack_require__(725);
	
	/**
	 * This method is like `_.intersection` except that it accepts `comparator`
	 * which is invoked to compare elements of `arrays`. The order and references
	 * of result values are determined by the first array. The comparator is
	 * invoked with two arguments: (arrVal, othVal).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of intersecting values.
	 * @example
	 *
	 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	 *
	 * _.intersectionWith(objects, others, _.isEqual);
	 * // => [{ 'x': 1, 'y': 2 }]
	 */
	var intersectionWith = baseRest(function(arrays) {
	  var comparator = last(arrays),
	      mapped = arrayMap(arrays, castArrayLikeObject);
	
	  comparator = typeof comparator == 'function' ? comparator : undefined;
	  if (comparator) {
	    mapped.pop();
	  }
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped, undefined, comparator)
	    : [];
	});
	
	module.exports = intersectionWith;


/***/ }),
/* 751 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeJoin = arrayProto.join;
	
	/**
	 * Converts all elements in `array` into a string separated by `separator`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to convert.
	 * @param {string} [separator=','] The element separator.
	 * @returns {string} Returns the joined string.
	 * @example
	 *
	 * _.join(['a', 'b', 'c'], '~');
	 * // => 'a~b~c'
	 */
	function join(array, separator) {
	  return array == null ? '' : nativeJoin.call(array, separator);
	}
	
	module.exports = join;


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(648),
	    baseIsNaN = __webpack_require__(649),
	    strictLastIndexOf = __webpack_require__(753),
	    toInteger = __webpack_require__(599);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * This method is like `_.indexOf` except that it iterates over elements of
	 * `array` from right to left.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=array.length-1] The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 * @example
	 *
	 * _.lastIndexOf([1, 2, 1, 2], 2);
	 * // => 3
	 *
	 * // Search from the `fromIndex`.
	 * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	 * // => 1
	 */
	function lastIndexOf(array, value, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = length;
	  if (fromIndex !== undefined) {
	    index = toInteger(fromIndex);
	    index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	  }
	  return value === value
	    ? strictLastIndexOf(array, value, index)
	    : baseFindIndex(array, baseIsNaN, index, true);
	}
	
	module.exports = lastIndexOf;


/***/ }),
/* 753 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.lastIndexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictLastIndexOf(array, value, fromIndex) {
	  var index = fromIndex + 1;
	  while (index--) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return index;
	}
	
	module.exports = strictLastIndexOf;


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	var baseNth = __webpack_require__(755),
	    toInteger = __webpack_require__(599);
	
	/**
	 * Gets the element at index `n` of `array`. If `n` is negative, the nth
	 * element from the end is returned.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.11.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {number} [n=0] The index of the element to return.
	 * @returns {*} Returns the nth element of `array`.
	 * @example
	 *
	 * var array = ['a', 'b', 'c', 'd'];
	 *
	 * _.nth(array, 1);
	 * // => 'b'
	 *
	 * _.nth(array, -2);
	 * // => 'c';
	 */
	function nth(array, n) {
	  return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	}
	
	module.exports = nth;


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	var isIndex = __webpack_require__(598);
	
	/**
	 * The base implementation of `_.nth` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {Array} array The array to query.
	 * @param {number} n The index of the element to return.
	 * @returns {*} Returns the nth element of `array`.
	 */
	function baseNth(array, n) {
	  var length = array.length;
	  if (!length) {
	    return;
	  }
	  n += n < 0 ? length : 0;
	  return isIndex(n, length) ? array[n] : undefined;
	}
	
	module.exports = baseNth;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(655),
	    pullAll = __webpack_require__(757);
	
	/**
	 * Removes all given values from `array` using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	 * to remove elements from an array by predicate.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Array
	 * @param {Array} array The array to modify.
	 * @param {...*} [values] The values to remove.
	 * @returns {Array} Returns `array`.
	 * @example
	 *
	 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	 *
	 * _.pull(array, 'a', 'c');
	 * console.log(array);
	 * // => ['b', 'b']
	 */
	var pull = baseRest(pullAll);
	
	module.exports = pull;


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	var basePullAll = __webpack_require__(758);
	
	/**
	 * This method is like `_.pull` except that it accepts an array of values to remove.
	 *
	 * **Note:** Unlike `_.difference`, this method mutates `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to remove.
	 * @returns {Array} Returns `array`.
	 * @example
	 *
	 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	 *
	 * _.pullAll(array, ['a', 'c']);
	 * console.log(array);
	 * // => ['b', 'b']
	 */
	function pullAll(array, values) {
	  return (array && array.length && values && values.length)
	    ? basePullAll(array, values)
	    : array;
	}
	
	module.exports = pullAll;


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(652),
	    baseIndexOf = __webpack_require__(647),
	    baseIndexOfWith = __webpack_require__(759),
	    baseUnary = __webpack_require__(653),
	    copyArray = __webpack_require__(611);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * The base implementation of `_.pullAllBy` without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to remove.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns `array`.
	 */
	function basePullAll(array, values, iteratee, comparator) {
	  var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	      index = -1,
	      length = values.length,
	      seen = array;
	
	  if (array === values) {
	    values = copyArray(values);
	  }
	  if (iteratee) {
	    seen = arrayMap(array, baseUnary(iteratee));
	  }
	  while (++index < length) {
	    var fromIndex = 0,
	        value = values[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	      if (seen !== array) {
	        splice.call(seen, fromIndex, 1);
	      }
	      splice.call(array, fromIndex, 1);
	    }
	  }
	  return array;
	}
	
	module.exports = basePullAll;


/***/ }),
/* 759 */
/***/ (function(module, exports) {

	/**
	 * This function is like `baseIndexOf` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOfWith(array, value, fromIndex, comparator) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (comparator(array[index], value)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseIndexOfWith;


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(666),
	    basePullAll = __webpack_require__(758);
	
	/**
	 * This method is like `_.pullAll` except that it accepts `iteratee` which is
	 * invoked for each element of `array` and `values` to generate the criterion
	 * by which they're compared. The iteratee is invoked with one argument: (value).
	 *
	 * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to remove.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Array} Returns `array`.
	 * @example
	 *
	 * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	 *
	 * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	 * console.log(array);
	 * // => [{ 'x': 2 }]
	 */
	function pullAllBy(array, values, iteratee) {
	  return (array && array.length && values && values.length)
	    ? basePullAll(array, values, baseIteratee(iteratee, 2))
	    : array;
	}
	
	module.exports = pullAllBy;


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	var basePullAll = __webpack_require__(758);
	
	/**
	 * This method is like `_.pullAll` except that it accepts `comparator` which
	 * is invoked to compare elements of `array` to `values`. The comparator is
	 * invoked with two arguments: (arrVal, othVal).
	 *
	 * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.6.0
	 * @category Array
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to remove.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns `array`.
	 * @example
	 *
	 * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	 *
	 * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	 * console.log(array);
	 * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	 */
	function pullAllWith(array, values, comparator) {
	  return (array && array.length && values && values.length)
	    ? basePullAll(array, values, undefined, comparator)
	    : array;
	}
	
	module.exports = pullAllWith;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(652),
	    baseAt = __webpack_require__(763),
	    basePullAt = __webpack_require__(764),
	    compareAscending = __webpack_require__(767),
	    flatRest = __webpack_require__(768),
	    isIndex = __webpack_require__(598);
	
	/**
	 * Removes elements from `array` corresponding to `indexes` and returns an
	 * array of removed elements.
	 *
	 * **Note:** Unlike `_.at`, this method mutates `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to modify.
	 * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	 * @returns {Array} Returns the new array of removed elements.
	 * @example
	 *
	 * var array = ['a', 'b', 'c', 'd'];
	 * var pulled = _.pullAt(array, [1, 3]);
	 *
	 * console.log(array);
	 * // => ['a', 'c']
	 *
	 * console.log(pulled);
	 * // => ['b', 'd']
	 */
	var pullAt = flatRest(function(array, indexes) {
	  var length = array == null ? 0 : array.length,
	      result = baseAt(array, indexes);
	
	  basePullAt(array, arrayMap(indexes, function(index) {
	    return isIndex(index, length) ? +index : index;
	  }).sort(compareAscending));
	
	  return result;
	});
	
	module.exports = pullAt;


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	var get = __webpack_require__(709);
	
	/**
	 * The base implementation of `_.at` without support for individual paths.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {string[]} paths The property paths to pick.
	 * @returns {Array} Returns the picked elements.
	 */
	function baseAt(object, paths) {
	  var index = -1,
	      length = paths.length,
	      result = Array(length),
	      skip = object == null;
	
	  while (++index < length) {
	    result[index] = skip ? undefined : get(object, paths[index]);
	  }
	  return result;
	}
	
	module.exports = baseAt;


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	var baseUnset = __webpack_require__(765),
	    isIndex = __webpack_require__(598);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * The base implementation of `_.pullAt` without support for individual
	 * indexes or capturing the removed elements.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {number[]} indexes The indexes of elements to remove.
	 * @returns {Array} Returns `array`.
	 */
	function basePullAt(array, indexes) {
	  var length = array ? indexes.length : 0,
	      lastIndex = length - 1;
	
	  while (length--) {
	    var index = indexes[length];
	    if (length == lastIndex || index !== previous) {
	      var previous = index;
	      if (isIndex(index)) {
	        splice.call(array, index, 1);
	      } else {
	        baseUnset(array, index);
	      }
	    }
	  }
	  return array;
	}
	
	module.exports = basePullAt;


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(711),
	    last = __webpack_require__(725),
	    parent = __webpack_require__(766),
	    toKey = __webpack_require__(718);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(710),
	    baseSlice = __webpack_require__(591);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(602);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(740),
	    overRest = __webpack_require__(657),
	    setToString = __webpack_require__(659);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(666),
	    basePullAt = __webpack_require__(764);
	
	/**
	 * Removes all elements from `array` that `predicate` returns truthy for
	 * and returns an array of the removed elements. The predicate is invoked
	 * with three arguments: (value, index, array).
	 *
	 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	 * to pull elements from an array by value.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Array
	 * @param {Array} array The array to modify.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new array of removed elements.
	 * @example
	 *
	 * var array = [1, 2, 3, 4];
	 * var evens = _.remove(array, function(n) {
	 *   return n % 2 == 0;
	 * });
	 *
	 * console.log(array);
	 * // => [1, 3]
	 *
	 * console.log(evens);
	 * // => [2, 4]
	 */
	function remove(array, predicate) {
	  var result = [];
	  if (!(array && array.length)) {
	    return result;
	  }
	  var index = -1,
	      indexes = [],
	      length = array.length;
	
	  predicate = baseIteratee(predicate, 3);
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result.push(value);
	      indexes.push(index);
	    }
	  }
	  basePullAt(array, indexes);
	  return result;
	}
	
	module.exports = remove;


/***/ }),
/* 770 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeReverse = arrayProto.reverse;
	
	/**
	 * Reverses `array` so that the first element becomes the last, the second
	 * element becomes the second to last, and so on.
	 *
	 * **Note:** This method mutates `array` and is based on
	 * [`Array#reverse`](https://mdn.io/Array/reverse).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to modify.
	 * @returns {Array} Returns `array`.
	 * @example
	 *
	 * var array = [1, 2, 3];
	 *
	 * _.reverse(array);
	 * // => [3, 2, 1]
	 *
	 * console.log(array);
	 * // => [3, 2, 1]
	 */
	function reverse(array) {
	  return array == null ? array : nativeReverse.call(array);
	}
	
	module.exports = reverse;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(591),
	    isIterateeCall = __webpack_require__(592),
	    toInteger = __webpack_require__(599);
	
	/**
	 * Creates a slice of `array` from `start` up to, but not including, `end`.
	 *
	 * **Note:** This method is used instead of
	 * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	 * returned.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function slice(array, start, end) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return [];
	  }
	  if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	    start = 0;
	    end = length;
	  }
	  else {
	    start = start == null ? 0 : toInteger(start);
	    end = end === undefined ? length : toInteger(end);
	  }
	  return baseSlice(array, start, end);
	}
	
	module.exports = slice;


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSortedIndex = __webpack_require__(773);
	
	/**
	 * Uses a binary search to determine the lowest index at which `value`
	 * should be inserted into `array` in order to maintain its sort order.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The sorted array to inspect.
	 * @param {*} value The value to evaluate.
	 * @returns {number} Returns the index at which `value` should be inserted
	 *  into `array`.
	 * @example
	 *
	 * _.sortedIndex([30, 50], 40);
	 * // => 1
	 */
	function sortedIndex(array, value) {
	  return baseSortedIndex(array, value);
	}
	
	module.exports = sortedIndex;


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSortedIndexBy = __webpack_require__(774),
	    identity = __webpack_require__(656),
	    isSymbol = __webpack_require__(602);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295,
	    HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	/**
	 * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	 * performs a binary search of `array` to determine the index at which `value`
	 * should be inserted into `array` in order to maintain its sort order.
	 *
	 * @private
	 * @param {Array} array The sorted array to inspect.
	 * @param {*} value The value to evaluate.
	 * @param {boolean} [retHighest] Specify returning the highest qualified index.
	 * @returns {number} Returns the index at which `value` should be inserted
	 *  into `array`.
	 */
	function baseSortedIndex(array, value, retHighest) {
	  var low = 0,
	      high = array == null ? low : array.length;
	
	  if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	    while (low < high) {
	      var mid = (low + high) >>> 1,
	          computed = array[mid];
	
	      if (computed !== null && !isSymbol(computed) &&
	          (retHighest ? (computed <= value) : (computed < value))) {
	        low = mid + 1;
	      } else {
	        high = mid;
	      }
	    }
	    return high;
	  }
	  return baseSortedIndexBy(array, value, identity, retHighest);
	}
	
	module.exports = baseSortedIndex;


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(602);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295,
	    MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeFloor = Math.floor,
	    nativeMin = Math.min;
	
	/**
	 * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	 * which invokes `iteratee` for `value` and each element of `array` to compute
	 * their sort ranking. The iteratee is invoked with one argument; (value).
	 *
	 * @private
	 * @param {Array} array The sorted array to inspect.
	 * @param {*} value The value to evaluate.
	 * @param {Function} iteratee The iteratee invoked per element.
	 * @param {boolean} [retHighest] Specify returning the highest qualified index.
	 * @returns {number} Returns the index at which `value` should be inserted
	 *  into `array`.
	 */
	function baseSortedIndexBy(array, value, iteratee, retHighest) {
	  value = iteratee(value);
	
	  var low = 0,
	      high = array == null ? 0 : array.length,
	      valIsNaN = value !== value,
	      valIsNull = value === null,
	      valIsSymbol = isSymbol(value),
	      valIsUndefined = value === undefined;
	
	  while (low < high) {
	    var mid = nativeFloor((low + high) / 2),
	        computed = iteratee(array[mid]),
	        othIsDefined = computed !== undefined,
	        othIsNull = computed === null,
	        othIsReflexive = computed === computed,
	        othIsSymbol = isSymbol(computed);
	
	    if (valIsNaN) {
	      var setLow = retHighest || othIsReflexive;
	    } else if (valIsUndefined) {
	      setLow = othIsReflexive && (retHighest || othIsDefined);
	    } else if (valIsNull) {
	      setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	    } else if (valIsSymbol) {
	      setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	    } else if (othIsNull || othIsSymbol) {
	      setLow = false;
	    } else {
	      setLow = retHighest ? (computed <= value) : (computed < value);
	    }
	    if (setLow) {
	      low = mid + 1;
	    } else {
	      high = mid;
	    }
	  }
	  return nativeMin(high, MAX_ARRAY_INDEX);
	}
	
	module.exports = baseSortedIndexBy;


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(666),
	    baseSortedIndexBy = __webpack_require__(774);
	
	/**
	 * This method is like `_.sortedIndex` except that it accepts `iteratee`
	 * which is invoked for `value` and each element of `array` to compute their
	 * sort ranking. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The sorted array to inspect.
	 * @param {*} value The value to evaluate.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {number} Returns the index at which `value` should be inserted
	 *  into `array`.
	 * @example
	 *
	 * var objects = [{ 'x': 4 }, { 'x': 5 }];
	 *
	 * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	 * // => 0
	 */
	function sortedIndexBy(array, value, iteratee) {
	  return baseSortedIndexBy(array, value, baseIteratee(iteratee, 2));
	}
	
	module.exports = sortedIndexBy;


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSortedIndex = __webpack_require__(773),
	    eq = __webpack_require__(593);
	
	/**
	 * This method is like `_.indexOf` except that it performs a binary
	 * search on a sorted `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 * @example
	 *
	 * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	 * // => 1
	 */
	function sortedIndexOf(array, value) {
	  var length = array == null ? 0 : array.length;
	  if (length) {
	    var index = baseSortedIndex(array, value);
	    if (index < length && eq(array[index], value)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = sortedIndexOf;


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSortedIndex = __webpack_require__(773);
	
	/**
	 * This method is like `_.sortedIndex` except that it returns the highest
	 * index at which `value` should be inserted into `array` in order to
	 * maintain its sort order.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The sorted array to inspect.
	 * @param {*} value The value to evaluate.
	 * @returns {number} Returns the index at which `value` should be inserted
	 *  into `array`.
	 * @example
	 *
	 * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	 * // => 4
	 */
	function sortedLastIndex(array, value) {
	  return baseSortedIndex(array, value, true);
	}
	
	module.exports = sortedLastIndex;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(666),
	    baseSortedIndexBy = __webpack_require__(774);
	
	/**
	 * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	 * which is invoked for `value` and each element of `array` to compute their
	 * sort ranking. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The sorted array to inspect.
	 * @param {*} value The value to evaluate.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {number} Returns the index at which `value` should be inserted
	 *  into `array`.
	 * @example
	 *
	 * var objects = [{ 'x': 4 }, { 'x': 5 }];
	 *
	 * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	 * // => 1
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	 * // => 1
	 */
	function sortedLastIndexBy(array, value, iteratee) {
	  return baseSortedIndexBy(array, value, baseIteratee(iteratee, 2), true);
	}
	
	module.exports = sortedLastIndexBy;


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSortedIndex = __webpack_require__(773),
	    eq = __webpack_require__(593);
	
	/**
	 * This method is like `_.lastIndexOf` except that it performs a binary
	 * search on a sorted `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 * @example
	 *
	 * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	 * // => 3
	 */
	function sortedLastIndexOf(array, value) {
	  var length = array == null ? 0 : array.length;
	  if (length) {
	    var index = baseSortedIndex(array, value, true) - 1;
	    if (eq(array[index], value)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = sortedLastIndexOf;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSortedUniq = __webpack_require__(781);
	
	/**
	 * This method is like `_.uniq` except that it's designed and optimized
	 * for sorted arrays.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.sortedUniq([1, 1, 2]);
	 * // => [1, 2]
	 */
	function sortedUniq(array) {
	  return (array && array.length)
	    ? baseSortedUniq(array)
	    : [];
	}
	
	module.exports = sortedUniq;


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(593);
	
	/**
	 * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseSortedUniq(array, iteratee) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    if (!index || !eq(computed, seen)) {
	      var seen = computed;
	      result[resIndex++] = value === 0 ? 0 : value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseSortedUniq;


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(666),
	    baseSortedUniq = __webpack_require__(781);
	
	/**
	 * This method is like `_.uniqBy` except that it's designed and optimized
	 * for sorted arrays.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	 * // => [1.1, 2.3]
	 */
	function sortedUniqBy(array, iteratee) {
	  return (array && array.length)
	    ? baseSortedUniq(array, baseIteratee(iteratee, 2))
	    : [];
	}
	
	module.exports = sortedUniqBy;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(591);
	
	/**
	 * Gets all but the first element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.tail([1, 2, 3]);
	 * // => [2, 3]
	 */
	function tail(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseSlice(array, 1, length) : [];
	}
	
	module.exports = tail;


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(591),
	    toInteger = __webpack_require__(599);
	
	/**
	 * Creates a slice of `array` with `n` elements taken from the beginning.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {number} [n=1] The number of elements to take.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.take([1, 2, 3]);
	 * // => [1]
	 *
	 * _.take([1, 2, 3], 2);
	 * // => [1, 2]
	 *
	 * _.take([1, 2, 3], 5);
	 * // => [1, 2, 3]
	 *
	 * _.take([1, 2, 3], 0);
	 * // => []
	 */
	function take(array, n, guard) {
	  if (!(array && array.length)) {
	    return [];
	  }
	  n = (guard || n === undefined) ? 1 : toInteger(n);
	  return baseSlice(array, 0, n < 0 ? 0 : n);
	}
	
	module.exports = take;


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(591),
	    toInteger = __webpack_require__(599);
	
	/**
	 * Creates a slice of `array` with `n` elements taken from the end.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {number} [n=1] The number of elements to take.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.takeRight([1, 2, 3]);
	 * // => [3]
	 *
	 * _.takeRight([1, 2, 3], 2);
	 * // => [2, 3]
	 *
	 * _.takeRight([1, 2, 3], 5);
	 * // => [1, 2, 3]
	 *
	 * _.takeRight([1, 2, 3], 0);
	 * // => []
	 */
	function takeRight(array, n, guard) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return [];
	  }
	  n = (guard || n === undefined) ? 1 : toInteger(n);
	  n = length - n;
	  return baseSlice(array, n < 0 ? 0 : n, length);
	}
	
	module.exports = takeRight;


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(666),
	    baseWhile = __webpack_require__(730);
	
	/**
	 * Creates a slice of `array` with elements taken from the end. Elements are
	 * taken until `predicate` returns falsey. The predicate is invoked with
	 * three arguments: (value, index, array).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': true },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': false }
	 * ];
	 *
	 * _.takeRightWhile(users, function(o) { return !o.active; });
	 * // => objects for ['fred', 'pebbles']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	 * // => objects for ['pebbles']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.takeRightWhile(users, ['active', false]);
	 * // => objects for ['fred', 'pebbles']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.takeRightWhile(users, 'active');
	 * // => []
	 */
	function takeRightWhile(array, predicate) {
	  return (array && array.length)
	    ? baseWhile(array, baseIteratee(predicate, 3), false, true)
	    : [];
	}
	
	module.exports = takeRightWhile;


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(666),
	    baseWhile = __webpack_require__(730);
	
	/**
	 * Creates a slice of `array` with elements taken from the beginning. Elements
	 * are taken until `predicate` returns falsey. The predicate is invoked with
	 * three arguments: (value, index, array).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.takeWhile(users, function(o) { return !o.active; });
	 * // => objects for ['barney', 'fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.takeWhile(users, { 'user': 'barney', 'active': false });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.takeWhile(users, ['active', false]);
	 * // => objects for ['barney', 'fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.takeWhile(users, 'active');
	 * // => []
	 */
	function takeWhile(array, predicate) {
	  return (array && array.length)
	    ? baseWhile(array, baseIteratee(predicate, 3))
	    : [];
	}
	
	module.exports = takeWhile;


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(606),
	    baseRest = __webpack_require__(655),
	    baseUniq = __webpack_require__(789),
	    isArrayLikeObject = __webpack_require__(664);
	
	/**
	 * Creates an array of unique values, in order, from all given arrays using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * _.union([2], [1, 2]);
	 * // => [2, 1]
	 */
	var union = baseRest(function(arrays) {
	  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	});
	
	module.exports = union;


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(614),
	    arrayIncludes = __webpack_require__(646),
	    arrayIncludesWith = __webpack_require__(651),
	    cacheHas = __webpack_require__(654),
	    createSet = __webpack_require__(790),
	    setToArray = __webpack_require__(682);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(703),
	    noop = __webpack_require__(791),
	    setToArray = __webpack_require__(682);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ }),
/* 791 */
/***/ (function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(606),
	    baseIteratee = __webpack_require__(666),
	    baseRest = __webpack_require__(655),
	    baseUniq = __webpack_require__(789),
	    isArrayLikeObject = __webpack_require__(664),
	    last = __webpack_require__(725);
	
	/**
	 * This method is like `_.union` except that it accepts `iteratee` which is
	 * invoked for each element of each `arrays` to generate the criterion by
	 * which uniqueness is computed. Result values are chosen from the first
	 * array in which the value occurs. The iteratee is invoked with one argument:
	 * (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	 * // => [2.1, 1.2]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	var unionBy = baseRest(function(arrays) {
	  var iteratee = last(arrays);
	  if (isArrayLikeObject(iteratee)) {
	    iteratee = undefined;
	  }
	  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), baseIteratee(iteratee, 2));
	});
	
	module.exports = unionBy;


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(606),
	    baseRest = __webpack_require__(655),
	    baseUniq = __webpack_require__(789),
	    isArrayLikeObject = __webpack_require__(664),
	    last = __webpack_require__(725);
	
	/**
	 * This method is like `_.union` except that it accepts `comparator` which
	 * is invoked to compare elements of `arrays`. Result values are chosen from
	 * the first array in which the value occurs. The comparator is invoked
	 * with two arguments: (arrVal, othVal).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	 *
	 * _.unionWith(objects, others, _.isEqual);
	 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	 */
	var unionWith = baseRest(function(arrays) {
	  var comparator = last(arrays);
	  comparator = typeof comparator == 'function' ? comparator : undefined;
	  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	});
	
	module.exports = unionWith;


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	var baseUniq = __webpack_require__(789);
	
	/**
	 * Creates a duplicate-free version of an array, using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons, in which only the first occurrence of each element
	 * is kept. The order of result values is determined by the order they occur
	 * in the array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniq([2, 1, 2]);
	 * // => [2, 1]
	 */
	function uniq(array) {
	  return (array && array.length) ? baseUniq(array) : [];
	}
	
	module.exports = uniq;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(666),
	    baseUniq = __webpack_require__(789);
	
	/**
	 * This method is like `_.uniq` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * uniqueness is computed. The order of result values is determined by the
	 * order they occur in the array. The iteratee is invoked with one argument:
	 * (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	 * // => [2.1, 1.2]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	function uniqBy(array, iteratee) {
	  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
	}
	
	module.exports = uniqBy;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	var baseUniq = __webpack_require__(789);
	
	/**
	 * This method is like `_.uniq` except that it accepts `comparator` which
	 * is invoked to compare elements of `array`. The order of result values is
	 * determined by the order they occur in the array.The comparator is invoked
	 * with two arguments: (arrVal, othVal).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	 *
	 * _.uniqWith(objects, _.isEqual);
	 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	 */
	function uniqWith(array, comparator) {
	  comparator = typeof comparator == 'function' ? comparator : undefined;
	  return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	}
	
	module.exports = uniqWith;


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(687),
	    arrayMap = __webpack_require__(652),
	    baseProperty = __webpack_require__(723),
	    baseTimes = __webpack_require__(691),
	    isArrayLikeObject = __webpack_require__(664);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.zip` except that it accepts an array of grouped
	 * elements and creates an array regrouping the elements to their pre-zip
	 * configuration.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.2.0
	 * @category Array
	 * @param {Array} array The array of grouped elements to process.
	 * @returns {Array} Returns the new array of regrouped elements.
	 * @example
	 *
	 * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	 * // => [['a', 1, true], ['b', 2, false]]
	 *
	 * _.unzip(zipped);
	 * // => [['a', 'b'], [1, 2], [true, false]]
	 */
	function unzip(array) {
	  if (!(array && array.length)) {
	    return [];
	  }
	  var length = 0;
	  array = arrayFilter(array, function(group) {
	    if (isArrayLikeObject(group)) {
	      length = nativeMax(group.length, length);
	      return true;
	    }
	  });
	  return baseTimes(length, function(index) {
	    return arrayMap(array, baseProperty(index));
	  });
	}
	
	module.exports = unzip;


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(658),
	    arrayMap = __webpack_require__(652),
	    unzip = __webpack_require__(797);
	
	/**
	 * This method is like `_.unzip` except that it accepts `iteratee` to specify
	 * how regrouped values should be combined. The iteratee is invoked with the
	 * elements of each group: (...group).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.8.0
	 * @category Array
	 * @param {Array} array The array of grouped elements to process.
	 * @param {Function} [iteratee=_.identity] The function to combine
	 *  regrouped values.
	 * @returns {Array} Returns the new array of regrouped elements.
	 * @example
	 *
	 * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	 * // => [[1, 10, 100], [2, 20, 200]]
	 *
	 * _.unzipWith(zipped, _.add);
	 * // => [3, 30, 300]
	 */
	function unzipWith(array, iteratee) {
	  if (!(array && array.length)) {
	    return [];
	  }
	  var result = unzip(array);
	  if (iteratee == null) {
	    return result;
	  }
	  return arrayMap(result, function(group) {
	    return apply(iteratee, undefined, group);
	  });
	}
	
	module.exports = unzipWith;


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(613),
	    baseRest = __webpack_require__(655),
	    isArrayLikeObject = __webpack_require__(664);
	
	/**
	 * Creates an array excluding all given values using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * **Note:** Unlike `_.pull`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...*} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.difference, _.xor
	 * @example
	 *
	 * _.without([2, 1, 2, 3], 1, 2);
	 * // => [3]
	 */
	var without = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, values)
	    : [];
	});
	
	module.exports = without;


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(687),
	    baseRest = __webpack_require__(655),
	    baseXor = __webpack_require__(801),
	    isArrayLikeObject = __webpack_require__(664);
	
	/**
	 * Creates an array of unique values that is the
	 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	 * of the given arrays. The order of result values is determined by the order
	 * they occur in the arrays.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.difference, _.without
	 * @example
	 *
	 * _.xor([2, 1], [2, 3]);
	 * // => [1, 3]
	 */
	var xor = baseRest(function(arrays) {
	  return baseXor(arrayFilter(arrays, isArrayLikeObject));
	});
	
	module.exports = xor;


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(613),
	    baseFlatten = __webpack_require__(606),
	    baseUniq = __webpack_require__(789);
	
	/**
	 * The base implementation of methods like `_.xor`, without support for
	 * iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of values.
	 */
	function baseXor(arrays, iteratee, comparator) {
	  var length = arrays.length;
	  if (length < 2) {
	    return length ? baseUniq(arrays[0]) : [];
	  }
	  var index = -1,
	      result = Array(length);
	
	  while (++index < length) {
	    var array = arrays[index],
	        othIndex = -1;
	
	    while (++othIndex < length) {
	      if (othIndex != index) {
	        result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	      }
	    }
	  }
	  return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	}
	
	module.exports = baseXor;


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(687),
	    baseIteratee = __webpack_require__(666),
	    baseRest = __webpack_require__(655),
	    baseXor = __webpack_require__(801),
	    isArrayLikeObject = __webpack_require__(664),
	    last = __webpack_require__(725);
	
	/**
	 * This method is like `_.xor` except that it accepts `iteratee` which is
	 * invoked for each element of each `arrays` to generate the criterion by
	 * which by which they're compared. The order of result values is determined
	 * by the order they occur in the arrays. The iteratee is invoked with one
	 * argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	 * // => [1.2, 3.4]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 2 }]
	 */
	var xorBy = baseRest(function(arrays) {
	  var iteratee = last(arrays);
	  if (isArrayLikeObject(iteratee)) {
	    iteratee = undefined;
	  }
	  return baseXor(arrayFilter(arrays, isArrayLikeObject), baseIteratee(iteratee, 2));
	});
	
	module.exports = xorBy;


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(687),
	    baseRest = __webpack_require__(655),
	    baseXor = __webpack_require__(801),
	    isArrayLikeObject = __webpack_require__(664),
	    last = __webpack_require__(725);
	
	/**
	 * This method is like `_.xor` except that it accepts `comparator` which is
	 * invoked to compare elements of `arrays`. The order of result values is
	 * determined by the order they occur in the arrays. The comparator is invoked
	 * with two arguments: (arrVal, othVal).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	 *
	 * _.xorWith(objects, others, _.isEqual);
	 * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	 */
	var xorWith = baseRest(function(arrays) {
	  var comparator = last(arrays);
	  comparator = typeof comparator == 'function' ? comparator : undefined;
	  return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	});
	
	module.exports = xorWith;


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(655),
	    unzip = __webpack_require__(797);
	
	/**
	 * Creates an array of grouped elements, the first of which contains the
	 * first elements of the given arrays, the second of which contains the
	 * second elements of the given arrays, and so on.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to process.
	 * @returns {Array} Returns the new array of grouped elements.
	 * @example
	 *
	 * _.zip(['a', 'b'], [1, 2], [true, false]);
	 * // => [['a', 1, true], ['b', 2, false]]
	 */
	var zip = baseRest(unzip);
	
	module.exports = zip;


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(806),
	    baseZipObject = __webpack_require__(808);
	
	/**
	 * This method is like `_.fromPairs` except that it accepts two arrays,
	 * one of property identifiers and one of corresponding values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.4.0
	 * @category Array
	 * @param {Array} [props=[]] The property identifiers.
	 * @param {Array} [values=[]] The property values.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * _.zipObject(['a', 'b'], [1, 2]);
	 * // => { 'a': 1, 'b': 2 }
	 */
	function zipObject(props, values) {
	  return baseZipObject(props || [], values || [], assignValue);
	}
	
	module.exports = zipObject;


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(807),
	    eq = __webpack_require__(593);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(662);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 808 */
/***/ (function(module, exports) {

	/**
	 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	 *
	 * @private
	 * @param {Array} props The property identifiers.
	 * @param {Array} values The property values.
	 * @param {Function} assignFunc The function to assign values.
	 * @returns {Object} Returns the new object.
	 */
	function baseZipObject(props, values, assignFunc) {
	  var index = -1,
	      length = props.length,
	      valsLength = values.length,
	      result = {};
	
	  while (++index < length) {
	    var value = index < valsLength ? values[index] : undefined;
	    assignFunc(result, props[index], value);
	  }
	  return result;
	}
	
	module.exports = baseZipObject;


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSet = __webpack_require__(810),
	    baseZipObject = __webpack_require__(808);
	
	/**
	 * This method is like `_.zipObject` except that it supports property paths.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.1.0
	 * @category Array
	 * @param {Array} [props=[]] The property identifiers.
	 * @param {Array} [values=[]] The property values.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	 * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	 */
	function zipObjectDeep(props, values) {
	  return baseZipObject(props || [], values || [], baseSet);
	}
	
	module.exports = zipObjectDeep;


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(806),
	    castPath = __webpack_require__(711),
	    isIndex = __webpack_require__(598),
	    isObject = __webpack_require__(596),
	    toKey = __webpack_require__(718);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(655),
	    unzipWith = __webpack_require__(798);
	
	/**
	 * This method is like `_.zip` except that it accepts `iteratee` to specify
	 * how grouped values should be combined. The iteratee is invoked with the
	 * elements of each group: (...group).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.8.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to process.
	 * @param {Function} [iteratee=_.identity] The function to combine
	 *  grouped values.
	 * @returns {Array} Returns the new array of grouped elements.
	 * @example
	 *
	 * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	 *   return a + b + c;
	 * });
	 * // => [111, 222]
	 */
	var zipWith = baseRest(function(arrays) {
	  var length = arrays.length,
	      iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	  iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	  return unzipWith(arrays, iteratee);
	});
	
	module.exports = zipWith;


/***/ }),
/* 812 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var generateUniqueId = exports.generateUniqueId = function generateUniqueId() {
	  var timestamp = new Date().getTime().toString();
	  var randomSuffix = Math.random().toString(36).substring(7);
	  // toString(36) convierte un número en una cadena utilizando la base 36.
	  // substring(7) devuelve una parte de la cadena a partir del séptimo carácter.
	
	  return timestamp + "_" + randomSuffix;
	};

/***/ }),
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fireEvent = exports.getCompanyUser = exports.getUser = exports.login = exports.deleteImage = exports.updateImage = exports.toLastJob = exports.toNextJob = exports.getTextSearchProducts = exports.getTwinnedLooks = exports.getAnnotationFromStyleAdvisor = exports.getLookProductsInactive = exports.getLookProducts = exports.getLook = exports.saveDetection = exports.getAnnotations = exports.getJobs = exports.toValidate = exports.searchByImageWithApiKey = exports.searchByImage = exports.searchById = exports.recognize = exports.detect = exports.searchProduct = exports.getProducts = exports.changeCategory = exports.getCategories = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(267);
	
	var _constants2 = __webpack_require__(267);
	
	var parseJSON = function parseJSON(response) {
	  if (response.status !== 204) return response.json();else return true;
	};
	
	var checkStatus = function checkStatus(response) {
	  if (response.status >= 200 && response.status < 300) {
	    return response;
	  } else {
	    var error = new Error(response.statusText);
	    error.response = response;
	    throw error;
	  }
	};
	
	var getHeaders = function getHeaders(token) {
	  if (token) {
	    return _extends({}, _constants.headers, {
	      Authorization: 'Bearer ' + token
	    });
	  } else {
	    return _constants.headers;
	  }
	};
	
	var getHeadersWithApiKey = function getHeadersWithApiKey(apikey) {
	  if (apikey) {
	    return _extends({}, _constants.headers, {
	      apikey: '' + apikey
	    });
	  } else {
	    return _constants.headers;
	  }
	};
	
	var getHeadersWithApiKeyAndToken = function getHeadersWithApiKeyAndToken(apikey, token) {
	  if (apikey && token) {
	    return _extends({}, _constants.headers, {
	      apikey: '' + apikey,
	      Authorization: 'Bearer ' + token
	    });
	  } else {
	    return _constants.headers;
	  }
	};
	
	var getHeadersWithXApiKey = function getHeadersWithXApiKey(apikey) {
	  if (apikey) {
	    return _extends({}, _constants.headers, {
	      'X-api-key': '' + apikey
	    });
	  } else {
	    return _constants.headers;
	  }
	};
	
	var postWithApiKey = function postWithApiKey(h, apikey, data) {
	  console.log(' [API CALL] POST WITH APIKEY ', h, apikey, data);
	  if (!data) console.log('[WARNING] POST CALL WITH NO DATA', data);
	  return window.fetch(h, {
	    body: data ? JSON.stringify(data) : '',
	    method: 'POST',
	    headers: getHeadersWithApiKey(apikey)
	  }).then(checkStatus).then(parseJSON);
	};
	
	var postWithApiKeyAndToken = function postWithApiKeyAndToken(h, apikey, token, data) {
	  console.log(' [API CALL] POST WITH APIKEY ', h, apikey, data);
	  if (!data) console.log('[WARNING] POST CALL WITH NO DATA', data);
	  return window.fetch(h, {
	    body: data ? JSON.stringify(data) : '',
	    method: 'POST',
	    headers: getHeadersWithApiKeyAndToken(apikey, token)
	  }).then(checkStatus).then(parseJSON);
	};
	
	var postWithXApiKey = function postWithXApiKey(h, apikey, data) {
	  if (!data) console.log('[WARNING] POST CALL WITH NO DATA', data);
	  return window.fetch(h, {
	    body: data ? JSON.stringify(data) : '',
	    method: 'POST',
	    headers: getHeadersWithXApiKey(apikey)
	  }).then(checkStatus).then(parseJSON);
	};
	
	// PATCH=https://wideeyes.atlassian.net/wiki/spaces/DEV/pages/616759331/WID-823+Imposible+to+change+category+in+annotation+platform
	var putWithApiKey = function putWithApiKey(h, apikey, data) {
	  console.log(' [API CALL] PUT WITH APIKEY ', h, apikey, data);
	  if (!data) console.log('[WARNING] PUT CALL WITH NO DATA', data);
	  return window.fetch(h, {
	    body: data ? JSON.stringify(data) : '',
	    method: 'PUT',
	    headers: getHeadersWithApiKey(apikey)
	  }).then(checkStatus).then(parseJSON);
	};
	
	var putWithApiKeyAndToken = function putWithApiKeyAndToken(h, apikey, token, data) {
	  console.log(' [API CALL] PUT WITH APIKEY AND TOKEN', h, apikey, data);
	  if (!data) console.log('[WARNING] PUT CALL WITH NO DATA', data);
	  console.log(JSON.stringify(data));
	  console.log(getHeadersWithApiKeyAndToken(apikey, token));
	  return window.fetch(h, {
	    body: data ? JSON.stringify(data) : '',
	    method: 'PUT',
	    headers: getHeadersWithApiKeyAndToken(apikey, token)
	  }).then(checkStatus).then(parseJSON);
	};
	
	var post = function post(h, token, data) {
	  console.log(' [API CALL] POST ', h, token, data);
	  if (!data) console.log('[WARNING] POST CALL WITH NO DATA', data);
	  return window.fetch(h, {
	    body: data ? JSON.stringify(data) : '',
	    method: 'POST',
	    headers: getHeaders(token)
	  }).then(checkStatus).then(parseJSON);
	};
	
	var put = function put(h, token, data) {
	  console.log(' [API CALL] PUT ', h, token, data);
	  if (!data) console.log('[WARNING] PUT CALL WITH NO DATA', data);
	  return window.fetch(h, {
	    body: JSON.stringify(data),
	    method: 'PUT',
	    headers: getHeaders(token)
	  }).then(checkStatus).then(parseJSON);
	};
	
	var postWithoutHeader = function postWithoutHeader(h, data, params) {
	  console.log(' [API CALL] POST WITHOUT HEADER ', h, data);
	  if (!data) console.log('[WARNING] POST CALL WITH NO DATA', data);
	  if (params) {
	    // we only add test par
	    if (params.env === 'test') {
	      h = h + '?' + params.env + '=true';
	    }
	  }
	
	  return window.fetch(h, {
	    body: JSON.stringify(data),
	    method: 'POST',
	    headers: {
	      'Accept': 'application/json',
	      'Content-Type': 'application/json'
	    }
	
	  }).then(checkStatus).then(parseJSON);
	};
	
	var convertToHeaders = function convertToHeaders(query) {
	  return query ? '?' + Object.keys(query).map(function (key) {
	    return encodeURIComponent(key) + '=' + encodeURIComponent(query[key]);
	  }).join('&').replace(/%20/g, '+') : '';
	};
	
	var get = function get(h, token, params) {
	  console.log('[API CALL] GET ', h, token, params);
	  return window.fetch(h + convertToHeaders(params), {
	    method: 'GET',
	    headers: getHeaders(token)
	  }).then(checkStatus).then(parseJSON);
	};
	
	var getWithApikeyAndConvertHeaders = function getWithApikeyAndConvertHeaders(h, apikey, params) {
	  console.log('[API CALL] GET WITH APIKEY', h, apikey, params);
	  return window.fetch(h + convertToHeaders(params), {
	    method: 'GET',
	    headers: getHeadersWithApiKey(apikey)
	  }).then(checkStatus).then(parseJSON);
	};
	
	var getWithApikey = function getWithApikey(h, apikey, params) {
	  console.log('[API CALL] GET WITH APIKEY', h, apikey, params);
	  return window.fetch(h, {
	    method: 'GET',
	    headers: getHeadersWithApiKey(apikey)
	  }).then(checkStatus).then(parseJSON);
	};
	
	var getWithApikeyAndToken = function getWithApikeyAndToken(h, apikey, token, params) {
	  console.log('[API CALL] GET WITH APIKEY AND TOKEN', h, apikey, token, params);
	  return window.fetch(h + convertToHeaders(params), {
	    method: 'GET',
	    headers: getHeadersWithApiKeyAndToken(apikey, token)
	  }).then(checkStatus).then(parseJSON);
	};
	
	var del = function del(h, token) {
	  console.log('[API CALL] DELETE', h, token);
	  return window.fetch(h, {
	    method: 'DELETE',
	    headers: getHeaders(token)
	  }).then(checkStatus).then(parseJSON);
	};
	
	// category
	var getCategories = exports.getCategories = function getCategories(apikey, token) {
	  return postWithApiKeyAndToken(_constants.host + '/v2/get_category_data', apikey, token);
	};
	var changeCategory = exports.changeCategory = function changeCategory(apikey, token, params, data) {
	  return putWithApiKeyAndToken(_constants.host + '/v2/product/' + params.uid + '/changeCategory', apikey, token, data);
	};
	
	// products
	var getProducts = exports.getProducts = function getProducts(apikey, token, params, data) {
	  return getWithApikeyAndToken(_constants.host + '/v2/product', apikey, token, params);
	};
	var searchProduct = exports.searchProduct = function searchProduct(apikey, token, params, data) {
	  return getWithApikeyAndToken(_constants.host + '/v2/product/' + params.uid, apikey, token, data);
	};
	var detect = exports.detect = function detect(token, data) {
	  return post(_constants.host + '/v4/DetectAndFeatures', token, data);
	};
	var recognize = exports.recognize = function recognize(token, data) {
	  return postWithApiKey(_constants.host + '/v1/Recognize', token, data);
	};
	var searchById = exports.searchById = function searchById(apikey, data) {
	  return postWithApiKey(_constants.host + '/v4/SearchById', apikey, data);
	};
	var searchByImage = exports.searchByImage = function searchByImage(token, data) {
	  return post(_constants.host + '/v4/SearchByImage', token, data);
	};
	var searchByImageWithApiKey = exports.searchByImageWithApiKey = function searchByImageWithApiKey(apikey, data) {
	  return postWithApiKey(_constants.host + '/v4/SearchByImage', apikey, data);
	};
	var toValidate = exports.toValidate = function toValidate(token, data) {
	  return get(_constants.host + '/annotator/v2/job/' + data.jobId + '/image/toValidate', token, data);
	};
	var getJobs = exports.getJobs = function getJobs(token, data) {
	  return get(_constants.host + '/annotator/v2/job', token, _extends({}, data, { limit: 300, page: 1 }));
	};
	var getAnnotations = exports.getAnnotations = function getAnnotations(token, data) {
	  return get(_constants.host + '/annotator/v2/job/' + data.jobId + '/image/' + data.image.id + '/annotation', token, data);
	};
	var saveDetection = exports.saveDetection = function saveDetection(token, params, data) {
	  return post(_constants.host + '/annotator/v2/job/' + params.jobId + '/image/' + params.imageId + '/annotation/' + params.annotationId, token, data);
	};
	
	// looks
	var getLook = exports.getLook = function getLook(apikey, token, data) {
	  return getWithApikeyAndToken(_constants.host + '/v2/look/uid/' + data.uid, apikey, token, data);
	};
	var getLookProducts = exports.getLookProducts = function getLookProducts(apikey, token, uid) {
	  return getWithApikeyAndToken(_constants.host + '/v2/product/' + uid, apikey, token);
	};
	var getLookProductsInactive = exports.getLookProductsInactive = function getLookProductsInactive(apikey, token, uid) {
	  return getWithApikeyAndToken(_constants.host + '/v2/product/' + uid + '?status=inactive', apikey, token);
	};
	
	// Style advisor
	var getAnnotationFromStyleAdvisor = exports.getAnnotationFromStyleAdvisor = function getAnnotationFromStyleAdvisor(token, data) {
	  return postWithApiKey(_constants2.hostApiMirror + '/v5/styleAdvisor', token, data);
	};
	
	// Twinned looks (Hermanados)
	var getTwinnedLooks = exports.getTwinnedLooks = function getTwinnedLooks(apikey, params) {
	  return getWithApikey(_constants.host + '/look/twinned/' + params.uid, apikey, params);
	};
	
	// Text Search
	var getTextSearchProducts = exports.getTextSearchProducts = function getTextSearchProducts(apikey, data) {
	  return postWithApiKey(_constants2.hostApiMirror + '/v5/textSearch', apikey, data);
	};
	
	var toNextJob = exports.toNextJob = function toNextJob(token, params, data) {
	  return post(_constants.host + '/annotator/v2/job/' + params.jobId + '/image/' + params.imageId + '/toNextJob', token, data);
	};
	var toLastJob = exports.toLastJob = function toLastJob(token, params, data) {
	  return post(_constants.host + '/annotator/v2/job/' + params.jobId + '/image/' + params.imageId + '/toLastJob', token, data);
	};
	
	var updateImage = exports.updateImage = function updateImage(token, params, data) {
	  return post(_constants.host + '/annotator/v2/job/' + params.jobId + '/image/' + params.imageId, token, data);
	};
	var deleteImage = exports.deleteImage = function deleteImage(token, params, data) {
	  return del(_constants.host + '/annotator/v2/job/' + params.jobId + '/image/' + params.imageId, token, data);
	};
	// make delete call to http://api.wide-eyes.it/annotator/v2/job/12/image/21425/annotation/121264
	// make post call to Request URL:http://api.wide-eyes.it/annotator/v2/job/12/image/21425/annotation?mode=supervisor
	// with {"data":"{\"bbox\":[{\"tag\":\"scarf\",\"x1\":150,\"y1\":55,\"x2\":272,\"y2\":348},{\"tag\":\"boots\",\"x1\":143,\"y1\":362,\"x2\":218,\"y2\":580},{\"tag\":\"boots\",\"x1\":240,\"y1\":357,\"x2\":306,\"y2\":578}]}"}
	
	// Mocks
	// export const searchProduct = (token, params, data) => searchProductMock(`${host}/product/${params.uid}`, token, data)
	
	// export const getAnnotations = (token, data) => getAnnotationsMock(`${host}/annotator/v2/job/${data.jobId}/image/${data.imageId}/annotation`, token, data)
	// export const saveDetection = (token, data) => saveDetectionMock(`${host}/annotator/v2/job/${data.jobId}/image/${data.imageId}/annotation`, token, data)
	// export const toValidate = (token, data) => toValidateMock(`${host}/annotator/v2/job/${data.jobId}/image/toValidate`, token, data)
	// export const searchByImage = (token, data) => searchByImageMock(`${host}/v4/SearchByImage`, token, data)
	// export const recognize = (token, data) => recognizeMock(`${host}/v1/Recognize`, token, data)
	// export const removeDetection = (token, data) => saveDetectionMock(`${host}/annotator/v2/job/${data.jobId}/image/${data.imageId}/annotation`, token, data)
	
	// users
	var login = exports.login = function login(data) {
	  return post(_constants.host + '/login', null, data);
	};
	var getUser = exports.getUser = function getUser(token) {
	  return get(_constants.host + '/users/show', token);
	};
	var getCompanyUser = exports.getCompanyUser = function getCompanyUser(apikey) {
	  return getWithApikeyAndConvertHeaders(_constants.host + '/users/show', apikey);
	};
	var fireEvent = exports.fireEvent = function fireEvent(apikey, data) {
	  return postWithApiKey(_constants.host + '/events/fire', apikey, data);
	};

/***/ }),
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var setItem = exports.setItem = function setItem(id, data) {
	  try {
	    return window.localStorage.setItem(id, data);
	  } catch (e) {
	    return undefined;
	  }
	};
	
	var deleteItem = exports.deleteItem = function deleteItem(id) {
	  try {
	    return window.localStorage.removeItem(id);
	  } catch (e) {
	    return undefined;
	  }
	};
	var getItem = exports.getItem = function getItem(id) {
	  try {
	    return window.localStorage.getItem(id);
	  } catch (e) {
	    return undefined;
	  }
	};

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sagas = __webpack_require__(956);
	
	var _sagas2 = _interopRequireDefault(_sagas);
	
	var _reducers = __webpack_require__(973);
	
	var reducers = _interopRequireWildcard(_reducers);
	
	var _reduxSaga = __webpack_require__(968);
	
	var _reduxSaga2 = _interopRequireDefault(_reduxSaga);
	
	var _redux = __webpack_require__(277);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global __DEV__ */
	
	exports.default = configureStore;
	
	
	function configureStore(initialState) {
	  var sagaMiddleware = (0, _reduxSaga2.default)();
	
	  var createStoreWithMiddleware = void 0;
	
	  if (false) {
	    createStoreWithMiddleware = (0, _redux.applyMiddleware)(require('redux-logger')(), sagaMiddleware)(_redux.createStore);
	  } else {
	    createStoreWithMiddleware = (0, _redux.applyMiddleware)(sagaMiddleware)(_redux.createStore);
	  }
	
	  var reducer = (0, _redux.combineReducers)(reducers);
	  var store = void 0;
	
	  if (false) {
	    store = createStoreWithMiddleware(reducer, initialState, window.devToolsExtension && window.devToolsExtension());
	  } else {
	    store = createStoreWithMiddleware(reducer, initialState);
	  }
	
	  sagaMiddleware.run(_sagas2.default);
	  return store;
	}

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = rootSaga;
	
	var _api = __webpack_require__(826);
	
	var Api = _interopRequireWildcard(_api);
	
	var _app = __webpack_require__(298);
	
	var _reduxActions = __webpack_require__(299);
	
	var _reactRouter = __webpack_require__(180);
	
	var _effects = __webpack_require__(957);
	
	var _reduxSaga = __webpack_require__(968);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _marked = /*#__PURE__*/regeneratorRuntime.mark(rootSaga),
	    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(loginSaga),
	    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getUserSaga),
	    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(recognizeSaga),
	    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(searchByIdSaga),
	    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(searchByImageSaga),
	    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(toValidateSaga),
	    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(getCategoriesSaga),
	    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(changeCategorySaga),
	    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(getJobsSaga),
	    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(getAnnotationsSaga),
	    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(saveAllAndNextJobSaga),
	    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(searchProductSagas),
	    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(searchProductsSagas),
	    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(skipAndNextJobSagas),
	    _marked16 = /*#__PURE__*/regeneratorRuntime.mark(resetAndNextJobSagas),
	    _marked17 = /*#__PURE__*/regeneratorRuntime.mark(selectAlternativeImageSagas),
	    _marked18 = /*#__PURE__*/regeneratorRuntime.mark(getLookSagas),
	    _marked19 = /*#__PURE__*/regeneratorRuntime.mark(getLookProductsSagas),
	    _marked20 = /*#__PURE__*/regeneratorRuntime.mark(getAnnotationFromStyleAdvisorSagas),
	    _marked21 = /*#__PURE__*/regeneratorRuntime.mark(getTwinnedLooksSagas),
	    _marked22 = /*#__PURE__*/regeneratorRuntime.mark(getFinalAnnotationLookProductsSagas),
	    _marked23 = /*#__PURE__*/regeneratorRuntime.mark(getTextSearchSagas),
	    _marked24 = /*#__PURE__*/regeneratorRuntime.mark(searchProduct),
	    _marked25 = /*#__PURE__*/regeneratorRuntime.mark(searchProducts),
	    _marked26 = /*#__PURE__*/regeneratorRuntime.mark(getJobs),
	    _marked27 = /*#__PURE__*/regeneratorRuntime.mark(selectAlternativeImage),
	    _marked28 = /*#__PURE__*/regeneratorRuntime.mark(getCategories),
	    _marked29 = /*#__PURE__*/regeneratorRuntime.mark(changeCategory),
	    _marked30 = /*#__PURE__*/regeneratorRuntime.mark(toValidateRecognize),
	    _marked31 = /*#__PURE__*/regeneratorRuntime.mark(toValidate),
	    _marked32 = /*#__PURE__*/regeneratorRuntime.mark(getAnnotations),
	    _marked33 = /*#__PURE__*/regeneratorRuntime.mark(recognize),
	    _marked34 = /*#__PURE__*/regeneratorRuntime.mark(skipAndNextJob),
	    _marked35 = /*#__PURE__*/regeneratorRuntime.mark(resetAndNextJob),
	    _marked36 = /*#__PURE__*/regeneratorRuntime.mark(saveAllAndNextJob),
	    _marked37 = /*#__PURE__*/regeneratorRuntime.mark(searchById),
	    _marked38 = /*#__PURE__*/regeneratorRuntime.mark(searchByImage),
	    _marked39 = /*#__PURE__*/regeneratorRuntime.mark(getLook),
	    _marked40 = /*#__PURE__*/regeneratorRuntime.mark(getLookProducts),
	    _marked41 = /*#__PURE__*/regeneratorRuntime.mark(getAnnotationFromStyleAdvisor),
	    _marked42 = /*#__PURE__*/regeneratorRuntime.mark(getTwinnedLooks),
	    _marked43 = /*#__PURE__*/regeneratorRuntime.mark(getTextSearch),
	    _marked44 = /*#__PURE__*/regeneratorRuntime.mark(getFinalAnnotationLookProducts),
	    _marked45 = /*#__PURE__*/regeneratorRuntime.mark(getLookProductsCall),
	    _marked46 = /*#__PURE__*/regeneratorRuntime.mark(login),
	    _marked47 = /*#__PURE__*/regeneratorRuntime.mark(getUser);
	
	var _window = window,
	    alert = _window.alert;
	function rootSaga() {
	  return regeneratorRuntime.wrap(function rootSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return [loginSaga(), getUserSaga(), recognizeSaga(), searchByIdSaga(), searchByImageSaga(), toValidateSaga(), getCategoriesSaga(), changeCategorySaga(), getJobsSaga(), getAnnotationsSaga(), saveAllAndNextJobSaga(), searchProductSagas(), searchProductsSagas(), skipAndNextJobSagas(), resetAndNextJobSagas(), selectAlternativeImageSagas(), getLookSagas(), getLookProductsSagas(), getAnnotationFromStyleAdvisorSagas(), getTwinnedLooksSagas(), getTextSearchSagas(), getFinalAnnotationLookProductsSagas()];
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function loginSaga() {
	  return regeneratorRuntime.wrap(function loginSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          return _context2.delegateYield((0, _reduxSaga.takeLatest)('USER_LOGIN_REQUESTED', login), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	function getUserSaga() {
	  return regeneratorRuntime.wrap(function getUserSaga$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          return _context3.delegateYield((0, _reduxSaga.takeEvery)('GET_USER_REQUESTED', getUser), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	function recognizeSaga() {
	  return regeneratorRuntime.wrap(function recognizeSaga$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          return _context4.delegateYield((0, _reduxSaga.takeLatest)('RECOGNIZE_PRODUCTS_REQUESTED', recognize), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	function searchByIdSaga() {
	  return regeneratorRuntime.wrap(function searchByIdSaga$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          return _context5.delegateYield((0, _reduxSaga.takeLatest)('GET_SIMILARS_REQUESTED', searchById), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	function searchByImageSaga() {
	  return regeneratorRuntime.wrap(function searchByImageSaga$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          return _context6.delegateYield((0, _reduxSaga.takeLatest)('SEARCH_BY_IMAGE_REQUESTED', searchByImage), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this);
	}
	function toValidateSaga() {
	  return regeneratorRuntime.wrap(function toValidateSaga$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          return _context7.delegateYield((0, _reduxSaga.takeLatest)('GET_IMAGE_TO_VALIDATE_REQUESTED', toValidate), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked7, this);
	}
	function getCategoriesSaga() {
	  return regeneratorRuntime.wrap(function getCategoriesSaga$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          return _context8.delegateYield((0, _reduxSaga.takeLatest)('GET_CATEGORIES_REQUESTED', getCategories), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked8, this);
	}
	function changeCategorySaga() {
	  return regeneratorRuntime.wrap(function changeCategorySaga$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          return _context9.delegateYield((0, _reduxSaga.takeLatest)(' CHANGE_CATEGORY_REQUESTED', changeCategory), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked9, this);
	}
	function getJobsSaga() {
	  return regeneratorRuntime.wrap(function getJobsSaga$(_context10) {
	    while (1) {
	      switch (_context10.prev = _context10.next) {
	        case 0:
	          return _context10.delegateYield((0, _reduxSaga.takeLatest)('GET_JOBS_REQUESTED', getJobs), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context10.stop();
	      }
	    }
	  }, _marked10, this);
	}
	function getAnnotationsSaga() {
	  return regeneratorRuntime.wrap(function getAnnotationsSaga$(_context11) {
	    while (1) {
	      switch (_context11.prev = _context11.next) {
	        case 0:
	          return _context11.delegateYield((0, _reduxSaga.takeLatest)('GET_ANNOTATIONS_REQUESTED', getAnnotations), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context11.stop();
	      }
	    }
	  }, _marked11, this);
	}
	function saveAllAndNextJobSaga() {
	  return regeneratorRuntime.wrap(function saveAllAndNextJobSaga$(_context12) {
	    while (1) {
	      switch (_context12.prev = _context12.next) {
	        case 0:
	          return _context12.delegateYield((0, _reduxSaga.takeLatest)('SAVE_ALL_REQUESTED', saveAllAndNextJob), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context12.stop();
	      }
	    }
	  }, _marked12, this);
	}
	function searchProductSagas() {
	  return regeneratorRuntime.wrap(function searchProductSagas$(_context13) {
	    while (1) {
	      switch (_context13.prev = _context13.next) {
	        case 0:
	          return _context13.delegateYield((0, _reduxSaga.takeLatest)('SEARCH_PRODUCT_REQUESTED', searchProduct), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context13.stop();
	      }
	    }
	  }, _marked13, this);
	}
	function searchProductsSagas() {
	  return regeneratorRuntime.wrap(function searchProductsSagas$(_context14) {
	    while (1) {
	      switch (_context14.prev = _context14.next) {
	        case 0:
	          return _context14.delegateYield((0, _reduxSaga.takeLatest)('SEARCH_PRODUCTS_REQUESTED', searchProducts), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context14.stop();
	      }
	    }
	  }, _marked14, this);
	}
	function skipAndNextJobSagas() {
	  return regeneratorRuntime.wrap(function skipAndNextJobSagas$(_context15) {
	    while (1) {
	      switch (_context15.prev = _context15.next) {
	        case 0:
	          return _context15.delegateYield((0, _reduxSaga.takeLatest)('SKIP_AND_FINISH_REQUESTED', skipAndNextJob), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context15.stop();
	      }
	    }
	  }, _marked15, this);
	}
	function resetAndNextJobSagas() {
	  return regeneratorRuntime.wrap(function resetAndNextJobSagas$(_context16) {
	    while (1) {
	      switch (_context16.prev = _context16.next) {
	        case 0:
	          return _context16.delegateYield((0, _reduxSaga.takeLatest)('RESET_AND_FINISH_REQUESTED', resetAndNextJob), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context16.stop();
	      }
	    }
	  }, _marked16, this);
	}
	function selectAlternativeImageSagas() {
	  return regeneratorRuntime.wrap(function selectAlternativeImageSagas$(_context17) {
	    while (1) {
	      switch (_context17.prev = _context17.next) {
	        case 0:
	          return _context17.delegateYield((0, _reduxSaga.takeLatest)('SELECT_ALTERNATIVE_IMAGE_REQUESTED', selectAlternativeImage), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context17.stop();
	      }
	    }
	  }, _marked17, this);
	}
	function getLookSagas() {
	  return regeneratorRuntime.wrap(function getLookSagas$(_context18) {
	    while (1) {
	      switch (_context18.prev = _context18.next) {
	        case 0:
	          return _context18.delegateYield((0, _reduxSaga.takeLatest)('GET_LOOK_REQUESTED', getLook), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context18.stop();
	      }
	    }
	  }, _marked18, this);
	}
	function getLookProductsSagas() {
	  return regeneratorRuntime.wrap(function getLookProductsSagas$(_context19) {
	    while (1) {
	      switch (_context19.prev = _context19.next) {
	        case 0:
	          return _context19.delegateYield((0, _reduxSaga.takeLatest)('GET_LOOK_PRODUCTS_REQUESTED', getLookProducts), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context19.stop();
	      }
	    }
	  }, _marked19, this);
	}
	function getAnnotationFromStyleAdvisorSagas() {
	  return regeneratorRuntime.wrap(function getAnnotationFromStyleAdvisorSagas$(_context20) {
	    while (1) {
	      switch (_context20.prev = _context20.next) {
	        case 0:
	          return _context20.delegateYield((0, _reduxSaga.takeLatest)('GET_ANNOTATION_FROM_STYLE_ADVISOR_REQUESTED', getAnnotationFromStyleAdvisor), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context20.stop();
	      }
	    }
	  }, _marked20, this);
	}
	function getTwinnedLooksSagas() {
	  return regeneratorRuntime.wrap(function getTwinnedLooksSagas$(_context21) {
	    while (1) {
	      switch (_context21.prev = _context21.next) {
	        case 0:
	          return _context21.delegateYield((0, _reduxSaga.takeLatest)('GET_TWINNED_LOOKS_REQUESTED', getTwinnedLooks), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context21.stop();
	      }
	    }
	  }, _marked21, this);
	}
	function getFinalAnnotationLookProductsSagas() {
	  return regeneratorRuntime.wrap(function getFinalAnnotationLookProductsSagas$(_context22) {
	    while (1) {
	      switch (_context22.prev = _context22.next) {
	        case 0:
	          return _context22.delegateYield((0, _reduxSaga.takeLatest)('GET_FINAL_ANNOTATION_LOOK_PRODUCTS_REQUESTED', getFinalAnnotationLookProducts), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context22.stop();
	      }
	    }
	  }, _marked22, this);
	}
	
	function getTextSearchSagas() {
	  return regeneratorRuntime.wrap(function getTextSearchSagas$(_context23) {
	    while (1) {
	      switch (_context23.prev = _context23.next) {
	        case 0:
	          return _context23.delegateYield((0, _reduxSaga.takeLatest)('GET_TEXT_SEARCH_REQUESTED', getTextSearch), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context23.stop();
	      }
	    }
	  }, _marked23, this);
	}
	
	function searchProduct(action) {
	  var res;
	  return regeneratorRuntime.wrap(function searchProduct$(_context24) {
	    while (1) {
	      switch (_context24.prev = _context24.next) {
	        case 0:
	          _context24.prev = 0;
	          _context24.next = 3;
	          return (0, _effects.call)(Api.searchProduct, action.payload.apikey, action.payload.token, { 'uid': action.payload.data.uid });
	
	        case 3:
	          res = _context24.sent;
	          _context24.next = 6;
	          return (0, _effects.put)((0, _reduxActions.createAction)('SEARCH_PRODUCT_RECEIVED')(res));
	
	        case 6:
	          _context24.next = 16;
	          break;
	
	        case 8:
	          _context24.prev = 8;
	          _context24.t0 = _context24['catch'](0);
	
	          alert('SEARCH_PRODUCT_FAILED: ' + _context24.t0 + ' uid ' + action.payload.data.uid);
	
	          if (!(_context24.t0.status === 401)) {
	            _context24.next = 14;
	            break;
	          }
	
	          _context24.next = 14;
	          return (0, _effects.put)((0, _reduxActions.createAction)('LOGOUT')());
	
	        case 14:
	          _context24.next = 16;
	          return (0, _effects.put)((0, _reduxActions.createAction)('SEARCH_PRODUCT_FAILED')(_context24.t0));
	
	        case 16:
	        case 'end':
	          return _context24.stop();
	      }
	    }
	  }, _marked24, this, [[0, 8]]);
	}
	
	function searchProducts(action) {
	  var res;
	  return regeneratorRuntime.wrap(function searchProducts$(_context25) {
	    while (1) {
	      switch (_context25.prev = _context25.next) {
	        case 0:
	          _context25.prev = 0;
	          _context25.next = 3;
	          return (0, _effects.call)(Api.getProducts, action.payload.apikey, action.payload.token, action.payload.data);
	
	        case 3:
	          res = _context25.sent;
	          _context25.next = 6;
	          return (0, _effects.put)((0, _reduxActions.createAction)('SEARCH_PRODUCTS_RECEIVED')(res));
	
	        case 6:
	          _context25.next = 16;
	          break;
	
	        case 8:
	          _context25.prev = 8;
	          _context25.t0 = _context25['catch'](0);
	
	          alert('SEARCH_PRODUCTS_FAILED: ' + _context25.t0);
	
	          if (!(_context25.t0.status === 401)) {
	            _context25.next = 14;
	            break;
	          }
	
	          _context25.next = 14;
	          return (0, _effects.put)((0, _reduxActions.createAction)('LOGOUT')());
	
	        case 14:
	          _context25.next = 16;
	          return (0, _effects.put)((0, _reduxActions.createAction)('SEARCH_PRODUCTS_FAILED')(_context25.t0));
	
	        case 16:
	        case 'end':
	          return _context25.stop();
	      }
	    }
	  }, _marked25, this, [[0, 8]]);
	}
	
	function getJobs(action) {
	  var res;
	  return regeneratorRuntime.wrap(function getJobs$(_context26) {
	    while (1) {
	      switch (_context26.prev = _context26.next) {
	        case 0:
	          _context26.prev = 0;
	          _context26.next = 3;
	          return (0, _effects.put)((0, _app.toggleLoading)(true));
	
	        case 3:
	          _context26.next = 5;
	          return (0, _effects.call)(Api.getJobs, action.payload.token, action.payload.data);
	
	        case 5:
	          res = _context26.sent;
	          _context26.next = 8;
	          return (0, _effects.put)((0, _reduxActions.createAction)('GET_JOBS_COMPLETED')(res));
	
	        case 8:
	          _context26.next = 10;
	          return (0, _effects.put)((0, _app.toggleLoading)(false));
	
	        case 10:
	          _context26.next = 20;
	          break;
	
	        case 12:
	          _context26.prev = 12;
	          _context26.t0 = _context26['catch'](0);
	
	          alert('GET_JOBS_FAILED: ' + _context26.t0);
	
	          if (!(_context26.t0.status === 401)) {
	            _context26.next = 18;
	            break;
	          }
	
	          _context26.next = 18;
	          return (0, _effects.put)((0, _reduxActions.createAction)('LOGOUT')());
	
	        case 18:
	          _context26.next = 20;
	          return (0, _effects.put)((0, _reduxActions.createAction)('GET_JOBS_FAILED')(_context26.t0));
	
	        case 20:
	        case 'end':
	          return _context26.stop();
	      }
	    }
	  }, _marked26, this, [[0, 12]]);
	}
	
	function selectAlternativeImage(action) {
	  var data, res2, dataSearchByImage, res;
	  return regeneratorRuntime.wrap(function selectAlternativeImage$(_context27) {
	    while (1) {
	      switch (_context27.prev = _context27.next) {
	        case 0:
	          _context27.prev = 0;
	          _context27.next = 3;
	          return (0, _effects.put)((0, _app.toggleLoading)(true));
	
	        case 3:
	          data = {
	            image: action.payload.data.image.url
	          };
	          _context27.next = 6;
	          return (0, _effects.put)((0, _reduxActions.createAction)('SELECT_ALTERNATIVE_IMAGE_COMPLETED')(action.payload.data.image));
	
	        case 6:
	          _context27.next = 8;
	          return (0, _effects.call)(Api.detect, action.payload.token, data);
	
	        case 8:
	          res2 = _context27.sent;
	
	          // TMPFIX we have 0 detections to mock one to perform any search and let this shit work.
	          if (!(res2 && res2.results && res2.results.detections && res2.results.detections.length)) {
	            res2 = {
	              results: {
	                detections: [{
	                  bbox: {
	                    x1: 0,
	                    y1: 0,
	                    x2: 1,
	                    y2: 1
	                  }
	                }]
	              }
	            };
	          }
	          _context27.next = 12;
	          return (0, _effects.put)((0, _reduxActions.createAction)('RECOGNIZE_PRODUCTS_COMPLETED')(res2.results));
	
	        case 12:
	          // Once we have the new detections we have to call search by image to get the results
	          dataSearchByImage = {
	            bboxes: res2.results.detections && res2.results.detections.length > 0 ? [res2.results.detections[0].bbox] : null,
	            image: action.payload.data.image.url,
	            gender: JSON.parse(action.payload.data.image.customData).gender,
	            maxNumResults: 50,
	            maxNumCategories: 20
	          };
	          _context27.next = 15;
	          return (0, _effects.call)(Api.searchByImageWithApiKey, action.payload.apikey, dataSearchByImage);
	
	        case 15:
	          res = _context27.sent;
	          _context27.next = 18;
	          return (0, _effects.put)((0, _app.toggleLoading)(false));
	
	        case 18:
	          _context27.next = 20;
	          return (0, _effects.put)((0, _reduxActions.createAction)('SEARCH_BY_IMAGE_COMPLETED')({
	            results: res.results,
	            attributes: res.attributes,
	            data: dataSearchByImage
	          }));
	
	        case 20:
	          _context27.next = 30;
	          break;
	
	        case 22:
	          _context27.prev = 22;
	          _context27.t0 = _context27['catch'](0);
	
	          alert('SELECT_ALTENATIVE_IMAGES_FAILED: ' + _context27.t0);
	
	          if (!(_context27.t0.status === 401)) {
	            _context27.next = 28;
	            break;
	          }
	
	          _context27.next = 28;
	          return (0, _effects.put)((0, _reduxActions.createAction)('LOGOUT')());
	
	        case 28:
	          _context27.next = 30;
	          return (0, _effects.put)((0, _reduxActions.createAction)('SELECT_ALTENATIVE_IMAGES_FAILED')(_context27.t0));
	
	        case 30:
	        case 'end':
	          return _context27.stop();
	      }
	    }
	  }, _marked27, this, [[0, 22]]);
	}
	
	function getCategories(action) {
	  var res;
	  return regeneratorRuntime.wrap(function getCategories$(_context28) {
	    while (1) {
	      switch (_context28.prev = _context28.next) {
	        case 0:
	          _context28.prev = 0;
	          _context28.next = 3;
	          return (0, _effects.put)((0, _app.toggleLoading)(true));
	
	        case 3:
	          _context28.next = 5;
	          return (0, _effects.call)(Api.getCategories, action.payload.apikey, action.payload.token);
	
	        case 5:
	          res = _context28.sent;
	          _context28.next = 8;
	          return (0, _effects.put)((0, _reduxActions.createAction)('GET_CATEGORIES_COMPLETED')(res.categories));
	
	        case 8:
	          _context28.next = 10;
	          return (0, _effects.put)((0, _app.toggleLoading)(false));
	
	        case 10:
	          _context28.next = 20;
	          break;
	
	        case 12:
	          _context28.prev = 12;
	          _context28.t0 = _context28['catch'](0);
	
	          alert('GET_CATEGORIES_FAILED: ' + _context28.t0);
	
	          if (!(_context28.t0.status === 401)) {
	            _context28.next = 18;
	            break;
	          }
	
	          _context28.next = 18;
	          return (0, _effects.put)((0, _reduxActions.createAction)('LOGOUT')());
	
	        case 18:
	          _context28.next = 20;
	          return (0, _effects.put)((0, _reduxActions.createAction)('GET_CATEGORIES_FAILED')(_context28.t0));
	
	        case 20:
	        case 'end':
	          return _context28.stop();
	      }
	    }
	  }, _marked28, this, [[0, 12]]);
	}
	
	// PATCH=https://wideeyes.atlassian.net/wiki/spaces/DEV/pages/616759331/WID-823+Imposible+to+change+category+in+annotation+platform
	function changeCategory(action) {
	  var res;
	  return regeneratorRuntime.wrap(function changeCategory$(_context29) {
	    while (1) {
	      switch (_context29.prev = _context29.next) {
	        case 0:
	          _context29.prev = 0;
	          _context29.next = 3;
	          return (0, _effects.put)((0, _app.toggleLoading)(true));
	
	        case 3:
	          _context29.next = 5;
	          return (0, _effects.call)(Api.changeCategory, action.payload.apikey, action.payload.token, {
	            uid: action.payload.uid
	          });
	
	        case 5:
	          res = _context29.sent;
	          _context29.next = 8;
	          return (0, _effects.put)((0, _reduxActions.createAction)('CHANGE_CATEGORY_COMPLETED')(res));
	
	        case 8:
	          _context29.next = 10;
	          return (0, _effects.put)((0, _app.toggleLoading)(false));
	
	        case 10:
	          _context29.next = 20;
	          break;
	
	        case 12:
	          _context29.prev = 12;
	          _context29.t0 = _context29['catch'](0);
	
	          alert('CHANGE_CATEGORY_FAILED: ' + _context29.t0);
	
	          if (!(_context29.t0.status === 401)) {
	            _context29.next = 18;
	            break;
	          }
	
	          _context29.next = 18;
	          return (0, _effects.put)((0, _reduxActions.createAction)('LOGOUT')());
	
	        case 18:
	          _context29.next = 20;
	          return (0, _effects.put)((0, _reduxActions.createAction)('CHANGE_CATEGORY_FAILED')(_context29.t0));
	
	        case 20:
	        case 'end':
	          return _context29.stop();
	      }
	    }
	  }, _marked29, this, [[0, 12]]);
	}
	
	/**
	 * Method to try to extract recognize using images on data.
	 * @param action
	 * @param imageInfo
	 * @param lookInfo
	 * @returns {Generator<*, void, *>}
	 */
	function toValidateRecognize(action, imageInfo, lookInfo) {
	  return regeneratorRuntime.wrap(function toValidateRecognize$(_context30) {
	    while (1) {
	      switch (_context30.prev = _context30.next) {
	        case 0:
	          _context30.prev = 0;
	          _context30.next = 3;
	          return (0, _effects.call)(Api.recognize, action.payload.apikey, { 'image': imageInfo.url, 'gender': lookInfo.gender });
	
	        case 3:
	          return _context30.abrupt('return', _context30.sent);
	
	        case 6:
	          _context30.prev = 6;
	          _context30.t0 = _context30['catch'](0);
	          return _context30.abrupt('return', { 'results': [] // annotator can continue without this data manually.
	          });
	
	        case 9:
	        case 'end':
	          return _context30.stop();
	      }
	    }
	  }, _marked30, this, [[0, 6]]);
	}
	
	/**
	 * Gets next image to be validated.
	 * @param action
	 * @returns {Generator<(CallEffect|Generator<*, void, *>)[]|CallEffect|PutEffect<*>, void, *>}
	 */
	function toValidate(action) {
	  var res, lookInfo, imageUrl, _ref, _ref2, res2, recognizeResult;
	
	  return regeneratorRuntime.wrap(function toValidate$(_context31) {
	    while (1) {
	      switch (_context31.prev = _context31.next) {
	        case 0:
	          _context31.prev = 0;
	          _context31.next = 3;
	          return (0, _effects.put)((0, _app.toggleLoading)(true));
	
	        case 3:
	          _context31.next = 5;
	          return (0, _effects.call)(Api.toValidate, action.payload.token, action.payload.data);
	
	        case 5:
	          res = _context31.sent;
	          lookInfo = JSON.parse(res.customData);
	          // TMPFIX: Another shit hack to avoid images without url we got one from alternatives.
	
	          imageUrl = res.url;
	
	          if (!imageUrl && lookInfo.alternativeImages) {
	            imageUrl = lookInfo.alternativeImages[0];
	          }
	          res.url = imageUrl;
	          _context31.next = 12;
	          return [(0, _effects.call)(Api.getAnnotations, action.payload.token, {
	            image: res,
	            jobId: action.payload.data.jobId
	          }), toValidateRecognize(action, res, lookInfo)];
	
	        case 12:
	          _ref = _context31.sent;
	          _ref2 = _slicedToArray(_ref, 2);
	          res2 = _ref2[0];
	          recognizeResult = _ref2[1];
	
	          res2.annotations[0].data = JSON.stringify(recognizeResult);
	          _context31.next = 19;
	          return (0, _effects.put)((0, _reduxActions.createAction)('GET_IMAGE_TO_VALIDATE_COMPLETED')(res));
	
	        case 19:
	          _context31.next = 21;
	          return (0, _effects.put)((0, _reduxActions.createAction)('GET_ANNOTATIONS_COMPLETED')(res2));
	
	        case 21:
	          _context31.next = 23;
	          return (0, _effects.put)((0, _app.toggleLoading)(false));
	
	        case 23:
	          _context31.next = 33;
	          break;
	
	        case 25:
	          _context31.prev = 25;
	          _context31.t0 = _context31['catch'](0);
	
	          alert('There aren\'t looks to annotate for this user');
	
	          if (!(_context31.t0.status === 401)) {
	            _context31.next = 31;
	            break;
	          }
	
	          _context31.next = 31;
	          return (0, _effects.put)((0, _reduxActions.createAction)('LOGOUT')());
	
	        case 31:
	          _context31.next = 33;
	          return (0, _effects.put)((0, _reduxActions.createAction)('GET_IMAGE_TO_VALIDATE_FAILED')(_context31.t0));
	
	        case 33:
	        case 'end':
	          return _context31.stop();
	      }
	    }
	  }, _marked31, this, [[0, 25]]);
	}
	
	function getAnnotations(action) {
	  var res;
	  return regeneratorRuntime.wrap(function getAnnotations$(_context32) {
	    while (1) {
	      switch (_context32.prev = _context32.next) {
	        case 0:
	          _context32.prev = 0;
	          _context32.next = 3;
	          return (0, _effects.put)((0, _app.toggleLoading)(true));
	
	        case 3:
	          _context32.next = 5;
	          return (0, _effects.call)(Api.recognize, action.payload.token, action.payload.data);
	
	        case 5:
	          res = _context32.sent;
	          _context32.next = 8;
	          return (0, _effects.put)((0, _reduxActions.createAction)('GET_ANNOTATIONS_COMPLETED')(res));
	
	        case 8:
	          _context32.next = 10;
	          return (0, _effects.put)((0, _app.toggleLoading)(false));
	
	        case 10:
	          _context32.next = 20;
	          break;
	
	        case 12:
	          _context32.prev = 12;
	          _context32.t0 = _context32['catch'](0);
	
	          alert('GET_ANNOTATIONS_FAILED: ' + _context32.t0);
	
	          if (!(_context32.t0.status === 401)) {
	            _context32.next = 18;
	            break;
	          }
	
	          _context32.next = 18;
	          return (0, _effects.put)((0, _reduxActions.createAction)('LOGOUT')());
	
	        case 18:
	          _context32.next = 20;
	          return (0, _effects.put)((0, _reduxActions.createAction)('GET_ANNOTATIONS_FAILED')(_context32.t0));
	
	        case 20:
	        case 'end':
	          return _context32.stop();
	      }
	    }
	  }, _marked32, this, [[0, 12]]);
	}
	
	function recognize(action) {
	  var res;
	  return regeneratorRuntime.wrap(function recognize$(_context33) {
	    while (1) {
	      switch (_context33.prev = _context33.next) {
	        case 0:
	          _context33.prev = 0;
	          _context33.next = 3;
	          return (0, _effects.put)((0, _app.toggleLoading)(true));
	
	        case 3:
	          _context33.next = 5;
	          return (0, _effects.call)(Api.recognize, action.payload.token, action.payload.data);
	
	        case 5:
	          res = _context33.sent;
	          _context33.next = 8;
	          return (0, _effects.put)((0, _reduxActions.createAction)('RECOGNIZE_PRODUCTS_COMPLETED')(res));
	
	        case 8:
	          _context33.next = 10;
	          return (0, _effects.put)((0, _app.toggleLoading)(false));
	
	        case 10:
	          forwardTo('/');
	          _context33.next = 21;
	          break;
	
	        case 13:
	          _context33.prev = 13;
	          _context33.t0 = _context33['catch'](0);
	
	          alert('RECOGNIZE_PRODUCTS_FAILED: ' + _context33.t0);
	
	          if (!(_context33.t0.status === 401)) {
	            _context33.next = 19;
	            break;
	          }
	
	          _context33.next = 19;
	          return (0, _effects.put)((0, _reduxActions.createAction)('LOGOUT')());
	
	        case 19:
	          _context33.next = 21;
	          return (0, _effects.put)((0, _reduxActions.createAction)('RECOGNIZE_PRODUCTS_FAILED')(_context33.t0));
	
	        case 21:
	        case 'end':
	          return _context33.stop();
	      }
	    }
	  }, _marked33, this, [[0, 13]]);
	}
	
	function skipAndNextJob(action) {
	  return regeneratorRuntime.wrap(function skipAndNextJob$(_context34) {
	    while (1) {
	      switch (_context34.prev = _context34.next) {
	        case 0:
	          _context34.prev = 0;
	          _context34.next = 3;
	          return (0, _effects.put)((0, _app.toggleLoading)(true));
	
	        case 3:
	          _context34.next = 5;
	          return (0, _effects.call)(Api.deleteImage, action.payload.token, {
	            imageId: action.payload.data.uid,
	            jobId: action.payload.data.jobId
	          });
	
	        case 5:
	          _context34.next = 7;
	          return (0, _effects.put)((0, _app.toggleLoading)(false));
	
	        case 7:
	
	          location.reload();
	          _context34.next = 18;
	          break;
	
	        case 10:
	          _context34.prev = 10;
	          _context34.t0 = _context34['catch'](0);
	
	          alert('SKIP_AND_FINISH_FAILED: ' + _context34.t0);
	
	          if (!(_context34.t0.status === 401)) {
	            _context34.next = 16;
	            break;
	          }
	
	          _context34.next = 16;
	          return (0, _effects.put)((0, _reduxActions.createAction)('LOGOUT')());
	
	        case 16:
	          _context34.next = 18;
	          return (0, _effects.put)((0, _reduxActions.createAction)('SKIP_AND_FINISH_FAILED')(_context34.t0));
	
	        case 18:
	        case 'end':
	          return _context34.stop();
	      }
	    }
	  }, _marked34, this, [[0, 10]]);
	}
	
	function resetAndNextJob(action) {
	  var simplifiedDetections, res, res2;
	  return regeneratorRuntime.wrap(function resetAndNextJob$(_context35) {
	    while (1) {
	      switch (_context35.prev = _context35.next) {
	        case 0:
	          simplifiedDetections = action.payload.data.annotationData.detections.map(function (x) {
	            delete x.attributes;
	            delete x.results;
	            return x;
	          });
	          _context35.prev = 1;
	          _context35.next = 4;
	          return (0, _effects.put)((0, _app.toggleLoading)(true));
	
	        case 4:
	          _context35.next = 6;
	          return (0, _effects.call)(Api.saveDetection, action.payload.token, {
	            jobId: action.payload.data.annotationData.jobId,
	            annotationId: action.payload.data.annotationData.annotationId,
	            imageId: action.payload.data.imageData.id
	          }, {
	            data: JSON.stringify({
	              errors: [],
	              results: simplifiedDetections
	            })
	          });
	
	        case 6:
	          res = _context35.sent;
	          _context35.next = 9;
	          return (0, _effects.call)(Api.toLastJob, action.payload.token, {
	            jobId: parseInt(action.payload.data.imageData.jobId),
	            imageId: parseInt(action.payload.data.imageData.id)
	          });
	
	        case 9:
	          res2 = _context35.sent;
	          _context35.next = 12;
	          return (0, _effects.put)((0, _app.toggleLoading)(false));
	
	        case 12:
	          _context35.next = 14;
	          return (0, _effects.put)((0, _reduxActions.createAction)('RESET_AND_FINISH_COMPLETE')());
	
	        case 14:
	          if (res && res2) {
	            setTimeout(function () {
	              location.reload();
	            }, 3000);
	          }
	          _context35.next = 25;
	          break;
	
	        case 17:
	          _context35.prev = 17;
	          _context35.t0 = _context35['catch'](1);
	
	          alert('RESET_AND_FINISH_FAILED: ' + _context35.t0);
	
	          if (!(_context35.t0.status === 401)) {
	            _context35.next = 23;
	            break;
	          }
	
	          _context35.next = 23;
	          return (0, _effects.put)((0, _reduxActions.createAction)('LOGOUT')());
	
	        case 23:
	          _context35.next = 25;
	          return (0, _effects.put)((0, _reduxActions.createAction)('RESET_AND_FINISH_FAILED')(_context35.t0));
	
	        case 25:
	        case 'end':
	          return _context35.stop();
	      }
	    }
	  }, _marked35, this, [[1, 17]]);
	}
	
	function saveAllAndNextJob(action) {
	  var simplifiedDetections, res, res2, res3;
	  return regeneratorRuntime.wrap(function saveAllAndNextJob$(_context36) {
	    while (1) {
	      switch (_context36.prev = _context36.next) {
	        case 0:
	          // remove data we don't want to send
	          simplifiedDetections = action.payload.data.annotationData.detections.map(function (x) {
	            delete x.attributes;
	            delete x.internal_ref;
	            delete x.results;
	            return x;
	          });
	          _context36.prev = 1;
	          _context36.next = 4;
	          return (0, _effects.put)((0, _app.toggleLoading)(true));
	
	        case 4:
	          _context36.next = 6;
	          return (0, _effects.call)(Api.saveDetection, action.payload.token, {
	            jobId: action.payload.data.annotationData.jobId,
	            annotationId: action.payload.data.annotationData.annotationId,
	            imageId: action.payload.data.imageData.id
	          }, {
	            data: JSON.stringify({
	              errors: [],
	              results: simplifiedDetections
	            })
	          });
	
	        case 6:
	          res = _context36.sent;
	          _context36.next = 9;
	          return (0, _effects.call)(Api.updateImage, action.payload.token, {
	            jobId: action.payload.data.imageData.jobId,
	            imageId: action.payload.data.imageData.id
	          }, action.payload.data.imageData);
	
	        case 9:
	          res2 = _context36.sent;
	          _context36.next = 12;
	          return (0, _effects.call)(Api.toNextJob, action.payload.token, {
	            jobId: parseInt(action.payload.data.imageData.jobId),
	            imageId: parseInt(action.payload.data.imageData.id)
	          });
	
	        case 12:
	          res3 = _context36.sent;
	          _context36.next = 15;
	          return (0, _effects.put)((0, _reduxActions.createAction)('SAVE_ALL_COMPLETED')({}));
	
	        case 15:
	          if (res && res2 && res3) {
	            setTimeout(function () {
	              location.reload();
	            }, 3000);
	          } else {
	            alert('Error occured sending information. Please, try again. ');
	          }
	          _context36.next = 26;
	          break;
	
	        case 18:
	          _context36.prev = 18;
	          _context36.t0 = _context36['catch'](1);
	
	          alert('SAVE_ALL_COMPLETED_FAILED: ' + _context36.t0);
	
	          if (!(_context36.t0.status === 401)) {
	            _context36.next = 24;
	            break;
	          }
	
	          _context36.next = 24;
	          return (0, _effects.put)((0, _reduxActions.createAction)('LOGOUT')());
	
	        case 24:
	          _context36.next = 26;
	          return (0, _effects.put)((0, _reduxActions.createAction)('SAVE_ALL_COMPLETED_FAILED')(_context36.t0));
	
	        case 26:
	        case 'end':
	          return _context36.stop();
	      }
	    }
	  }, _marked36, this, [[1, 18]]);
	}
	
	function searchById(action) {
	  var res;
	  return regeneratorRuntime.wrap(function searchById$(_context37) {
	    while (1) {
	      switch (_context37.prev = _context37.next) {
	        case 0:
	          _context37.prev = 0;
	          _context37.next = 3;
	          return (0, _effects.call)(Api.searchById, action.payload.apikey, action.payload.data);
	
	        case 3:
	          res = _context37.sent;
	          _context37.next = 6;
	          return (0, _effects.put)((0, _reduxActions.createAction)('GET_SIMILARS_COMPLETED')({
	            results: res.results[0].products
	          }));
	
	        case 6:
	          _context37.next = 11;
	          break;
	
	        case 8:
	          _context37.prev = 8;
	          _context37.t0 = _context37['catch'](0);
	
	          alert('GET_SIMILARS_FAILED: ' + _context37.t0);
	
	        case 11:
	        case 'end':
	          return _context37.stop();
	      }
	    }
	  }, _marked37, this, [[0, 8]]);
	}
	
	function searchByImage(action) {
	  var res;
	  return regeneratorRuntime.wrap(function searchByImage$(_context38) {
	    while (1) {
	      switch (_context38.prev = _context38.next) {
	        case 0:
	          _context38.prev = 0;
	          _context38.next = 3;
	          return (0, _effects.put)((0, _app.toggleLoading)(true));
	
	        case 3:
	          _context38.next = 5;
	          return (0, _effects.call)(Api.searchByImageWithApiKey, action.payload.apikey, action.payload.data);
	
	        case 5:
	          res = _context38.sent;
	          _context38.next = 8;
	          return (0, _effects.put)((0, _app.toggleLoading)(false));
	
	        case 8:
	          _context38.next = 10;
	          return (0, _effects.put)((0, _reduxActions.createAction)('SEARCH_BY_IMAGE_COMPLETED')({
	            results: res.results,
	            attributes: res.attributes,
	            data: action.payload.data
	          }));
	
	        case 10:
	          _context38.next = 20;
	          break;
	
	        case 12:
	          _context38.prev = 12;
	          _context38.t0 = _context38['catch'](0);
	
	          alert('SEARCH_BY_IMAGE_FAILED: ' + _context38.t0);
	
	          if (!(_context38.t0.status === 401)) {
	            _context38.next = 18;
	            break;
	          }
	
	          _context38.next = 18;
	          return (0, _effects.put)((0, _reduxActions.createAction)('LOGOUT')());
	
	        case 18:
	          _context38.next = 20;
	          return (0, _effects.put)((0, _reduxActions.createAction)('SEARCH_BY_IMAGE_FAILED')(_context38.t0));
	
	        case 20:
	        case 'end':
	          return _context38.stop();
	      }
	    }
	  }, _marked38, this, [[0, 12]]);
	}
	
	function getLook(action) {
	  var res;
	  return regeneratorRuntime.wrap(function getLook$(_context39) {
	    while (1) {
	      switch (_context39.prev = _context39.next) {
	        case 0:
	          _context39.prev = 0;
	          _context39.next = 3;
	          return (0, _effects.call)(Api.getLook, action.payload.apikey, action.payload.token, action.payload.data);
	
	        case 3:
	          res = _context39.sent;
	          _context39.next = 6;
	          return (0, _effects.put)((0, _reduxActions.createAction)('GET_LOOK_COMPLETED')({
	            results: res.results
	          }));
	
	        case 6:
	          _context39.next = 12;
	          break;
	
	        case 8:
	          _context39.prev = 8;
	          _context39.t0 = _context39['catch'](0);
	          _context39.next = 12;
	          return (0, _effects.put)((0, _reduxActions.createAction)('GET_LOOK_FAILED')(_context39.t0));
	
	        case 12:
	        case 'end':
	          return _context39.stop();
	      }
	    }
	  }, _marked39, this, [[0, 8]]);
	}
	
	function getLookProducts(action) {
	  var filteredUids, calls, responses, looksNoProducts;
	  return regeneratorRuntime.wrap(function getLookProducts$(_context40) {
	    while (1) {
	      switch (_context40.prev = _context40.next) {
	        case 0:
	          _context40.prev = 0;
	          filteredUids = action.payload.data.uids.filter(function (uid) {
	            return uid != null;
	          });
	          calls = filteredUids.map(function (uid) {
	            return (0, _effects.call)(getLookProductsCall, action.payload.apikey, action.payload.token, uid);
	          });
	          _context40.next = 5;
	          return (0, _effects.all)(calls);
	
	        case 5:
	          responses = _context40.sent;
	          looksNoProducts = action.payload.data.lookNoProducts || [];
	          _context40.next = 9;
	          return (0, _effects.put)((0, _reduxActions.createAction)('GET_LOOK_PRODUCTS_COMPLETED')({
	            results: responses.map(function (res) {
	              return res.results[0];
	            }),
	            lookNoProducts: looksNoProducts
	          }));
	
	        case 9:
	          _context40.next = 15;
	          break;
	
	        case 11:
	          _context40.prev = 11;
	          _context40.t0 = _context40['catch'](0);
	          _context40.next = 15;
	          return (0, _effects.put)((0, _reduxActions.createAction)('GET_LOOK_PRODUCTS_FAILED')(_context40.t0));
	
	        case 15:
	        case 'end':
	          return _context40.stop();
	      }
	    }
	  }, _marked40, this, [[0, 11]]);
	}
	
	function getAnnotationFromStyleAdvisor(action) {
	  var _action$payload, apikey, data, token, res, payload;
	
	  return regeneratorRuntime.wrap(function getAnnotationFromStyleAdvisor$(_context41) {
	    while (1) {
	      switch (_context41.prev = _context41.next) {
	        case 0:
	          _context41.prev = 0;
	          _action$payload = action.payload, apikey = _action$payload.apikey, data = _action$payload.data, token = _action$payload.token;
	          _context41.next = 4;
	          return (0, _effects.call)(Api.getAnnotationFromStyleAdvisor, apikey, data);
	
	        case 4:
	          res = _context41.sent;
	          payload = _extends({}, res, { token: token });
	          _context41.next = 8;
	          return (0, _effects.put)((0, _reduxActions.createAction)('GET_ANNOTATION_FROM_STYLE_ADVISOR_COMPLETED')(payload));
	
	        case 8:
	          _context41.next = 14;
	          break;
	
	        case 10:
	          _context41.prev = 10;
	          _context41.t0 = _context41['catch'](0);
	          _context41.next = 14;
	          return (0, _effects.put)((0, _reduxActions.createAction)('GET_ANNOTATION_FROM_STYLE_ADVISOR_FAILED')(_context41.t0));
	
	        case 14:
	        case 'end':
	          return _context41.stop();
	      }
	    }
	  }, _marked41, this, [[0, 10]]);
	}
	
	function getTwinnedLooks(action) {
	  var _action$payload2, apikey, data, token, responseTwinnedLooks, twinnedLooks, calls, resultCalls, allProductLooks, updatedLooks, payload;
	
	  return regeneratorRuntime.wrap(function getTwinnedLooks$(_context42) {
	    while (1) {
	      switch (_context42.prev = _context42.next) {
	        case 0:
	          _context42.prev = 0;
	          _action$payload2 = action.payload, apikey = _action$payload2.apikey, data = _action$payload2.data, token = _action$payload2.token;
	          _context42.next = 4;
	          return (0, _effects.call)(Api.getTwinnedLooks, apikey, data);
	
	        case 4:
	          responseTwinnedLooks = _context42.sent;
	          twinnedLooks = responseTwinnedLooks.result.results;
	          calls = [];
	
	          twinnedLooks.map(function (look) {
	            calls.push(look.products.map(function (product) {
	              return (0, _effects.call)(getLookProductsCall, apikey, token, product.match);
	            }));
	          });
	          _context42.next = 10;
	          return (0, _effects.all)(calls);
	
	        case 10:
	          resultCalls = _context42.sent;
	          allProductLooks = {};
	
	          resultCalls.forEach(function (responseCallForLook) {
	            responseCallForLook.forEach(function (_ref3) {
	              var errors = _ref3.errors,
	                  results = _ref3.results;
	
	              var prod = results[0];
	              allProductLooks[prod.uid] = prod;
	            });
	          });
	
	          /**
	           * We want to rebuild every twinned look object
	           * to have all the matches (products) details from the api
	           */
	          updatedLooks = twinnedLooks.map(function (look) {
	            var updatedProducts = look.products.map(function (product) {
	              return _extends({}, allProductLooks[product.match]);
	            });
	            return _extends({}, look, { products: updatedProducts });
	          });
	          payload = { result: updatedLooks, token: token };
	          _context42.next = 17;
	          return (0, _effects.put)((0, _reduxActions.createAction)('GET_TWINNED_LOOKS_COMPLETED')(payload));
	
	        case 17:
	          _context42.next = 23;
	          break;
	
	        case 19:
	          _context42.prev = 19;
	          _context42.t0 = _context42['catch'](0);
	          _context42.next = 23;
	          return (0, _effects.put)((0, _reduxActions.createAction)('GET_TWINNED_LOOKS_FAILED')(_context42.t0));
	
	        case 23:
	        case 'end':
	          return _context42.stop();
	      }
	    }
	  }, _marked42, this, [[0, 19]]);
	}
	
	function getTextSearch(action) {
	  var _action$payload3, apikey, data, res;
	
	  return regeneratorRuntime.wrap(function getTextSearch$(_context43) {
	    while (1) {
	      switch (_context43.prev = _context43.next) {
	        case 0:
	          _context43.prev = 0;
	          _action$payload3 = action.payload, apikey = _action$payload3.apikey, data = _action$payload3.data;
	          _context43.next = 4;
	          return (0, _effects.call)(Api.getTextSearchProducts, apikey, data);
	
	        case 4:
	          res = _context43.sent;
	          _context43.next = 7;
	          return (0, _effects.put)((0, _reduxActions.createAction)('GET_TEXT_SEARCH_COMPLETED')({
	            results: res.results[0].products
	          }));
	
	        case 7:
	          _context43.next = 13;
	          break;
	
	        case 9:
	          _context43.prev = 9;
	          _context43.t0 = _context43['catch'](0);
	          _context43.next = 13;
	          return (0, _effects.put)((0, _reduxActions.createAction)('GET_TEXT_SEARCH_FAILED')(_context43.t0));
	
	        case 13:
	        case 'end':
	          return _context43.stop();
	      }
	    }
	  }, _marked43, this, [[0, 9]]);
	}
	
	function getFinalAnnotationLookProducts(action) {
	  var _action$payload4, apikey, data, token, calls, resultCalls, allProductLooks, payload;
	
	  return regeneratorRuntime.wrap(function getFinalAnnotationLookProducts$(_context44) {
	    while (1) {
	      switch (_context44.prev = _context44.next) {
	        case 0:
	          _context44.prev = 0;
	          _action$payload4 = action.payload, apikey = _action$payload4.apikey, data = _action$payload4.data, token = _action$payload4.token;
	
	          console.log('getFinalAnnotationLookProducts data: ', data);
	
	          calls = [];
	
	
	          calls.push(data.map(function (detection) {
	            if ('perfectMatch' in detection) {
	              return (0, _effects.call)(getLookProductsCall, apikey, token, detection.perfectMatch);
	            } else {
	              return null;
	            }
	          }));
	          _context44.next = 7;
	          return (0, _effects.all)(calls);
	
	        case 7:
	          resultCalls = _context44.sent;
	          allProductLooks = [];
	
	
	          resultCalls.forEach(function (responseCallForLook) {
	            responseCallForLook.forEach(function (response) {
	              if (response) {
	                var results = response.results;
	
	                if (results && results.length > 0) {
	                  if (results[0]) {
	                    allProductLooks.push(results[0]);
	                  }
	                }
	              }
	            });
	          });
	
	          if (!(allProductLooks.length === 0)) {
	            _context44.next = 15;
	            break;
	          }
	
	          _context44.next = 13;
	          return (0, _effects.put)((0, _reduxActions.createAction)('GET_ANNOTATIONS_FINAL_LOOK_PRODUCTS_FAILED')('No products annoted.'));
	
	        case 13:
	          _context44.next = 18;
	          break;
	
	        case 15:
	          payload = { result: allProductLooks, token: token };
	          _context44.next = 18;
	          return (0, _effects.put)((0, _reduxActions.createAction)('GET_ANNOTATIONS_FINAL_LOOK_PRODUCTS_COMPLETED')(payload));
	
	        case 18:
	          _context44.next = 24;
	          break;
	
	        case 20:
	          _context44.prev = 20;
	          _context44.t0 = _context44['catch'](0);
	          _context44.next = 24;
	          return (0, _effects.put)((0, _reduxActions.createAction)('GET_ANNOTATIONS_FINAL_LOOK_PRODUCTS_FAILED')(_context44.t0));
	
	        case 24:
	        case 'end':
	          return _context44.stop();
	      }
	    }
	  }, _marked44, this, [[0, 20]]);
	}
	
	function getLookProductsCall(apikey, token, uid) {
	  return regeneratorRuntime.wrap(function getLookProductsCall$(_context45) {
	    while (1) {
	      switch (_context45.prev = _context45.next) {
	        case 0:
	          _context45.prev = 0;
	          _context45.next = 3;
	          return (0, _effects.call)(Api.getLookProducts, apikey, token, uid);
	
	        case 3:
	          return _context45.abrupt('return', _context45.sent);
	
	        case 6:
	          _context45.prev = 6;
	          _context45.t0 = _context45['catch'](0);
	          _context45.next = 10;
	          return (0, _effects.call)(Api.getLookProductsInactive, apikey, token, uid);
	
	        case 10:
	          return _context45.abrupt('return', _context45.sent);
	
	        case 11:
	        case 'end':
	          return _context45.stop();
	      }
	    }
	  }, _marked45, this, [[0, 6]]);
	}
	
	function login(action) {
	  var _ref4, access_token, res;
	
	  return regeneratorRuntime.wrap(function login$(_context46) {
	    while (1) {
	      switch (_context46.prev = _context46.next) {
	        case 0:
	          _context46.prev = 0;
	          _context46.next = 3;
	          return (0, _effects.call)(Api.login, action.payload);
	
	        case 3:
	          _ref4 = _context46.sent;
	          access_token = _ref4.access_token;
	          _context46.next = 7;
	          return (0, _effects.put)((0, _app.toggleLoading)(true));
	
	        case 7:
	          _context46.next = 9;
	          return (0, _effects.call)(Api.getUser, access_token);
	
	        case 9:
	          res = _context46.sent;
	          _context46.next = 12;
	          return (0, _effects.put)((0, _app.toggleLoading)(false));
	
	        case 12:
	          _context46.next = 14;
	          return (0, _effects.put)((0, _reduxActions.createAction)('USER_LOGGED_IN_COMPLETED')(_extends({}, res, { token: access_token })));
	
	        case 14:
	
	          forwardTo('/');
	          _context46.next = 22;
	          break;
	
	        case 17:
	          _context46.prev = 17;
	          _context46.t0 = _context46['catch'](0);
	
	          alert('USER_LOGGED_IN_FAILED: ' + _context46.t0);
	          _context46.next = 22;
	          return (0, _effects.put)((0, _reduxActions.createAction)('USER_LOGGED_IN_FAILED')(_context46.t0));
	
	        case 22:
	        case 'end':
	          return _context46.stop();
	      }
	    }
	  }, _marked46, this, [[0, 17]]);
	}
	
	function getUser(action) {
	  var res, payload;
	  return regeneratorRuntime.wrap(function getUser$(_context47) {
	    while (1) {
	      switch (_context47.prev = _context47.next) {
	        case 0:
	          _context47.prev = 0;
	          _context47.next = 3;
	          return (0, _effects.call)(Api.getUser, action.payload);
	
	        case 3:
	          res = _context47.sent;
	          payload = _extends({}, res, { token: action.payload });
	          _context47.next = 7;
	          return (0, _effects.put)((0, _reduxActions.createAction)('GET_USER_COMPLETED')(payload));
	
	        case 7:
	          _context47.next = 14;
	          break;
	
	        case 9:
	          _context47.prev = 9;
	          _context47.t0 = _context47['catch'](0);
	
	          alert('GET_USER_FAILED: ' + _context47.t0);
	          _context47.next = 14;
	          return (0, _effects.put)((0, _reduxActions.createAction)('GET_USER_FAILED')(_context47.t0));
	
	        case 14:
	        case 'end':
	          return _context47.stop();
	      }
	    }
	  }, _marked47, this, [[0, 9]]);
	}
	
	var forwardTo = function forwardTo(loc) {
	  return _reactRouter.browserHistory.push(loc);
	};

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _io = __webpack_require__(958);
	
	Object.defineProperty(exports, 'take', {
	  enumerable: true,
	  get: function get() {
	    return _io.take;
	  }
	});
	Object.defineProperty(exports, 'takem', {
	  enumerable: true,
	  get: function get() {
	    return _io.takem;
	  }
	});
	Object.defineProperty(exports, 'put', {
	  enumerable: true,
	  get: function get() {
	    return _io.put;
	  }
	});
	Object.defineProperty(exports, 'all', {
	  enumerable: true,
	  get: function get() {
	    return _io.all;
	  }
	});
	Object.defineProperty(exports, 'race', {
	  enumerable: true,
	  get: function get() {
	    return _io.race;
	  }
	});
	Object.defineProperty(exports, 'call', {
	  enumerable: true,
	  get: function get() {
	    return _io.call;
	  }
	});
	Object.defineProperty(exports, 'apply', {
	  enumerable: true,
	  get: function get() {
	    return _io.apply;
	  }
	});
	Object.defineProperty(exports, 'cps', {
	  enumerable: true,
	  get: function get() {
	    return _io.cps;
	  }
	});
	Object.defineProperty(exports, 'fork', {
	  enumerable: true,
	  get: function get() {
	    return _io.fork;
	  }
	});
	Object.defineProperty(exports, 'spawn', {
	  enumerable: true,
	  get: function get() {
	    return _io.spawn;
	  }
	});
	Object.defineProperty(exports, 'join', {
	  enumerable: true,
	  get: function get() {
	    return _io.join;
	  }
	});
	Object.defineProperty(exports, 'cancel', {
	  enumerable: true,
	  get: function get() {
	    return _io.cancel;
	  }
	});
	Object.defineProperty(exports, 'select', {
	  enumerable: true,
	  get: function get() {
	    return _io.select;
	  }
	});
	Object.defineProperty(exports, 'actionChannel', {
	  enumerable: true,
	  get: function get() {
	    return _io.actionChannel;
	  }
	});
	Object.defineProperty(exports, 'cancelled', {
	  enumerable: true,
	  get: function get() {
	    return _io.cancelled;
	  }
	});
	Object.defineProperty(exports, 'flush', {
	  enumerable: true,
	  get: function get() {
	    return _io.flush;
	  }
	});
	Object.defineProperty(exports, 'getContext', {
	  enumerable: true,
	  get: function get() {
	    return _io.getContext;
	  }
	});
	Object.defineProperty(exports, 'setContext', {
	  enumerable: true,
	  get: function get() {
	    return _io.setContext;
	  }
	});
	Object.defineProperty(exports, 'takeEvery', {
	  enumerable: true,
	  get: function get() {
	    return _io.takeEvery;
	  }
	});
	Object.defineProperty(exports, 'takeLatest', {
	  enumerable: true,
	  get: function get() {
	    return _io.takeLatest;
	  }
	});
	Object.defineProperty(exports, 'throttle', {
	  enumerable: true,
	  get: function get() {
	    return _io.throttle;
	  }
	});

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.asEffect = exports.takem = undefined;
	exports.take = take;
	exports.put = put;
	exports.all = all;
	exports.race = race;
	exports.call = call;
	exports.apply = apply;
	exports.cps = cps;
	exports.fork = fork;
	exports.spawn = spawn;
	exports.join = join;
	exports.cancel = cancel;
	exports.select = select;
	exports.actionChannel = actionChannel;
	exports.cancelled = cancelled;
	exports.flush = flush;
	exports.getContext = getContext;
	exports.setContext = setContext;
	exports.takeEvery = takeEvery;
	exports.takeLatest = takeLatest;
	exports.throttle = throttle;
	
	var _utils = __webpack_require__(959);
	
	var _sagaHelpers = __webpack_require__(960);
	
	var IO = (0, _utils.sym)('IO');
	var TAKE = 'TAKE';
	var PUT = 'PUT';
	var ALL = 'ALL';
	var RACE = 'RACE';
	var CALL = 'CALL';
	var CPS = 'CPS';
	var FORK = 'FORK';
	var JOIN = 'JOIN';
	var CANCEL = 'CANCEL';
	var SELECT = 'SELECT';
	var ACTION_CHANNEL = 'ACTION_CHANNEL';
	var CANCELLED = 'CANCELLED';
	var FLUSH = 'FLUSH';
	var GET_CONTEXT = 'GET_CONTEXT';
	var SET_CONTEXT = 'SET_CONTEXT';
	
	var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';
	
	var effect = function effect(type, payload) {
	  var _ref;
	
	  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
	};
	
	function take() {
	  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';
	
	  if (arguments.length) {
	    (0, _utils.check)(arguments[0], _utils.is.notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
	  }
	  if (_utils.is.pattern(patternOrChannel)) {
	    return effect(TAKE, { pattern: patternOrChannel });
	  }
	  if (_utils.is.channel(patternOrChannel)) {
	    return effect(TAKE, { channel: patternOrChannel });
	  }
	  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
	}
	
	take.maybe = function () {
	  var eff = take.apply(undefined, arguments);
	  eff[TAKE].maybe = true;
	  return eff;
	};
	
	var takem = /*#__PURE__*/exports.takem = (0, _utils.deprecate)(take.maybe, /*#__PURE__*/(0, _utils.updateIncentive)('takem', 'take.maybe'));
	
	function put(channel, action) {
	  if (arguments.length > 1) {
	    (0, _utils.check)(channel, _utils.is.notUndef, 'put(channel, action): argument channel is undefined');
	    (0, _utils.check)(channel, _utils.is.channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
	    (0, _utils.check)(action, _utils.is.notUndef, 'put(channel, action): argument action is undefined');
	  } else {
	    (0, _utils.check)(channel, _utils.is.notUndef, 'put(action): argument action is undefined');
	    action = channel;
	    channel = null;
	  }
	  return effect(PUT, { channel: channel, action: action });
	}
	
	put.resolve = function () {
	  var eff = put.apply(undefined, arguments);
	  eff[PUT].resolve = true;
	  return eff;
	};
	
	put.sync = (0, _utils.deprecate)(put.resolve, (0, _utils.updateIncentive)('put.sync', 'put.resolve'));
	
	function all(effects) {
	  return effect(ALL, effects);
	}
	
	function race(effects) {
	  return effect(RACE, effects);
	}
	
	function getFnCallDesc(meth, fn, args) {
	  (0, _utils.check)(fn, _utils.is.notUndef, meth + ': argument fn is undefined');
	
	  var context = null;
	  if (_utils.is.array(fn)) {
	    var _fn = fn;
	    context = _fn[0];
	    fn = _fn[1];
	  } else if (fn.fn) {
	    var _fn2 = fn;
	    context = _fn2.context;
	    fn = _fn2.fn;
	  }
	  if (context && _utils.is.string(fn) && _utils.is.func(context[fn])) {
	    fn = context[fn];
	  }
	  (0, _utils.check)(fn, _utils.is.func, meth + ': argument ' + fn + ' is not a function');
	
	  return { context: context, fn: fn, args: args };
	}
	
	function call(fn) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return effect(CALL, getFnCallDesc('call', fn, args));
	}
	
	function apply(context, fn) {
	  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
	}
	
	function cps(fn) {
	  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    args[_key2 - 1] = arguments[_key2];
	  }
	
	  return effect(CPS, getFnCallDesc('cps', fn, args));
	}
	
	function fork(fn) {
	  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    args[_key3 - 1] = arguments[_key3];
	  }
	
	  return effect(FORK, getFnCallDesc('fork', fn, args));
	}
	
	function spawn(fn) {
	  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    args[_key4 - 1] = arguments[_key4];
	  }
	
	  var eff = fork.apply(undefined, [fn].concat(args));
	  eff[FORK].detached = true;
	  return eff;
	}
	
	function join() {
	  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	    tasks[_key5] = arguments[_key5];
	  }
	
	  if (tasks.length > 1) {
	    return all(tasks.map(function (t) {
	      return join(t);
	    }));
	  }
	  var task = tasks[0];
	  (0, _utils.check)(task, _utils.is.notUndef, 'join(task): argument task is undefined');
	  (0, _utils.check)(task, _utils.is.task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
	  return effect(JOIN, task);
	}
	
	function cancel() {
	  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	    tasks[_key6] = arguments[_key6];
	  }
	
	  if (tasks.length > 1) {
	    return all(tasks.map(function (t) {
	      return cancel(t);
	    }));
	  }
	  var task = tasks[0];
	  if (tasks.length === 1) {
	    (0, _utils.check)(task, _utils.is.notUndef, 'cancel(task): argument task is undefined');
	    (0, _utils.check)(task, _utils.is.task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
	  }
	  return effect(CANCEL, task || _utils.SELF_CANCELLATION);
	}
	
	function select(selector) {
	  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
	    args[_key7 - 1] = arguments[_key7];
	  }
	
	  if (arguments.length === 0) {
	    selector = _utils.ident;
	  } else {
	    (0, _utils.check)(selector, _utils.is.notUndef, 'select(selector,[...]): argument selector is undefined');
	    (0, _utils.check)(selector, _utils.is.func, 'select(selector,[...]): argument ' + selector + ' is not a function');
	  }
	  return effect(SELECT, { selector: selector, args: args });
	}
	
	/**
	  channel(pattern, [buffer])    => creates an event channel for store actions
	**/
	function actionChannel(pattern, buffer) {
	  (0, _utils.check)(pattern, _utils.is.notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
	  if (arguments.length > 1) {
	    (0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
	    (0, _utils.check)(buffer, _utils.is.buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
	  }
	  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
	}
	
	function cancelled() {
	  return effect(CANCELLED, {});
	}
	
	function flush(channel) {
	  (0, _utils.check)(channel, _utils.is.channel, 'flush(channel): argument ' + channel + ' is not valid channel');
	  return effect(FLUSH, channel);
	}
	
	function getContext(prop) {
	  (0, _utils.check)(prop, _utils.is.string, 'getContext(prop): argument ' + prop + ' is not a string');
	  return effect(GET_CONTEXT, prop);
	}
	
	function setContext(props) {
	  (0, _utils.check)(props, _utils.is.object, (0, _utils.createSetContextWarning)(null, props));
	  return effect(SET_CONTEXT, props);
	}
	
	function takeEvery(patternOrChannel, worker) {
	  for (var _len8 = arguments.length, args = Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
	    args[_key8 - 2] = arguments[_key8];
	  }
	
	  return fork.apply(undefined, [_sagaHelpers.takeEveryHelper, patternOrChannel, worker].concat(args));
	}
	
	function takeLatest(patternOrChannel, worker) {
	  for (var _len9 = arguments.length, args = Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
	    args[_key9 - 2] = arguments[_key9];
	  }
	
	  return fork.apply(undefined, [_sagaHelpers.takeLatestHelper, patternOrChannel, worker].concat(args));
	}
	
	function throttle(ms, pattern, worker) {
	  for (var _len10 = arguments.length, args = Array(_len10 > 3 ? _len10 - 3 : 0), _key10 = 3; _key10 < _len10; _key10++) {
	    args[_key10 - 3] = arguments[_key10];
	  }
	
	  return fork.apply(undefined, [_sagaHelpers.throttleHelper, ms, pattern, worker].concat(args));
	}
	
	var createAsEffectType = function createAsEffectType(type) {
	  return function (effect) {
	    return effect && effect[IO] && effect[type];
	  };
	};
	
	var asEffect = exports.asEffect = {
	  take: createAsEffectType(TAKE),
	  put: createAsEffectType(PUT),
	  all: createAsEffectType(ALL),
	  race: createAsEffectType(RACE),
	  call: createAsEffectType(CALL),
	  cps: createAsEffectType(CPS),
	  fork: createAsEffectType(FORK),
	  join: createAsEffectType(JOIN),
	  cancel: createAsEffectType(CANCEL),
	  select: createAsEffectType(SELECT),
	  actionChannel: createAsEffectType(ACTION_CHANNEL),
	  cancelled: createAsEffectType(CANCELLED),
	  flush: createAsEffectType(FLUSH),
	  getContext: createAsEffectType(GET_CONTEXT),
	  setContext: createAsEffectType(SET_CONTEXT)
	};

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.check = check;
	exports.hasOwn = hasOwn;
	exports.remove = remove;
	exports.deferred = deferred;
	exports.arrayOfDeffered = arrayOfDeffered;
	exports.delay = delay;
	exports.createMockTask = createMockTask;
	exports.autoInc = autoInc;
	exports.makeIterator = makeIterator;
	exports.log = log;
	exports.deprecate = deprecate;
	var sym = exports.sym = function sym(id) {
	  return '@@redux-saga/' + id;
	};
	
	var TASK = exports.TASK = sym('TASK');
	var HELPER = exports.HELPER = sym('HELPER');
	var MATCH = exports.MATCH = sym('MATCH');
	var CANCEL = exports.CANCEL = sym('CANCEL_PROMISE');
	var SAGA_ACTION = exports.SAGA_ACTION = sym('SAGA_ACTION');
	var SELF_CANCELLATION = exports.SELF_CANCELLATION = sym('SELF_CANCELLATION');
	var konst = exports.konst = function konst(v) {
	  return function () {
	    return v;
	  };
	};
	var kTrue = exports.kTrue = konst(true);
	var kFalse = exports.kFalse = konst(false);
	var noop = exports.noop = function noop() {};
	var ident = exports.ident = function ident(v) {
	  return v;
	};
	
	function check(value, predicate, error) {
	  if (!predicate(value)) {
	    log('error', 'uncaught at check', error);
	    throw new Error(error);
	  }
	}
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	function hasOwn(object, property) {
	  return is.notUndef(object) && hasOwnProperty.call(object, property);
	}
	
	var is = exports.is = {
	  undef: function undef(v) {
	    return v === null || v === undefined;
	  },
	  notUndef: function notUndef(v) {
	    return v !== null && v !== undefined;
	  },
	  func: function func(f) {
	    return typeof f === 'function';
	  },
	  number: function number(n) {
	    return typeof n === 'number';
	  },
	  string: function string(s) {
	    return typeof s === 'string';
	  },
	  array: Array.isArray,
	  object: function object(obj) {
	    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
	  },
	  promise: function promise(p) {
	    return p && is.func(p.then);
	  },
	  iterator: function iterator(it) {
	    return it && is.func(it.next) && is.func(it.throw);
	  },
	  iterable: function iterable(it) {
	    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
	  },
	  task: function task(t) {
	    return t && t[TASK];
	  },
	  observable: function observable(ob) {
	    return ob && is.func(ob.subscribe);
	  },
	  buffer: function buffer(buf) {
	    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
	  },
	  pattern: function pattern(pat) {
	    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
	  },
	  channel: function channel(ch) {
	    return ch && is.func(ch.take) && is.func(ch.close);
	  },
	  helper: function helper(it) {
	    return it && it[HELPER];
	  },
	  stringableFunc: function stringableFunc(f) {
	    return is.func(f) && hasOwn(f, 'toString');
	  }
	};
	
	var object = exports.object = {
	  assign: function assign(target, source) {
	    for (var i in source) {
	      if (hasOwn(source, i)) {
	        target[i] = source[i];
	      }
	    }
	  }
	};
	
	function remove(array, item) {
	  var index = array.indexOf(item);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	}
	
	var array = exports.array = {
	  from: function from(obj) {
	    var arr = Array(obj.length);
	    for (var i in obj) {
	      if (hasOwn(obj, i)) {
	        arr[i] = obj[i];
	      }
	    }
	    return arr;
	  }
	};
	
	function deferred() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var def = _extends({}, props);
	  var promise = new Promise(function (resolve, reject) {
	    def.resolve = resolve;
	    def.reject = reject;
	  });
	  def.promise = promise;
	  return def;
	}
	
	function arrayOfDeffered(length) {
	  var arr = [];
	  for (var i = 0; i < length; i++) {
	    arr.push(deferred());
	  }
	  return arr;
	}
	
	function delay(ms) {
	  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  var timeoutId = void 0;
	  var promise = new Promise(function (resolve) {
	    timeoutId = setTimeout(function () {
	      return resolve(val);
	    }, ms);
	  });
	
	  promise[CANCEL] = function () {
	    return clearTimeout(timeoutId);
	  };
	
	  return promise;
	}
	
	function createMockTask() {
	  var _ref;
	
	  var running = true;
	  var _result = void 0,
	      _error = void 0;
	
	  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
	    return running;
	  }, _ref.result = function result() {
	    return _result;
	  }, _ref.error = function error() {
	    return _error;
	  }, _ref.setRunning = function setRunning(b) {
	    return running = b;
	  }, _ref.setResult = function setResult(r) {
	    return _result = r;
	  }, _ref.setError = function setError(e) {
	    return _error = e;
	  }, _ref;
	}
	
	function autoInc() {
	  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = exports.uid = autoInc();
	
	var kThrow = function kThrow(err) {
	  throw err;
	};
	var kReturn = function kReturn(value) {
	  return { value: value, done: true };
	};
	function makeIterator(next) {
	  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
	  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var isHelper = arguments[3];
	
	  var iterator = { name: name, next: next, throw: thro, return: kReturn };
	
	  if (isHelper) {
	    iterator[HELPER] = true;
	  }
	  if (typeof Symbol !== 'undefined') {
	    iterator[Symbol.iterator] = function () {
	      return iterator;
	    };
	  }
	  return iterator;
	}
	
	/**
	  Print error in a useful way whether in a browser environment
	  (with expandable error stack traces), or in a node.js environment
	  (text-only log output)
	 **/
	function log(level, message) {
	  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	  /*eslint-disable no-console*/
	  if (typeof window === 'undefined') {
	    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
	  } else {
	    console[level](message, error);
	  }
	}
	
	function deprecate(fn, deprecationWarning) {
	  return function () {
	    if (false) log('warn', deprecationWarning);
	    return fn.apply(undefined, arguments);
	  };
	}
	
	var updateIncentive = exports.updateIncentive = function updateIncentive(deprecated, preferred) {
	  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
	};
	
	var internalErr = exports.internalErr = function internalErr(err) {
	  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
	};
	
	var createSetContextWarning = exports.createSetContextWarning = function createSetContextWarning(ctx, props) {
	  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
	};
	
	var wrapSagaDispatch = exports.wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
	  return function (action) {
	    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
	  };
	};
	
	var cloneableGenerator = exports.cloneableGenerator = function cloneableGenerator(generatorFunc) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var history = [];
	    var gen = generatorFunc.apply(undefined, args);
	    return {
	      next: function next(arg) {
	        history.push(arg);
	        return gen.next(arg);
	      },
	      clone: function clone() {
	        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
	        history.forEach(function (arg) {
	          return clonedGen.next(arg);
	        });
	        return clonedGen;
	      },
	      return: function _return(value) {
	        return gen.return(value);
	      },
	      throw: function _throw(exception) {
	        return gen.throw(exception);
	      }
	    };
	  };
	};

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.throttleHelper = exports.takeLatestHelper = exports.takeEveryHelper = exports.throttle = exports.takeLatest = exports.takeEvery = undefined;
	
	var _takeEvery = __webpack_require__(961);
	
	var _takeEvery2 = _interopRequireDefault(_takeEvery);
	
	var _takeLatest = __webpack_require__(966);
	
	var _takeLatest2 = _interopRequireDefault(_takeLatest);
	
	var _throttle = __webpack_require__(967);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _utils = __webpack_require__(959);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var deprecationWarning = function deprecationWarning(helperName) {
	  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
	};
	
	var takeEvery = /*#__PURE__*/(0, _utils.deprecate)(_takeEvery2.default, /*#__PURE__*/deprecationWarning('takeEvery'));
	var takeLatest = /*#__PURE__*/(0, _utils.deprecate)(_takeLatest2.default, /*#__PURE__*/deprecationWarning('takeLatest'));
	var throttle = /*#__PURE__*/(0, _utils.deprecate)(_throttle2.default, /*#__PURE__*/deprecationWarning('throttle'));
	
	exports.takeEvery = takeEvery;
	exports.takeLatest = takeLatest;
	exports.throttle = throttle;
	exports.takeEveryHelper = _takeEvery2.default;
	exports.takeLatestHelper = _takeLatest2.default;
	exports.throttleHelper = _throttle2.default;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = takeEvery;
	
	var _fsmIterator = __webpack_require__(962);
	
	var _fsmIterator2 = _interopRequireDefault(_fsmIterator);
	
	var _io = __webpack_require__(958);
	
	var _channel = __webpack_require__(963);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function takeEvery(patternOrChannel, worker) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var yTake = { done: false, value: (0, _io.take)(patternOrChannel) };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	
	  var action = void 0,
	      setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return (0, _fsmIterator2.default)({
	    q1: function q1() {
	      return ['q2', yTake, setAction];
	    },
	    q2: function q2() {
	      return action === _channel.END ? [_fsmIterator.qEnd] : ['q1', yFork(action)];
	    }
	  }, 'q1', 'takeEvery(' + (0, _fsmIterator.safeName)(patternOrChannel) + ', ' + worker.name + ')');
	}

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.qEnd = undefined;
	exports.safeName = safeName;
	exports.default = fsmIterator;
	
	var _utils = __webpack_require__(959);
	
	var done = { done: true, value: undefined };
	var qEnd = exports.qEnd = {};
	
	function safeName(patternOrChannel) {
	  if (_utils.is.channel(patternOrChannel)) {
	    return 'channel';
	  } else if (Array.isArray(patternOrChannel)) {
	    return String(patternOrChannel.map(function (entry) {
	      return String(entry);
	    }));
	  } else {
	    return String(patternOrChannel);
	  }
	}
	
	function fsmIterator(fsm, q0) {
	  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';
	
	  var updateState = void 0,
	      qNext = q0;
	
	  function next(arg, error) {
	    if (qNext === qEnd) {
	      return done;
	    }
	
	    if (error) {
	      qNext = qEnd;
	      throw error;
	    } else {
	      updateState && updateState(arg);
	
	      var _fsm$qNext = fsm[qNext](),
	          q = _fsm$qNext[0],
	          output = _fsm$qNext[1],
	          _updateState = _fsm$qNext[2];
	
	      qNext = q;
	      updateState = _updateState;
	      return qNext === qEnd ? done : output;
	    }
	  }
	
	  return (0, _utils.makeIterator)(next, function (error) {
	    return next(null, error);
	  }, name, true);
	}

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.UNDEFINED_INPUT_ERROR = exports.INVALID_BUFFER = exports.isEnd = exports.END = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.emitter = emitter;
	exports.channel = channel;
	exports.eventChannel = eventChannel;
	exports.stdChannel = stdChannel;
	
	var _utils = __webpack_require__(959);
	
	var _buffers = __webpack_require__(964);
	
	var _scheduler = __webpack_require__(965);
	
	var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
	var END = exports.END = { type: CHANNEL_END_TYPE };
	var isEnd = exports.isEnd = function isEnd(a) {
	  return a && a.type === CHANNEL_END_TYPE;
	};
	
	function emitter() {
	  var subscribers = [];
	
	  function subscribe(sub) {
	    subscribers.push(sub);
	    return function () {
	      return (0, _utils.remove)(subscribers, sub);
	    };
	  }
	
	  function emit(item) {
	    var arr = subscribers.slice();
	    for (var i = 0, len = arr.length; i < len; i++) {
	      arr[i](item);
	    }
	  }
	
	  return {
	    subscribe: subscribe,
	    emit: emit
	  };
	}
	
	var INVALID_BUFFER = exports.INVALID_BUFFER = 'invalid buffer passed to channel factory function';
	var UNDEFINED_INPUT_ERROR = exports.UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';
	
	if (false) {
	  exports.UNDEFINED_INPUT_ERROR = UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
	}
	
	function channel() {
	  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _buffers.buffers.fixed();
	
	  var closed = false;
	  var takers = [];
	
	  (0, _utils.check)(buffer, _utils.is.buffer, INVALID_BUFFER);
	
	  function checkForbiddenStates() {
	    if (closed && takers.length) {
	      throw (0, _utils.internalErr)('Cannot have a closed channel with pending takers');
	    }
	    if (takers.length && !buffer.isEmpty()) {
	      throw (0, _utils.internalErr)('Cannot have pending takers with non empty buffer');
	    }
	  }
	
	  function put(input) {
	    checkForbiddenStates();
	    (0, _utils.check)(input, _utils.is.notUndef, UNDEFINED_INPUT_ERROR);
	    if (closed) {
	      return;
	    }
	    if (!takers.length) {
	      return buffer.put(input);
	    }
	    for (var i = 0; i < takers.length; i++) {
	      var cb = takers[i];
	      if (!cb[_utils.MATCH] || cb[_utils.MATCH](input)) {
	        takers.splice(i, 1);
	        return cb(input);
	      }
	    }
	  }
	
	  function take(cb) {
	    checkForbiddenStates();
	    (0, _utils.check)(cb, _utils.is.func, "channel.take's callback must be a function");
	
	    if (closed && buffer.isEmpty()) {
	      cb(END);
	    } else if (!buffer.isEmpty()) {
	      cb(buffer.take());
	    } else {
	      takers.push(cb);
	      cb.cancel = function () {
	        return (0, _utils.remove)(takers, cb);
	      };
	    }
	  }
	
	  function flush(cb) {
	    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
	    (0, _utils.check)(cb, _utils.is.func, "channel.flush' callback must be a function");
	    if (closed && buffer.isEmpty()) {
	      cb(END);
	      return;
	    }
	    cb(buffer.flush());
	  }
	
	  function close() {
	    checkForbiddenStates();
	    if (!closed) {
	      closed = true;
	      if (takers.length) {
	        var arr = takers;
	        takers = [];
	        for (var i = 0, len = arr.length; i < len; i++) {
	          arr[i](END);
	        }
	      }
	    }
	  }
	
	  return {
	    take: take,
	    put: put,
	    flush: flush,
	    close: close,
	    get __takers__() {
	      return takers;
	    },
	    get __closed__() {
	      return closed;
	    }
	  };
	}
	
	function eventChannel(subscribe) {
	  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _buffers.buffers.none();
	  var matcher = arguments[2];
	
	  /**
	    should be if(typeof matcher !== undefined) instead?
	    see PR #273 for a background discussion
	  **/
	  if (arguments.length > 2) {
	    (0, _utils.check)(matcher, _utils.is.func, 'Invalid match function passed to eventChannel');
	  }
	
	  var chan = channel(buffer);
	  var close = function close() {
	    if (!chan.__closed__) {
	      if (unsubscribe) {
	        unsubscribe();
	      }
	      chan.close();
	    }
	  };
	  var unsubscribe = subscribe(function (input) {
	    if (isEnd(input)) {
	      close();
	      return;
	    }
	    if (matcher && !matcher(input)) {
	      return;
	    }
	    chan.put(input);
	  });
	  if (chan.__closed__) {
	    unsubscribe();
	  }
	
	  if (!_utils.is.func(unsubscribe)) {
	    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
	  }
	
	  return {
	    take: chan.take,
	    flush: chan.flush,
	    close: close
	  };
	}
	
	function stdChannel(subscribe) {
	  var chan = eventChannel(function (cb) {
	    return subscribe(function (input) {
	      if (input[_utils.SAGA_ACTION]) {
	        cb(input);
	        return;
	      }
	      (0, _scheduler.asap)(function () {
	        return cb(input);
	      });
	    });
	  });
	
	  return _extends({}, chan, {
	    take: function take(cb, matcher) {
	      if (arguments.length > 1) {
	        (0, _utils.check)(matcher, _utils.is.func, "channel.take's matcher argument must be a function");
	        cb[_utils.MATCH] = matcher;
	      }
	      chan.take(cb);
	    }
	  });
	}

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.buffers = exports.BUFFER_OVERFLOW = undefined;
	
	var _utils = __webpack_require__(959);
	
	var BUFFER_OVERFLOW = exports.BUFFER_OVERFLOW = "Channel's Buffer overflow!";
	
	var ON_OVERFLOW_THROW = 1;
	var ON_OVERFLOW_DROP = 2;
	var ON_OVERFLOW_SLIDE = 3;
	var ON_OVERFLOW_EXPAND = 4;
	
	var zeroBuffer = { isEmpty: _utils.kTrue, put: _utils.noop, take: _utils.noop };
	
	function ringBuffer() {
	  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
	  var overflowAction = arguments[1];
	
	  var arr = new Array(limit);
	  var length = 0;
	  var pushIndex = 0;
	  var popIndex = 0;
	
	  var push = function push(it) {
	    arr[pushIndex] = it;
	    pushIndex = (pushIndex + 1) % limit;
	    length++;
	  };
	
	  var take = function take() {
	    if (length != 0) {
	      var it = arr[popIndex];
	      arr[popIndex] = null;
	      length--;
	      popIndex = (popIndex + 1) % limit;
	      return it;
	    }
	  };
	
	  var flush = function flush() {
	    var items = [];
	    while (length) {
	      items.push(take());
	    }
	    return items;
	  };
	
	  return {
	    isEmpty: function isEmpty() {
	      return length == 0;
	    },
	    put: function put(it) {
	      if (length < limit) {
	        push(it);
	      } else {
	        var doubledLimit = void 0;
	        switch (overflowAction) {
	          case ON_OVERFLOW_THROW:
	            throw new Error(BUFFER_OVERFLOW);
	          case ON_OVERFLOW_SLIDE:
	            arr[pushIndex] = it;
	            pushIndex = (pushIndex + 1) % limit;
	            popIndex = pushIndex;
	            break;
	          case ON_OVERFLOW_EXPAND:
	            doubledLimit = 2 * limit;
	
	            arr = flush();
	
	            length = arr.length;
	            pushIndex = arr.length;
	            popIndex = 0;
	
	            arr.length = doubledLimit;
	            limit = doubledLimit;
	
	            push(it);
	            break;
	          default:
	          // DROP
	        }
	      }
	    },
	    take: take,
	    flush: flush
	  };
	}
	
	var buffers = exports.buffers = {
	  none: function none() {
	    return zeroBuffer;
	  },
	  fixed: function fixed(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_THROW);
	  },
	  dropping: function dropping(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_DROP);
	  },
	  sliding: function sliding(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
	  },
	  expanding: function expanding(initialSize) {
	    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
	  }
	};

/***/ }),
/* 965 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.asap = asap;
	exports.suspend = suspend;
	exports.flush = flush;
	var queue = [];
	/**
	  Variable to hold a counting semaphore
	  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
	    already suspended)
	  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
	    triggers flushing the queued tasks.
	**/
	var semaphore = 0;
	
	/**
	  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
	  and flushed after this task has finished (assuming the scheduler endup in a released
	  state).
	**/
	function exec(task) {
	  try {
	    suspend();
	    task();
	  } finally {
	    release();
	  }
	}
	
	/**
	  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
	**/
	function asap(task) {
	  queue.push(task);
	
	  if (!semaphore) {
	    suspend();
	    flush();
	  }
	}
	
	/**
	  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
	  scheduler is released.
	**/
	function suspend() {
	  semaphore++;
	}
	
	/**
	  Puts the scheduler in a `released` state.
	**/
	function release() {
	  semaphore--;
	}
	
	/**
	  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
	**/
	function flush() {
	  release();
	
	  var task = void 0;
	  while (!semaphore && (task = queue.shift()) !== undefined) {
	    exec(task);
	  }
	}

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = takeLatest;
	
	var _fsmIterator = __webpack_require__(962);
	
	var _fsmIterator2 = _interopRequireDefault(_fsmIterator);
	
	var _io = __webpack_require__(958);
	
	var _channel = __webpack_require__(963);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function takeLatest(patternOrChannel, worker) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var yTake = { done: false, value: (0, _io.take)(patternOrChannel) };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	  var yCancel = function yCancel(task) {
	    return { done: false, value: (0, _io.cancel)(task) };
	  };
	
	  var task = void 0,
	      action = void 0;
	  var setTask = function setTask(t) {
	    return task = t;
	  };
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return (0, _fsmIterator2.default)({
	    q1: function q1() {
	      return ['q2', yTake, setAction];
	    },
	    q2: function q2() {
	      return action === _channel.END ? [_fsmIterator.qEnd] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
	    },
	    q3: function q3() {
	      return ['q1', yFork(action), setTask];
	    }
	  }, 'q1', 'takeLatest(' + (0, _fsmIterator.safeName)(patternOrChannel) + ', ' + worker.name + ')');
	}

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = throttle;
	
	var _fsmIterator = __webpack_require__(962);
	
	var _fsmIterator2 = _interopRequireDefault(_fsmIterator);
	
	var _io = __webpack_require__(958);
	
	var _channel = __webpack_require__(963);
	
	var _buffers = __webpack_require__(964);
	
	var _utils = __webpack_require__(959);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function throttle(delayLength, pattern, worker) {
	  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    args[_key - 3] = arguments[_key];
	  }
	
	  var action = void 0,
	      channel = void 0;
	
	  var yActionChannel = { done: false, value: (0, _io.actionChannel)(pattern, _buffers.buffers.sliding(1)) };
	  var yTake = function yTake() {
	    return { done: false, value: (0, _io.take)(channel) };
	  };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	  var yDelay = { done: false, value: (0, _io.call)(_utils.delay, delayLength) };
	
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	  var setChannel = function setChannel(ch) {
	    return channel = ch;
	  };
	
	  return (0, _fsmIterator2.default)({
	    q1: function q1() {
	      return ['q2', yActionChannel, setChannel];
	    },
	    q2: function q2() {
	      return ['q3', yTake(), setAction];
	    },
	    q3: function q3() {
	      return action === _channel.END ? [_fsmIterator.qEnd] : ['q4', yFork(action)];
	    },
	    q4: function q4() {
	      return ['q2', yDelay];
	    }
	  }, 'q1', 'throttle(' + (0, _fsmIterator.safeName)(pattern) + ', ' + worker.name + ')');
	}

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.utils = exports.effects = exports.CANCEL = exports.delay = exports.throttle = exports.takeLatest = exports.takeEvery = exports.buffers = exports.channel = exports.eventChannel = exports.END = exports.runSaga = undefined;
	
	var _runSaga = __webpack_require__(969);
	
	Object.defineProperty(exports, 'runSaga', {
	  enumerable: true,
	  get: function get() {
	    return _runSaga.runSaga;
	  }
	});
	
	var _channel = __webpack_require__(963);
	
	Object.defineProperty(exports, 'END', {
	  enumerable: true,
	  get: function get() {
	    return _channel.END;
	  }
	});
	Object.defineProperty(exports, 'eventChannel', {
	  enumerable: true,
	  get: function get() {
	    return _channel.eventChannel;
	  }
	});
	Object.defineProperty(exports, 'channel', {
	  enumerable: true,
	  get: function get() {
	    return _channel.channel;
	  }
	});
	
	var _buffers = __webpack_require__(964);
	
	Object.defineProperty(exports, 'buffers', {
	  enumerable: true,
	  get: function get() {
	    return _buffers.buffers;
	  }
	});
	
	var _sagaHelpers = __webpack_require__(960);
	
	Object.defineProperty(exports, 'takeEvery', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.takeEvery;
	  }
	});
	Object.defineProperty(exports, 'takeLatest', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.takeLatest;
	  }
	});
	Object.defineProperty(exports, 'throttle', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.throttle;
	  }
	});
	
	var _utils = __webpack_require__(959);
	
	Object.defineProperty(exports, 'delay', {
	  enumerable: true,
	  get: function get() {
	    return _utils.delay;
	  }
	});
	Object.defineProperty(exports, 'CANCEL', {
	  enumerable: true,
	  get: function get() {
	    return _utils.CANCEL;
	  }
	});
	
	var _middleware = __webpack_require__(971);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	var _effects = __webpack_require__(957);
	
	var effects = _interopRequireWildcard(_effects);
	
	var _utils2 = __webpack_require__(972);
	
	var utils = _interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _middleware2.default;
	exports.effects = effects;
	exports.utils = utils;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runSaga = runSaga;
	
	var _utils = __webpack_require__(959);
	
	var _proc = __webpack_require__(970);
	
	var _proc2 = _interopRequireDefault(_proc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
	var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';
	
	function runSaga(storeInterface, saga) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var iterator = void 0;
	
	  if (_utils.is.iterator(storeInterface)) {
	    if (false) {
	      (0, _utils.log)('warn', 'runSaga(iterator, storeInterface) has been deprecated in favor of ' + RUN_SAGA_SIGNATURE);
	    }
	    iterator = storeInterface;
	    storeInterface = saga;
	  } else {
	    (0, _utils.check)(saga, _utils.is.func, NON_GENERATOR_ERR);
	    iterator = saga.apply(undefined, args);
	    (0, _utils.check)(iterator, _utils.is.iterator, NON_GENERATOR_ERR);
	  }
	
	  var _storeInterface = storeInterface,
	      subscribe = _storeInterface.subscribe,
	      dispatch = _storeInterface.dispatch,
	      getState = _storeInterface.getState,
	      context = _storeInterface.context,
	      sagaMonitor = _storeInterface.sagaMonitor,
	      logger = _storeInterface.logger,
	      onError = _storeInterface.onError;
	
	
	  var effectId = (0, _utils.uid)();
	
	  if (sagaMonitor) {
	    // monitors are expected to have a certain interface, let's fill-in any missing ones
	    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || _utils.noop;
	    sagaMonitor.effectResolved = sagaMonitor.effectResolved || _utils.noop;
	    sagaMonitor.effectRejected = sagaMonitor.effectRejected || _utils.noop;
	    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || _utils.noop;
	    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || _utils.noop;
	
	    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
	  }
	
	  var task = (0, _proc2.default)(iterator, subscribe, (0, _utils.wrapSagaDispatch)(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);
	
	  if (sagaMonitor) {
	    sagaMonitor.effectResolved(effectId, task);
	  }
	
	  return task;
	}

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TASK_CANCEL = exports.CHANNEL_END = exports.NOT_ITERATOR_ERROR = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = proc;
	
	var _utils = __webpack_require__(959);
	
	var _scheduler = __webpack_require__(965);
	
	var _io = __webpack_require__(958);
	
	var _channel = __webpack_require__(963);
	
	var _buffers = __webpack_require__(964);
	
	function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }
	
	var NOT_ITERATOR_ERROR = exports.NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';
	
	var CHANNEL_END = exports.CHANNEL_END = {
	  toString: function toString() {
	    return '@@redux-saga/CHANNEL_END';
	  }
	};
	var TASK_CANCEL = exports.TASK_CANCEL = {
	  toString: function toString() {
	    return '@@redux-saga/TASK_CANCEL';
	  }
	};
	
	var matchers = {
	  wildcard: function wildcard() {
	    return _utils.kTrue;
	  },
	  default: function _default(pattern) {
	    return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {
	      return input.type === pattern;
	    } : function (input) {
	      return input.type === String(pattern);
	    };
	  },
	  array: function array(patterns) {
	    return function (input) {
	      return patterns.some(function (p) {
	        return matcher(p)(input);
	      });
	    };
	  },
	  predicate: function predicate(_predicate) {
	    return function (input) {
	      return _predicate(input);
	    };
	  }
	};
	
	function matcher(pattern) {
	  // prettier-ignore
	  return (pattern === '*' ? matchers.wildcard : _utils.is.array(pattern) ? matchers.array : _utils.is.stringableFunc(pattern) ? matchers.default : _utils.is.func(pattern) ? matchers.predicate : matchers.default)(pattern);
	}
	
	/**
	  Used to track a parent task and its forks
	  In the new fork model, forked tasks are attached by default to their parent
	  We model this using the concept of Parent task && main Task
	  main task is the main flow of the current Generator, the parent tasks is the
	  aggregation of the main tasks + all its forked tasks.
	  Thus the whole model represents an execution tree with multiple branches (vs the
	  linear execution tree in sequential (non parallel) programming)
	
	  A parent tasks has the following semantics
	  - It completes if all its forks either complete or all cancelled
	  - If it's cancelled, all forks are cancelled as well
	  - It aborts if any uncaught error bubbles up from forks
	  - If it completes, the return value is the one returned by the main task
	**/
	function forkQueue(name, mainTask, cb) {
	  var tasks = [],
	      result = void 0,
	      completed = false;
	  addTask(mainTask);
	
	  function abort(err) {
	    cancelAll();
	    cb(err, true);
	  }
	
	  function addTask(task) {
	    tasks.push(task);
	    task.cont = function (res, isErr) {
	      if (completed) {
	        return;
	      }
	
	      (0, _utils.remove)(tasks, task);
	      task.cont = _utils.noop;
	      if (isErr) {
	        abort(res);
	      } else {
	        if (task === mainTask) {
	          result = res;
	        }
	        if (!tasks.length) {
	          completed = true;
	          cb(result);
	        }
	      }
	    };
	    // task.cont.cancel = task.cancel
	  }
	
	  function cancelAll() {
	    if (completed) {
	      return;
	    }
	    completed = true;
	    tasks.forEach(function (t) {
	      t.cont = _utils.noop;
	      t.cancel();
	    });
	    tasks = [];
	  }
	
	  return {
	    addTask: addTask,
	    cancelAll: cancelAll,
	    abort: abort,
	    getTasks: function getTasks() {
	      return tasks;
	    },
	    taskNames: function taskNames() {
	      return tasks.map(function (t) {
	        return t.name;
	      });
	    }
	  };
	}
	
	function createTaskIterator(_ref) {
	  var context = _ref.context,
	      fn = _ref.fn,
	      args = _ref.args;
	
	  if (_utils.is.iterator(fn)) {
	    return fn;
	  }
	
	  // catch synchronous failures; see #152 and #441
	  var result = void 0,
	      error = void 0;
	  try {
	    result = fn.apply(context, args);
	  } catch (err) {
	    error = err;
	  }
	
	  // i.e. a generator function returns an iterator
	  if (_utils.is.iterator(result)) {
	    return result;
	  }
	
	  // do not bubble up synchronous failures for detached forks
	  // instead create a failed task. See #152 and #441
	  return error ? (0, _utils.makeIterator)(function () {
	    throw error;
	  }) : (0, _utils.makeIterator)(function () {
	    var pc = void 0;
	    var eff = { done: false, value: result };
	    var ret = function ret(value) {
	      return { done: true, value: value };
	    };
	    return function (arg) {
	      if (!pc) {
	        pc = true;
	        return eff;
	      } else {
	        return ret(arg);
	      }
	    };
	  }());
	}
	
	var wrapHelper = function wrapHelper(helper) {
	  return { fn: helper };
	};
	
	function proc(iterator) {
	  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
	    return _utils.noop;
	  };
	  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _utils.noop;
	  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _utils.noop;
	  var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	  var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
	  var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
	  var cont = arguments[8];
	
	  (0, _utils.check)(iterator, _utils.is.iterator, NOT_ITERATOR_ERROR);
	
	  var effectsString = '[...effects]';
	  var runParallelEffect = (0, _utils.deprecate)(runAllEffect, (0, _utils.updateIncentive)(effectsString, 'all(' + effectsString + ')'));
	
	  var sagaMonitor = options.sagaMonitor,
	      logger = options.logger,
	      onError = options.onError;
	
	  var log = logger || _utils.log;
	  var stdChannel = (0, _channel.stdChannel)(subscribe);
	  var taskContext = Object.create(parentContext);
	  /**
	    Tracks the current effect cancellation
	    Each time the generator progresses. calling runEffect will set a new value
	    on it. It allows propagating cancellation to child effects
	  **/
	  next.cancel = _utils.noop;
	
	  /**
	    Creates a new task descriptor for this generator, We'll also create a main task
	    to track the main flow (besides other forked tasks)
	  **/
	  var task = newTask(parentEffectId, name, iterator, cont);
	  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
	  var taskQueue = forkQueue(name, mainTask, end);
	
	  /**
	    cancellation of the main task. We'll simply resume the Generator with a Cancel
	  **/
	  function cancelMain() {
	    if (mainTask.isRunning && !mainTask.isCancelled) {
	      mainTask.isCancelled = true;
	      next(TASK_CANCEL);
	    }
	  }
	
	  /**
	    This may be called by a parent generator to trigger/propagate cancellation
	    cancel all pending tasks (including the main task), then end the current task.
	     Cancellation propagates down to the whole execution tree holded by this Parent task
	    It's also propagated to all joiners of this task and their execution tree/joiners
	     Cancellation is noop for terminated/Cancelled tasks tasks
	  **/
	  function cancel() {
	    /**
	      We need to check both Running and Cancelled status
	      Tasks can be Cancelled but still Running
	    **/
	    if (iterator._isRunning && !iterator._isCancelled) {
	      iterator._isCancelled = true;
	      taskQueue.cancelAll();
	      /**
	        Ending with a Never result will propagate the Cancellation to all joiners
	      **/
	      end(TASK_CANCEL);
	    }
	  }
	  /**
	    attaches cancellation logic to this task's continuation
	    this will permit cancellation to propagate down the call chain
	  **/
	  cont && (cont.cancel = cancel);
	
	  // tracks the running status
	  iterator._isRunning = true;
	
	  // kicks up the generator
	  next();
	
	  // then return the task descriptor to the caller
	  return task;
	
	  /**
	    This is the generator driver
	    It's a recursive async/continuation function which calls itself
	    until the generator terminates or throws
	  **/
	  function next(arg, isErr) {
	    // Preventive measure. If we end up here, then there is really something wrong
	    if (!mainTask.isRunning) {
	      throw new Error('Trying to resume an already finished generator');
	    }
	
	    try {
	      var result = void 0;
	      if (isErr) {
	        result = iterator.throw(arg);
	      } else if (arg === TASK_CANCEL) {
	        /**
	          getting TASK_CANCEL automatically cancels the main task
	          We can get this value here
	           - By cancelling the parent task manually
	          - By joining a Cancelled task
	        **/
	        mainTask.isCancelled = true;
	        /**
	          Cancels the current effect; this will propagate the cancellation down to any called tasks
	        **/
	        next.cancel();
	        /**
	          If this Generator has a `return` method then invokes it
	          This will jump to the finally block
	        **/
	        result = _utils.is.func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
	      } else if (arg === CHANNEL_END) {
	        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
	        result = _utils.is.func(iterator.return) ? iterator.return() : { done: true };
	      } else {
	        result = iterator.next(arg);
	      }
	
	      if (!result.done) {
	        runEffect(result.value, parentEffectId, '', next);
	      } else {
	        /**
	          This Generator has ended, terminate the main task and notify the fork queue
	        **/
	        mainTask.isMainRunning = false;
	        mainTask.cont && mainTask.cont(result.value);
	      }
	    } catch (error) {
	      if (mainTask.isCancelled) {
	        log('error', 'uncaught at ' + name, error.message);
	      }
	      mainTask.isMainRunning = false;
	      mainTask.cont(error, true);
	    }
	  }
	
	  function end(result, isErr) {
	    iterator._isRunning = false;
	    stdChannel.close();
	    if (!isErr) {
	      if (false) {
	        log('info', name + ' has been cancelled', '');
	      }
	      iterator._result = result;
	      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
	    } else {
	      if (result instanceof Error) {
	        result.sagaStack = 'at ' + name + ' \n ' + (result.sagaStack || result.stack);
	      }
	      if (!task.cont) {
	        log('error', 'uncaught', result.sagaStack || result.stack);
	        if (result instanceof Error && onError) {
	          onError(result);
	        }
	      }
	      iterator._error = result;
	      iterator._isAborted = true;
	      iterator._deferredEnd && iterator._deferredEnd.reject(result);
	    }
	    task.cont && task.cont(result, isErr);
	    task.joiners.forEach(function (j) {
	      return j.cb(result, isErr);
	    });
	    task.joiners = null;
	  }
	
	  function runEffect(effect, parentEffectId) {
	    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var cb = arguments[3];
	
	    var effectId = (0, _utils.uid)();
	    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });
	
	    /**
	      completion callback and cancel callback are mutually exclusive
	      We can't cancel an already completed effect
	      And We can't complete an already cancelled effectId
	    **/
	    var effectSettled = void 0;
	
	    // Completion callback passed to the appropriate effect runner
	    function currCb(res, isErr) {
	      if (effectSettled) {
	        return;
	      }
	
	      effectSettled = true;
	      cb.cancel = _utils.noop; // defensive measure
	      if (sagaMonitor) {
	        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
	      }
	      cb(res, isErr);
	    }
	    // tracks down the current cancel
	    currCb.cancel = _utils.noop;
	
	    // setup cancellation logic on the parent cb
	    cb.cancel = function () {
	      // prevents cancelling an already completed effect
	      if (effectSettled) {
	        return;
	      }
	
	      effectSettled = true;
	      /**
	        propagates cancel downward
	        catch uncaught cancellations errors; since we can no longer call the completion
	        callback, log errors raised during cancellations into the console
	      **/
	      try {
	        currCb.cancel();
	      } catch (err) {
	        log('error', 'uncaught at ' + name, err.message);
	      }
	      currCb.cancel = _utils.noop; // defensive measure
	
	      sagaMonitor && sagaMonitor.effectCancelled(effectId);
	    };
	
	    /**
	      each effect runner must attach its own logic of cancellation to the provided callback
	      it allows this generator to propagate cancellation downward.
	       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
	      And the setup must occur before calling the callback
	       This is a sort of inversion of control: called async functions are responsible
	      for completing the flow by calling the provided continuation; while caller functions
	      are responsible for aborting the current flow by calling the attached cancel function
	       Library users can attach their own cancellation logic to promises by defining a
	      promise[CANCEL] method in their returned promises
	      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
	    **/
	    var data = void 0;
	    // prettier-ignore
	    return (
	      // Non declarative effect
	      _utils.is.promise(effect) ? resolvePromise(effect, currCb) : _utils.is.helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : _utils.is.iterator(effect) ? resolveIterator(effect, effectId, name, currCb)
	
	      // declarative effects
	      : _utils.is.array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = _io.asEffect.take(effect)) ? runTakeEffect(data, currCb) : (data = _io.asEffect.put(effect)) ? runPutEffect(data, currCb) : (data = _io.asEffect.all(effect)) ? runAllEffect(data, effectId, currCb) : (data = _io.asEffect.race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = _io.asEffect.call(effect)) ? runCallEffect(data, effectId, currCb) : (data = _io.asEffect.cps(effect)) ? runCPSEffect(data, currCb) : (data = _io.asEffect.fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = _io.asEffect.join(effect)) ? runJoinEffect(data, currCb) : (data = _io.asEffect.cancel(effect)) ? runCancelEffect(data, currCb) : (data = _io.asEffect.select(effect)) ? runSelectEffect(data, currCb) : (data = _io.asEffect.actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = _io.asEffect.flush(effect)) ? runFlushEffect(data, currCb) : (data = _io.asEffect.cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = _io.asEffect.getContext(effect)) ? runGetContextEffect(data, currCb) : (data = _io.asEffect.setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is */currCb(effect)
	    );
	  }
	
	  function resolvePromise(promise, cb) {
	    var cancelPromise = promise[_utils.CANCEL];
	    if (_utils.is.func(cancelPromise)) {
	      cb.cancel = cancelPromise;
	    } else if (_utils.is.func(promise.abort)) {
	      cb.cancel = function () {
	        return promise.abort();
	      };
	      // TODO: add support for the fetch API, whenever they get around to
	      // adding cancel support
	    }
	    promise.then(cb, function (error) {
	      return cb(error, true);
	    });
	  }
	
	  function resolveIterator(iterator, effectId, name, cb) {
	    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
	  }
	
	  function runTakeEffect(_ref2, cb) {
	    var channel = _ref2.channel,
	        pattern = _ref2.pattern,
	        maybe = _ref2.maybe;
	
	    channel = channel || stdChannel;
	    var takeCb = function takeCb(inp) {
	      return inp instanceof Error ? cb(inp, true) : (0, _channel.isEnd)(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
	    };
	    try {
	      channel.take(takeCb, matcher(pattern));
	    } catch (err) {
	      return cb(err, true);
	    }
	    cb.cancel = takeCb.cancel;
	  }
	
	  function runPutEffect(_ref3, cb) {
	    var channel = _ref3.channel,
	        action = _ref3.action,
	        resolve = _ref3.resolve;
	
	    /**
	      Schedule the put in case another saga is holding a lock.
	      The put will be executed atomically. ie nested puts will execute after
	      this put has terminated.
	    **/
	    (0, _scheduler.asap)(function () {
	      var result = void 0;
	      try {
	        result = (channel ? channel.put : dispatch)(action);
	      } catch (error) {
	        // If we have a channel or `put.resolve` was used then bubble up the error.
	        if (channel || resolve) return cb(error, true);
	        log('error', 'uncaught at ' + name, error.stack || error.message || error);
	      }
	
	      if (resolve && _utils.is.promise(result)) {
	        resolvePromise(result, cb);
	      } else {
	        return cb(result);
	      }
	    });
	    // Put effects are non cancellables
	  }
	
	  function runCallEffect(_ref4, effectId, cb) {
	    var context = _ref4.context,
	        fn = _ref4.fn,
	        args = _ref4.args;
	
	    var result = void 0;
	    // catch synchronous failures; see #152
	    try {
	      result = fn.apply(context, args);
	    } catch (error) {
	      return cb(error, true);
	    }
	    return _utils.is.promise(result) ? resolvePromise(result, cb) : _utils.is.iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
	  }
	
	  function runCPSEffect(_ref5, cb) {
	    var context = _ref5.context,
	        fn = _ref5.fn,
	        args = _ref5.args;
	
	    // CPS (ie node style functions) can define their own cancellation logic
	    // by setting cancel field on the cb
	
	    // catch synchronous failures; see #152
	    try {
	      var cpsCb = function cpsCb(err, res) {
	        return _utils.is.undef(err) ? cb(res) : cb(err, true);
	      };
	      fn.apply(context, args.concat(cpsCb));
	      if (cpsCb.cancel) {
	        cb.cancel = function () {
	          return cpsCb.cancel();
	        };
	      }
	    } catch (error) {
	      return cb(error, true);
	    }
	  }
	
	  function runForkEffect(_ref6, effectId, cb) {
	    var context = _ref6.context,
	        fn = _ref6.fn,
	        args = _ref6.args,
	        detached = _ref6.detached;
	
	    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });
	
	    try {
	      (0, _scheduler.suspend)();
	      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : _utils.noop);
	
	      if (detached) {
	        cb(_task);
	      } else {
	        if (taskIterator._isRunning) {
	          taskQueue.addTask(_task);
	          cb(_task);
	        } else if (taskIterator._error) {
	          taskQueue.abort(taskIterator._error);
	        } else {
	          cb(_task);
	        }
	      }
	    } finally {
	      (0, _scheduler.flush)();
	    }
	    // Fork effects are non cancellables
	  }
	
	  function runJoinEffect(t, cb) {
	    if (t.isRunning()) {
	      var joiner = { task: task, cb: cb };
	      cb.cancel = function () {
	        return (0, _utils.remove)(t.joiners, joiner);
	      };
	      t.joiners.push(joiner);
	    } else {
	      t.isAborted() ? cb(t.error(), true) : cb(t.result());
	    }
	  }
	
	  function runCancelEffect(taskToCancel, cb) {
	    if (taskToCancel === _utils.SELF_CANCELLATION) {
	      taskToCancel = task;
	    }
	    if (taskToCancel.isRunning()) {
	      taskToCancel.cancel();
	    }
	    cb();
	    // cancel effects are non cancellables
	  }
	
	  function runAllEffect(effects, effectId, cb) {
	    var keys = Object.keys(effects);
	
	    if (!keys.length) {
	      return cb(_utils.is.array(effects) ? [] : {});
	    }
	
	    var completedCount = 0;
	    var completed = void 0;
	    var results = {};
	    var childCbs = {};
	
	    function checkEffectEnd() {
	      if (completedCount === keys.length) {
	        completed = true;
	        cb(_utils.is.array(effects) ? _utils.array.from(_extends({}, results, { length: keys.length })) : results);
	      }
	    }
	
	    keys.forEach(function (key) {
	      var chCbAtKey = function chCbAtKey(res, isErr) {
	        if (completed) {
	          return;
	        }
	        if (isErr || (0, _channel.isEnd)(res) || res === CHANNEL_END || res === TASK_CANCEL) {
	          cb.cancel();
	          cb(res, isErr);
	        } else {
	          results[key] = res;
	          completedCount++;
	          checkEffectEnd();
	        }
	      };
	      chCbAtKey.cancel = _utils.noop;
	      childCbs[key] = chCbAtKey;
	    });
	
	    cb.cancel = function () {
	      if (!completed) {
	        completed = true;
	        keys.forEach(function (key) {
	          return childCbs[key].cancel();
	        });
	      }
	    };
	
	    keys.forEach(function (key) {
	      return runEffect(effects[key], effectId, key, childCbs[key]);
	    });
	  }
	
	  function runRaceEffect(effects, effectId, cb) {
	    var completed = void 0;
	    var keys = Object.keys(effects);
	    var childCbs = {};
	
	    keys.forEach(function (key) {
	      var chCbAtKey = function chCbAtKey(res, isErr) {
	        if (completed) {
	          return;
	        }
	
	        if (isErr) {
	          // Race Auto cancellation
	          cb.cancel();
	          cb(res, true);
	        } else if (!(0, _channel.isEnd)(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
	          var _cb;
	
	          cb.cancel();
	          completed = true;
	          cb((_cb = {}, _cb[key] = res, _cb));
	        }
	      };
	      chCbAtKey.cancel = _utils.noop;
	      childCbs[key] = chCbAtKey;
	    });
	
	    cb.cancel = function () {
	      // prevents unnecessary cancellation
	      if (!completed) {
	        completed = true;
	        keys.forEach(function (key) {
	          return childCbs[key].cancel();
	        });
	      }
	    };
	    keys.forEach(function (key) {
	      if (completed) {
	        return;
	      }
	      runEffect(effects[key], effectId, key, childCbs[key]);
	    });
	  }
	
	  function runSelectEffect(_ref7, cb) {
	    var selector = _ref7.selector,
	        args = _ref7.args;
	
	    try {
	      var state = selector.apply(undefined, [getState()].concat(args));
	      cb(state);
	    } catch (error) {
	      cb(error, true);
	    }
	  }
	
	  function runChannelEffect(_ref8, cb) {
	    var pattern = _ref8.pattern,
	        buffer = _ref8.buffer;
	
	    var match = matcher(pattern);
	    match.pattern = pattern;
	    cb((0, _channel.eventChannel)(subscribe, buffer || _buffers.buffers.fixed(), match));
	  }
	
	  function runCancelledEffect(data, cb) {
	    cb(!!mainTask.isCancelled);
	  }
	
	  function runFlushEffect(channel, cb) {
	    channel.flush(cb);
	  }
	
	  function runGetContextEffect(prop, cb) {
	    cb(taskContext[prop]);
	  }
	
	  function runSetContextEffect(props, cb) {
	    _utils.object.assign(taskContext, props);
	    cb();
	  }
	
	  function newTask(id, name, iterator, cont) {
	    var _done, _ref9, _mutatorMap;
	
	    iterator._deferredEnd = null;
	    return _ref9 = {}, _ref9[_utils.TASK] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
	      if (iterator._deferredEnd) {
	        return iterator._deferredEnd.promise;
	      } else {
	        var def = (0, _utils.deferred)();
	        iterator._deferredEnd = def;
	        if (!iterator._isRunning) {
	          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
	        }
	        return def.promise;
	      }
	    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
	      return iterator._isRunning;
	    }, _ref9.isCancelled = function isCancelled() {
	      return iterator._isCancelled;
	    }, _ref9.isAborted = function isAborted() {
	      return iterator._isAborted;
	    }, _ref9.result = function result() {
	      return iterator._result;
	    }, _ref9.error = function error() {
	      return iterator._error;
	    }, _ref9.setContext = function setContext(props) {
	      (0, _utils.check)(props, _utils.is.object, (0, _utils.createSetContextWarning)('task', props));
	      _utils.object.assign(taskContext, props);
	    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
	  }
	}

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = sagaMiddlewareFactory;
	
	var _utils = __webpack_require__(959);
	
	var _channel = __webpack_require__(963);
	
	var _runSaga = __webpack_require__(969);
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function sagaMiddlewareFactory() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var _ref$context = _ref.context,
	      context = _ref$context === undefined ? {} : _ref$context,
	      options = _objectWithoutProperties(_ref, ['context']);
	
	  var sagaMonitor = options.sagaMonitor,
	      logger = options.logger,
	      onError = options.onError;
	
	
	  if (_utils.is.func(options)) {
	    if (true) {
	      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
	    } else {
	      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
	    }
	  }
	
	  if (logger && !_utils.is.func(logger)) {
	    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
	  }
	
	  if (false) {
	    throw new Error('`options.onerror` was removed. Use `options.onError` instead.');
	  }
	
	  if (onError && !_utils.is.func(onError)) {
	    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
	  }
	
	  if (options.emitter && !_utils.is.func(options.emitter)) {
	    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
	  }
	
	  function sagaMiddleware(_ref2) {
	    var getState = _ref2.getState,
	        dispatch = _ref2.dispatch;
	
	    var sagaEmitter = (0, _channel.emitter)();
	    sagaEmitter.emit = (options.emitter || _utils.ident)(sagaEmitter.emit);
	
	    sagaMiddleware.run = _runSaga.runSaga.bind(null, {
	      context: context,
	      subscribe: sagaEmitter.subscribe,
	      dispatch: dispatch,
	      getState: getState,
	      sagaMonitor: sagaMonitor,
	      logger: logger,
	      onError: onError
	    });
	
	    return function (next) {
	      return function (action) {
	        if (sagaMonitor && sagaMonitor.actionDispatched) {
	          sagaMonitor.actionDispatched(action);
	        }
	        var result = next(action); // hit reducers
	        sagaEmitter.emit(action);
	        return result;
	      };
	    };
	  }
	
	  sagaMiddleware.run = function () {
	    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
	  };
	
	  sagaMiddleware.setContext = function (props) {
	    (0, _utils.check)(props, _utils.is.object, (0, _utils.createSetContextWarning)('sagaMiddleware', props));
	    _utils.object.assign(context, props);
	  };
	
	  return sagaMiddleware;
	}

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(959);
	
	Object.defineProperty(exports, 'TASK', {
	  enumerable: true,
	  get: function get() {
	    return _utils.TASK;
	  }
	});
	Object.defineProperty(exports, 'SAGA_ACTION', {
	  enumerable: true,
	  get: function get() {
	    return _utils.SAGA_ACTION;
	  }
	});
	Object.defineProperty(exports, 'noop', {
	  enumerable: true,
	  get: function get() {
	    return _utils.noop;
	  }
	});
	Object.defineProperty(exports, 'is', {
	  enumerable: true,
	  get: function get() {
	    return _utils.is;
	  }
	});
	Object.defineProperty(exports, 'deferred', {
	  enumerable: true,
	  get: function get() {
	    return _utils.deferred;
	  }
	});
	Object.defineProperty(exports, 'arrayOfDeffered', {
	  enumerable: true,
	  get: function get() {
	    return _utils.arrayOfDeffered;
	  }
	});
	Object.defineProperty(exports, 'createMockTask', {
	  enumerable: true,
	  get: function get() {
	    return _utils.createMockTask;
	  }
	});
	Object.defineProperty(exports, 'cloneableGenerator', {
	  enumerable: true,
	  get: function get() {
	    return _utils.cloneableGenerator;
	  }
	});
	
	var _io = __webpack_require__(958);
	
	Object.defineProperty(exports, 'asEffect', {
	  enumerable: true,
	  get: function get() {
	    return _io.asEffect;
	  }
	});
	
	var _proc = __webpack_require__(970);
	
	Object.defineProperty(exports, 'CHANNEL_END', {
	  enumerable: true,
	  get: function get() {
	    return _proc.CHANNEL_END;
	  }
	});

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(974);
	
	Object.keys(_app).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _app[key];
	    }
	  });
	});
	
	var _user = __webpack_require__(975);
	
	Object.keys(_user).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _user[key];
	    }
	  });
	});
	
	var _products = __webpack_require__(976);
	
	Object.keys(_products).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _products[key];
	    }
	  });
	});

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _reduxActions = __webpack_require__(299);
	
	var defaultState = {
	  loading: false,
	  searchingProducts: false
	};
	
	exports.app = (0, _reduxActions.handleActions)({
	  TOGGLE_LOADING: function TOGGLE_LOADING(state, action) {
	    return {
	      loading: action.payload ? action.payload : !state.loading
	    };
	  }
	}, defaultState);

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.user = undefined;
	
	var _reduxActions = __webpack_require__(299);
	
	var _localStorage = __webpack_require__(954);
	
	var user = exports.user = (0, _reduxActions.handleActions)({
	  USER_LOGGED_OUT: function USER_LOGGED_OUT(state, action) {
	    (0, _localStorage.deleteItem)('wideeyes-token');
	    return {};
	  },
	
	  USER_LOGGED_IN_REQUESTED: function USER_LOGGED_IN_REQUESTED(state, action) {
	    return state;
	  },
	
	  USER_LOGGED_IN_COMPLETED: function USER_LOGGED_IN_COMPLETED(state, action) {
	    //TODO change hardcoded. Set in session if user can open href links of products
	    if (action.payload.config) {
	      (0, _localStorage.setItem)('wideeyes-canOpenProductLink', action.payload.config.canOpenProductLink);
	    }
	    (0, _localStorage.setItem)('annotatorId', action.payload._id);
	    (0, _localStorage.setItem)('wideeyes-token', action.payload.token);
	    return action.payload; // action.payload = user
	  },
	
	  USER_LOGGED_IN_FAILED: function USER_LOGGED_IN_FAILED(state, action) {
	    (0, _localStorage.deleteItem)('wideeyes-token');
	    return {};
	  },
	
	  GET_USER_REQUESTED: function GET_USER_REQUESTED(state, action) {
	    return state;
	  },
	
	  GET_USER_COMPLETED: function GET_USER_COMPLETED(state, action) {
	    (0, _localStorage.setItem)('wideeyes-token', action.payload.token);
	    return action.payload; // action.payload = user
	  },
	
	  GET_USER_FAILED: function GET_USER_FAILED() {
	    (0, _localStorage.deleteItem)('wideeyes-token');
	    return {};
	  }
	}, {});

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _array = __webpack_require__(589);
	
	var _reduxActions = __webpack_require__(299);
	
	var _constants = __webpack_require__(584);
	
	var _utils = __webpack_require__(812);
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// import mockStyleAdvisorResults from '../components/PopupStyleAdvisor/mockResults'
	
	var defaultState = {
	  all: [],
	  detection: {
	    perfectMatch: ''
	  },
	  attributes: {},
	  detections: [],
	  jobs: [],
	  categories: {},
	  imageToShow: '',
	  selected: {},
	  annotationId: '',
	  searchedProduct: {},
	  similars: [],
	  look: [],
	  lookProducts: [],
	  lookNoProducts: [],
	  styleAdvisorResults: [],
	  modalStyleAdvisorWasOpened: false,
	  twinnedLooksResults: [],
	  textSearchResults: []
	};
	
	exports.products = (0, _reduxActions.handleActions)({
	  RECOGNIZE_PRODUCTS_COMPLETED: function RECOGNIZE_PRODUCTS_COMPLETED(state, action) {
	    var detections = action.payload.detections || [];
	
	    detections.forEach(function (det) {
	      det.bbox = {
	        y1: det.bbox.y1,
	        x1: det.bbox.x1,
	        x2: det.bbox.x2,
	        y2: det.bbox.y2
	      };
	      det[_constants.INTERNAL_REF] = (0, _utils.generateUniqueId)();
	    });
	
	    var hasDetections = detections.length > 0;
	    return hasDetections ? _extends({}, state, {
	      detection: detections[0],
	      attributes: { results: [] },
	      detections: (0, _array.uniqBy)(detections, function (d) {
	        return d.label;
	      })
	    }) : _extends({}, state, {
	      attributes: { results: [] },
	      detections: [],
	      detection: {}
	    });
	  },
	
	  SEARCH_PRODUCTS_RECEIVED: function SEARCH_PRODUCTS_RECEIVED(state, action) {
	    var result = '';
	    if (action.payload.errors && action.payload.errors.length > 0) {
	      result = _extends({}, state, {
	        moreProductsErrors: action.payload.errors
	      });
	    }
	    if (action.payload.results && action.payload.results.length > 0) {
	      var products = action.payload.results;
	      if (state.moreProducts) {
	        products = products.concat(state.moreProducts);
	      }
	      result = _extends({}, state, {
	        moreProducts: products
	      });
	    }
	    return result;
	  },
	
	  SEARCH_PRODUCTS_EMPTY: function SEARCH_PRODUCTS_EMPTY(state, action) {
	    return _extends({}, state, {
	      moreProductsErrors: [],
	      moreProducts: []
	    });
	  },
	
	  SEARCH_PRODUCT_RECEIVED: function SEARCH_PRODUCT_RECEIVED(state, action) {
	    var result = '';
	    if (action.payload.results.length > 0) {
	      result = _extends({}, state, {
	        searchedProduct: action.payload.results[0]
	      });
	    } else {
	      if (action.payload.errors[0]) {
	        result = _extends({}, state, {
	          searchedProduct: { errorMessage: action.payload.errors[0].message }
	        });
	      }
	    }
	    return result;
	  },
	
	  SET_DETECTION: function SET_DETECTION(state, action) {
	    var detections = state.detections;
	    var internalRef = action.payload.internal_ref;
	
	
	    if (detections) {
	      var detectionIndex = detections.findIndex(function (det) {
	        return det.internal_ref === internalRef;
	      });
	      var detection = detections[detectionIndex] || {};
	
	      return _extends({}, state, {
	        detection: detection,
	        attributes: detection.attributes
	      });
	    } else {
	      return _extends({}, state, {
	        detection: {},
	        attributes: {}
	      });
	    }
	  },
	
	  GET_CATEGORIES_COMPLETED: function GET_CATEGORIES_COMPLETED(state, action) {
	    return _extends({}, state, {
	      categories: action.payload
	    });
	  },
	
	  GET_JOBS_COMPLETED: function GET_JOBS_COMPLETED(state, action) {
	    var jobs = action.payload.jobs.filter(function (j) {
	      return j.type === 'bboxWeRecommendV2';
	    });
	    return _extends({}, state, {
	      jobs: jobs
	    });
	  },
	
	  GET_IMAGE_TO_VALIDATE_COMPLETED: function GET_IMAGE_TO_VALIDATE_COMPLETED(state, action) {
	    return _extends({}, state, {
	      imageToShow: action.payload
	    });
	  },
	
	  SELECT_ALTERNATIVE_IMAGE_COMPLETED: function SELECT_ALTERNATIVE_IMAGE_COMPLETED(state, action) {
	    return _extends({}, state, {
	      all: [],
	      attributes: { results: [] },
	      imageToShow: action.payload,
	      detections: []
	    });
	  },
	
	  GET_ANNOTATIONS_COMPLETED: function GET_ANNOTATIONS_COMPLETED(state, action) {
	    var annotations = action.payload.annotations;
	    var _annotations$ = annotations[0],
	        id = _annotations$.id,
	        data = _annotations$.data;
	
	    var parsedData = JSON.parse(data);
	
	    parsedData.results.forEach(function (det) {
	      det[_constants.INTERNAL_REF] = (0, _utils.generateUniqueId)();
	    });
	
	    return _extends({}, state, {
	      annotationId: id,
	      detection: _extends({}, parsedData.results[0]),
	      attributes: { results: [] },
	      detections: [].concat(_toConsumableArray((0, _array.uniqBy)(parsedData.results, function (d) {
	        return d.label;
	      })))
	    });
	  },
	
	  DROP_RESULTS: function DROP_RESULTS(state, action) {
	    return _extends({}, state, {
	      detection: {},
	      all: '',
	      attributes: { results: [] },
	      detections: []
	    });
	  },
	
	  ADD_NEW_DETECTION: function ADD_NEW_DETECTION(state, action) {
	    var _action$payload = action.payload,
	        internal_ref = _action$payload.internal_ref,
	        label = _action$payload.label,
	        perfectMatch = _action$payload.perfectMatch;
	
	    var newDetection = {
	      internal_ref: internal_ref,
	      bbox: state.detection.bbox,
	      label: label,
	      perfectMatch: perfectMatch,
	      point: { x: 0, y: 0 }
	    };
	
	    return _extends({}, state, {
	      detections: [].concat(_toConsumableArray(state.detections), [newDetection]),
	      detection: newDetection,
	      attributes: { results: [] }
	    });
	  },
	
	  SEARCH_BY_IMAGE_COMPLETED: function SEARCH_BY_IMAGE_COMPLETED(state, action) {
	    var bbox = action.payload.data.bboxes[0];
	    var results = action.payload.results;
	
	    return _extends({}, state, {
	      all: results,
	      attributes: action.payload.attributes,
	      detection: _extends({}, state.detection, {
	        bbox: bbox
	      }),
	      detections: state.detections.map(function (d) {
	        return d.internal_ref === state.detection.internal_ref ? _extends({}, d, {
	          bbox: bbox,
	          results: results
	        }) : d;
	      })
	    });
	  },
	
	  GET_SIMILARS_COMPLETED: function GET_SIMILARS_COMPLETED(state, action) {
	    // we slice the similars because there are more than 100
	    return _extends({}, state, {
	      similars: action.payload.results.slice(Math.max(action.payload.results.length - 120, 1))
	    });
	  },
	
	  GET_LOOK_COMPLETED: function GET_LOOK_COMPLETED(state, action) {
	    return _extends({}, state, {
	      look: action.payload.results
	    });
	  },
	
	  GET_LOOK_PRODUCTS_COMPLETED: function GET_LOOK_PRODUCTS_COMPLETED(state, action) {
	    var lookNoProducts = action.payload.lookNoProducts || [];
	    return _extends({}, state, {
	      lookProducts: action.payload.results,
	      lookNoProducts: lookNoProducts
	    });
	  },
	
	  GET_ANNOTATION_FROM_STYLE_ADVISOR_COMPLETED: function GET_ANNOTATION_FROM_STYLE_ADVISOR_COMPLETED(state, action) {
	    console.log('GET_ANNOTATION_FROM_STYLE_ADVISOR_COMPLETED!', action);
	    var results = action.payload.results;
	
	    // Use it if you need to test the SA results
	    // const mockedResults = results.length ? results : mockStyleAdvisorResults.results;
	
	    return _extends({}, state, {
	      styleAdvisorResults: results,
	      modalStyleAdvisorWasOpened: true
	    });
	  },
	
	  GET_ANNOTATION_FROM_STYLE_ADVISOR_FAILED: function GET_ANNOTATION_FROM_STYLE_ADVISOR_FAILED(state, action) {
	    return _extends({}, state, {
	      styleAdvisorResults: [],
	      modalStyleAdvisorWasOpened: false
	    });
	  },
	
	  GET_TWINNED_LOOKS_COMPLETED: function GET_TWINNED_LOOKS_COMPLETED(state, action) {
	    console.log('GET_TWINNED_LOOKS_COMPLETED!', action);
	    var result = action.payload.result;
	
	    return _extends({}, state, {
	      twinnedLooksResults: result
	    });
	  },
	
	  GET_TWINNED_LOOKS_FAILED: function GET_TWINNED_LOOKS_FAILED(state, action) {
	    console.log('GET_TWINNED_LOOKS_FAILED!', action);
	    return _extends({}, state, {
	      twinnedLooksResults: []
	    });
	  },
	
	  GET_TEXT_SEARCH_COMPLETED: function GET_TEXT_SEARCH_COMPLETED(state, action) {
	    console.log('GET_TEXT_SEARCH_COMPLETED!', action);
	    var results = action.payload.results;
	
	    return _extends({}, state, {
	      textSearchResults: results
	    });
	  },
	
	  GET_TEXT_SEARCH_FAILED: function GET_TEXT_SEARCH_FAILED(state, action) {
	    console.log('GET_TEXT_SEARCH_FAILED!', action);
	    return _extends({}, state, {
	      textSearchResults: []
	    });
	  },
	
	  TEXT_SEARCH_RESET_RESULTS: function TEXT_SEARCH_RESET_RESULTS(state, action) {
	    console.log('TEXT_SEARCH_RESET_RESULTS!', action);
	    return _extends({}, state, {
	      textSearchResults: []
	    });
	  },
	
	  REMOVE_DETECTION: function REMOVE_DETECTION(state, action) {
	    var newDetections = state.detections.filter(function (item) {
	      return action.payload.data.detection !== item;
	    });
	
	    return _extends({}, state, {
	      detections: newDetections,
	      detection: Object.assign({}, newDetections[0] || '')
	    });
	  },
	
	  UPDATE_BBOX_DETECTION: function UPDATE_BBOX_DETECTION(state, action) {
	    console.log('UPDATE_BBOX_DETECTION: ', action);
	    var bbox = action.payload.bbox;
	    var detection = state.detection,
	        detections = state.detections;
	
	    return _extends({}, state, {
	      detection: _extends({}, detection, {
	        bbox: bbox
	      }),
	      detections: detections.map(function (d) {
	        return d.internal_ref === detection.internal_ref ? _extends({}, d, {
	          bbox: bbox
	        }) : d;
	      })
	    });
	  },
	
	  SELECT_PRODUCT: function SELECT_PRODUCT(state, action) {
	    var selectedProduct = action.payload.selectedProduct;
	    var uid = selectedProduct.uid,
	        category = selectedProduct.category;
	
	
	    var newDetection = {
	      perfectMatch: uid,
	      label: category.name + ' (' + uid + ')'
	    };
	
	    return _extends({}, state, {
	      selected: selectedProduct,
	      detections: state.detections.map(function (d) {
	        return state.detection.internal_ref === d.internal_ref ? _extends({}, d, newDetection) : d;
	      }),
	      detection: _extends({}, state.detection, newDetection)
	    });
	  },
	
	  SELECT_LOOK: function SELECT_LOOK(state, action) {
	    var _action$payload2 = action.payload,
	        annotationType = _action$payload2.annotationType,
	        lookProducts = _action$payload2.lookProducts,
	        lookNoProducts = _action$payload2.lookNoProducts;
	    var searchedProduct = state.searchedProduct;
	
	    lookNoProducts = lookNoProducts || [];
	    var noProductDetections = [];
	
	    if (_constants.TWINNED_LOOK_TYPE === annotationType) {
	      var twinnedLook = lookProducts; // add context
	
	      // 1. Find the product uid of the twinned look and remove it
	      lookProducts = twinnedLook.products.filter(function (prd) {
	        return prd.uid !== twinnedLook.uid;
	      });
	
	      // 3. Add the main look's product to the annotation
	      lookProducts.unshift(searchedProduct);
	    } else if (_constants.STYLE_ADVISOR_TYPE === annotationType) {
	      // Add the main look's product to the annotation
	      lookProducts.unshift(searchedProduct);
	    }
	
	    var firstPositionInternalRef = (0, _utils.generateUniqueId)();
	    var createDetection = function createDetection(product, isFirst) {
	      var internalRef = isFirst ? firstPositionInternalRef : (0, _utils.generateUniqueId)();
	      return {
	        internal_ref: internalRef,
	        label: product.uid,
	        perfectMatch: product.uid,
	        bbox: product.images[0].bbox
	      };
	    };
	    // Add NO Annotations to the selected detections list
	    if (_constants.LOOK_ANNOTATED_TYPE === annotationType) {
	      noProductDetections = lookNoProducts.map(function (product) {
	        return {
	          internal_ref: (0, _utils.generateUniqueId)(),
	          label: product.noCategory,
	          perfectMatch: _constants.NEW_DETECTION_STR,
	          bbox: {}
	        };
	      });
	    }
	
	    return _extends({}, state, {
	      selected: lookProducts[0],
	      detections: [].concat(_toConsumableArray(lookProducts.map(function (product, i) {
	        return createDetection(product, i === 0);
	      })), _toConsumableArray(noProductDetections)),
	      detection: createDetection(lookProducts[0], true)
	    });
	  },
	
	  SET_PERFECT_MATCH: function SET_PERFECT_MATCH(state, action) {
	    var detections = state.detections,
	        detection = state.detection;
	    var perfectMatch = action.payload.data.perfectMatch;
	
	    var createDetection = function createDetection(detection, perfectMatch) {
	      return _extends({}, detection, {
	        perfectMatch: perfectMatch,
	        label: perfectMatch
	      });
	    };
	
	    return _extends({}, state, {
	      detections: detections.map(function (d) {
	        return d.internal_ref === detection.internal_ref ? createDetection(d, perfectMatch) : d;
	      }),
	      detection: createDetection(detection, perfectMatch)
	    });
	  },
	
	  GET_ANNOTATIONS_FINAL_LOOK_PRODUCTS_COMPLETED: function GET_ANNOTATIONS_FINAL_LOOK_PRODUCTS_COMPLETED(state, action) {
	    return _extends({}, state, {
	      lookProducts: action.payload.result
	    });
	  },
	
	  GET_ANNOTATIONS_FINAL_LOOK_PRODUCTS_FAILED: function GET_ANNOTATIONS_FINAL_LOOK_PRODUCTS_FAILED(state, action) {
	    console.log('GET_ANNOTATIONS_FINAL_LOOK_PRODUCTS_FAILED!', action);
	    return _extends({}, state, {
	      lookProducts: []
	    });
	  },
	
	  SET_ANNOTATION_RECOMMEND_TYPE: function SET_ANNOTATION_RECOMMEND_TYPE(state, action) {
	    var detections = state.detections;
	    var data = action.payload.data;
	
	    return _extends({}, state, {
	      detections: detections.map(function (detection) {
	        var perfectMatch = detection.perfectMatch,
	            internalRef = detection.internal_ref;
	
	        if (perfectMatch in data) {
	          return _extends({}, detection, {
	            recommend_type: data[perfectMatch]
	          });
	        } else if (internalRef in data) {
	          return _extends({}, detection, {
	            recommend_type: data[internalRef]
	          });
	        } else {
	          return detection;
	        }
	      })
	    });
	  },
	
	  SET_NO_CATEGORY_RECOMMEND_TYPE: function SET_NO_CATEGORY_RECOMMEND_TYPE(state, action) {
	    return _extends({}, state, {
	      detections: state.detections.map(function (detection) {
	        if (detection.perfectMatch in action.payload.data && detection.recommend_type === _constants.RECOMMENDATION_TYPES.NO.value) {
	          return _extends({}, detection, {
	            no_category: action.payload.data[detection.perfectMatch]
	          });
	        } else if (detection.internal_ref in action.payload.data && detection.recommend_type === _constants.RECOMMENDATION_TYPES.NO.value) {
	          return _extends({}, detection, {
	            no_category: action.payload.data[detection.internal_ref]
	          });
	        } else {
	          var no_category = detection.no_category,
	              restOfDetection = _objectWithoutProperties(detection, ['no_category']);
	
	          return restOfDetection;
	        }
	      })
	    });
	  }
	
	}, defaultState);

/***/ })
]);


// WEBPACK FOOTER //
// app.e7493c5ea0f5fd9ec8a7.js